
export const content = {
  data: [
    {
      values: [
        [
          'Name of the transcriptome annotation',
          'CAN-NAV1.1'
        ],
        [
          'Date of the annotation',
          '2019-07-10'
        ],
        [
          'Number of input transcripts',
          '30074'
        ],
        [
          'Number of annotated sequences',
          '18560'
        ],
        [
          'Number of sequences coding for enzymes',
          '4542'
        ],
        [
          'Number of identified enzymes',
          '1020'
        ],
        [
          'Number of pathways with annotated enzymes',
          '157'
        ]
      ]
    }
  ],
  layout: {
    title: 'Overview of CAN-NAV1.1 annotations'
  }
};

export const pie = {
  data: [
    {
      // domain: {
      //     column: 0,
      //     row: 0
      // },
      hoverinfo: 'label+percent',
      labels: [
        'Interpro-noBlast',
        'Interpro-Blasted',
        'Blasted-Mapped',
        'Interpro-Blasted-Mapped',
        'Blasted-Mapped-Annotated',
        'Interpro-Blasted-Mapped-Annotated',
        'noBlast',
      ],
      // marker: {
      // colors: [
      //     '#0b7285',
      //     '#d9480f',
      //     '#5c940d',
      //     '#c92a2a',
      //     '#862e9c',
      //     '#a61e4d',
      //     '#954d00'
      // ]
      // },
      textinfo: 'none',
      type: 'pie',
      values: ['9589', '108', '2', '1808', '1', '18560', '6'],
    },
  ],
  layout: {
    //autosize: false,
    //showlegend: true,
    title: 'Schematic overview of CAN-NAV1.1 annotations',
  },
};

export const treemap = {
  data: [
    {
      marker: {
        cmax: 100,
        cmin: 0,
        colorbar: {
          thickness: 20,
          ticklen: 4,
          title: {
            side: 'right',
            text: 'Average % of annotated enzymes',
          },
        },
        colorscale: [
          ['0.0', 'rgb(227,250,252)'],
          ['1.0', 'rgb(11,114,133)'],
        ],
        opacity: 0,
        showscale: true,
      },
      type: 'scatter',
      x: [0],
      y: [0],
    },
    {
      fill: 'toself',
      fillcolor: 'rgb(181,221,227)',
      hoverinfo: 'text',
      hoveron: 'points+fills',
      line: {
        color: 'black',
        width: '1',
      },
      marker: {
        opacity: 0,
      },
      text: 'Metabolism of terpenoids and polyketides | 21.37%',
      type: 'treemap_tile',
      x: [0, 0, 21, 21, 0],
      y: [0, 15, 15, 0, 0],
    },
    {
      fill: 'toself',
      fillcolor: 'rgb(186,224,230)',
      hoverinfo: 'text',
      hoveron: 'points+fills',
      line: {
        color: 'black',
        width: '1',
      },
      marker: {
        opacity: 0,
      },
      text: 'Energy Metabolism | 18.89%',
      type: 'treemap_tile',
      x: [0, 0, 21, 21, 0],
      y: [15, 31, 31, 15, 15],
    },
    {
      fill: 'toself',
      fillcolor: 'rgb(211,240,243)',
      hoverinfo: 'text',
      hoveron: 'points+fills',
      line: {
        color: 'black',
        width: '1',
      },
      marker: {
        opacity: 0,
      },
      text: 'Environmental response | 7.48%',
      type: 'treemap_tile',
      x: [0, 0, 21, 21, 0],
      y: [31, 58, 58, 31, 31],
    },
    {
      fill: 'toself',
      fillcolor: 'rgb(154,204,212)',
      hoverinfo: 'text',
      hoveron: 'points+fills',
      line: {
        color: 'black',
        width: '1',
      },
      marker: {
        opacity: 0,
      },
      text: 'Amino acids metabolism | 33.85%',
      type: 'treemap_tile',
      x: [0, 0, 21, 21, 0],
      y: [58, 100, 100, 58, 58],
    },
    {
      fill: 'toself',
      fillcolor: 'rgb(180,220,226)',
      hoverinfo: 'text',
      hoveron: 'points+fills',
      line: {
        color: 'black',
        width: '1',
      },
      marker: {
        opacity: 0,
      },
      text: 'Lipid metabolism | 21.94%',
      type: 'treemap_tile',
      x: [21, 21, 59, 59, 21],
      y: [0, 25, 25, 0, 0],
    },
    {
      fill: 'toself',
      fillcolor: 'rgb(167,212,219)',
      hoverinfo: 'text',
      hoveron: 'points+fills',
      line: {
        color: 'black',
        width: '1',
      },
      marker: {
        opacity: 0,
      },
      text: 'Carbohydrates amd Glycan biosynthesis and metabolism | 27.67%',
      type: 'treemap_tile',
      x: [59, 59, 100, 100, 59],
      y: [0, 25, 25, 0, 0],
    },
    {
      fill: 'toself',
      fillcolor: 'rgb(217,244,247)',
      hoverinfo: 'text',
      hoveron: 'points+fills',
      line: {
        color: 'black',
        width: '1',
      },
      marker: {
        opacity: 0,
      },
      text: 'Genetic Information and nucleotide metabolism | 4.43%',
      type: 'treemap_tile',
      x: [21, 21, 55, 55, 21],
      y: [25, 61, 61, 25, 25],
    },
    {
      fill: 'toself',
      fillcolor: 'rgb(190,226,231)',
      hoverinfo: 'text',
      hoveron: 'points+fills',
      line: {
        color: 'black',
        width: '1',
      },
      marker: {
        opacity: 0,
      },
      text: 'Biosynthesis of other secondary metabolites | 17.29%',
      type: 'treemap_tile',
      x: [21, 21, 55, 55, 21],
      y: [61, 100, 100, 61, 61],
    },
    {
      fill: 'toself',
      fillcolor: 'rgb(189,226,231)',
      hoverinfo: 'text',
      hoveron: 'points+fills',
      line: {
        color: 'black',
        width: '1',
      },
      marker: {
        opacity: 0,
      },
      text: 'Others | 17.67%',
      type: 'treemap_tile',
      x: [55, 55, 100, 100, 55],
      y: [25, 100, 100, 25, 25],
    },
  ],
  layout: {
    hovermode: 'closest',
    showlegend: false,
    title: 'Categories of Plant Pathways',
    xaxis: {
      autotick: true,
      showgrid: false,
      showline: false,
      showticklabels: false,
      ticks: '',
      zeroline: false,
    },
    yaxis: {
      autotick: true,
      showgrid: false,
      showline: false,
      showticklabels: false,
      ticks: '',
      zeroline: false,
    },
  },
};
export const treemap2 = {
  data: [
    {
      type: 'treemap',
      labels: [
        'all',
        'Metabolism of terpenoids and polyketides',
        'Energy Metabolism',
        'Environmental response',
        'Amino acids metabolism',
        'Lipid metabolism',
        'Carbohydrates amd Glycan biosynthesis and metabolism',
        'Genetic Information and nucleotide metabolism',
        'Biosynthesis of other secondary metabolites',
        'Others',
      ],
      parents: ['', 'all', 'all', 'all', 'all', 'all', 'all', 'all', 'all'],
      values: [10, 30, 34, 67, 89, 27, 43, 29, 67],
      text: '',
      textinfo: 'text',
      customdata: [
        'all',
        'Metabolism of terpenoids and polyketides | 21.37%',
        'Energy Metabolism | 18.89%',
        'Environmental response | 7.48%',
        'Amino acids metabolism | 33.85%',
        'Lipid metabolism | 21.94%',
        'Carbohydrates amd Glycan biosynthesis and metabolism | 27%',
        'Genetic Information and nucleotide metabolism | 4.43%',
        'Biosynthesis of other secondary metabolites | 17.29%',
        'Others | 17.67%',
      ],
      hovertemplate: '%{customdata}' + '<extra></extra>',
      marker: {
        colorbar: {
          title: {
            side: 'right',
            text: 'Average % of annotated enzymes',
          },
        },
        cmin: 0,
        cmax: 100,
        showscale: true,
        colors: [
          'transparent',
          21.37,
          18.89,
          7.48,
          33.85,
          21.94,
          27,
          4.43,
          17.29,
          17.67,
        ],
      },
    },
  ],
  layout: {
    showlegend: false,
    title: 'Categories of Plant Pathways',
  },
};
export const imgSelect = {
  data: [
    {
      name: 'plot5',
      values: [
        'data:image/png;base64, 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',
      ],
    },
  ],
  layout: {
    title: '',
  },
};

export const table = {
  data: [
    {
      cells: [
        [
          'hmmer3-match',
          'GENE3D 4.2.0',
          'G3DSA:3.30.43.10',
          '',
          '',
          'HOMOLOGOUS_SUPERFAMILY',
          '1.3E-198',
          '43',
          '504',
          '1',
        ],
        [
          'hmmer3-match',
          'GENE3D 4.2.0',
          'G3DSA:3.30.465.10',
          '',
          '',
          'HOMOLOGOUS_SUPERFAMILY',
          '1.3E-198',
          '105',
          '225',
          '1',
        ],
        [
          'hmmer3-match',
          'GENE3D 4.2.0',
          'G3DSA:3.40.462.10',
          '',
          '',
          'HOMOLOGOUS_SUPERFAMILY',
          '1.3E-198',
          '227',
          '464',
          '1',
        ],
        [
          'hmmer3-match',
          'PFAM 32.0',
          'PF01565',
          'FAD_binding_4',
          'FAD binding domain',
          'DOMAIN',
          '2.2E-26',
          '55',
          '192',
          '1',
        ],
      ],
      headers: [
        'Method',
        'Database',
        'Signature ID',
        'Signature Name',
        'Signature Description',
        'Type',
        'E-Value',
        'START',
        'END',
        'Number of Fragments',
      ],
    },
  ],
  layout: {
    title: 'Protein domains of PK08943.1',
  },
};

export const sequence = {
  data: [
    {
      values: [
        [
          '>PRO08943.1',
          'MIAYLERFVHENDAESNQDDDVSTISNALELKSTIDAAAAVSASKDFGGIYSVEPLAFLKPSSTEDVARLIRAASSSPNLTVAARGNGHSINGQAMADRGIVLDMRSLATGSIHVGSAYADVSGGALWEEVLKRCLEFGLAPRSWTDYLSLTVGGTLSNGGVSGQAFRYGPQTSNVTELEVVNGKGETLICSESENPDLFFGSLGGLGQFGIITRARILLQPAPDMVRWIRLVYTEFEDFTRDAEFLVTRSENDSFDYVEGFVFSNNDNPLTGRPTVPLHPTQEFDPNLLPRCTGSVLYCLELALHYNNTDHPSTVDTAVTRQLARLGFVERLEFQVDLSYMEFLLRVKRAEEDAKANGMWDAPHPWLNLFVSKSDVAEFDRVVFKNLLKEGVGGPMLIYPLLRSKWDNRTSTVLPDGEIFYLVALLRFSPAYPKGPSVDKLIDQNKDIVNYCFAKGFDFKLYLPHYRTEKEWKRHFGNQWSRFVQRKLNFDPKAILAPGQKIFSRRINNIPQ',
        ],
      ],
    },
  ],
  layout: {
    margin: {
      b: 0,
      l: 0,
      r: 0,
      t: 0,
    },
    title: 'Protein Sequence of PRO08943.1',
  },
};

export const sequence2 = {
  data: [
    {
      values: [
        [
          '>PRO08943.1_haplo1',
          '........LFGSKSKMIAYLERFVHENDAESNQD..........................DFGGIYSVEPLAFLKPSSTEDVARLIRAASSSPNLTVAARGNGHSINGQAMADRGIVLDMRSLATGSIHVGSAYADVSGGALWEEVLKRCLEFGLAPRSWTDYLSLTVGGTLSNGGVSGQAFRYGPQTSNVTELEVVNGKGETLICSESENPDLFFGSLGGLGQFGIITR.RILLQPAPDMVRWIRLVYTEFEDFTRDAEFLVTRSENDSFDYVEGFVFSNNDNPLTGRPTVPLHPTQEFDPNLLPRCTGSVLYCLELALHYNNTDHPSTVDTAVTRQLARLGFVERLEFQVDLSYMEFLLRVKRAEED.....................DVAEF...VFKNLLKEGVGGPMLIYPLLRSKWD...........................GPSVDKLIDQ..........................EWKR..........................KIFSRRINNIPQ',
        ],
        [
          '>PRO08943.1_haplo2',
          '........LFGSKSKMIAYLERFVHENDAESNQD..........................DFGGIYSVEPLAFLKPSSTEDVARLIRAASSSPNLTVAARGNGHSINGQAMADRGIVLDMRSLATGSIHVGSAYADVSGGALWEEVLKRCLEFGLAPRSWTDYLSLTVGGTLSNGGVSGQAFRYGPQTSNVTELEVVNGKGETLICSESENPDLFFGSLGGLGQFGIITR.RILLQPAPDMVRWIRLVYTEFEDFTRDAEFLVTRSENDSFDYVEGFVFSNNDNPLTGRPTVPLHPTQEFDPNLLPRCTGSVLYCLELALHYNNTDHPSTVDTAVTRQLARLGFVERLEFQVDLSYMEFLLRVKRAEED.....................DVAEF...VFKNLLKEGVGGPMLIYPLLRSKWD...........................GPSVDKLIDQ..........................EWKR..........................KIFSRRINNIPQ',
        ],
      ],
    },
  ],
  layout: {
    title: 'Protein sequences of SRR3996358/PRO08943.1 (2 sequences)',
  },
};

export const select = {
  data: [
    {
      values: ['SRR3996358', 'SRR5210004', 'SRR3996359', 'SRR3996360'],
    },
  ],
  layout: {
    title: '',
  },
};

export const select2 = {
  data: [
    {
      titleSelect: 'Select polarity:',
      values: ['positive', 'negative'],
    },
  ],
  layout: {
    title: '',
  },
};

export const imgSelectColorscale = {
  data: [
    {
      hoverinfo: 'none',
      marker: {
        cmax: 100,
        cmin: 0,
        color: [],
        colorbar: {
          len: 200,
          lenmode: 'pixels',
          thickness: 20,
          title: {
            side: 'right',
            text: 'Maximum % of mutations in annotated enzyme sequences',
          },
        },
        colorscale: [
          [0, '#e3fafc'],
          [1, '#0b7285'],
        ],
        size: 1,
      },
      mode: 'markers',
      name: 'plot5_SRR3996358_map00908',
      values: [
        'data:image/png;base64, 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',
      ],
      x: [0, 1],
      y: [0, 1],
    },
  ],
  layout: {
    margin: {
      b: 0,
      l: 0,
      t: 0,
    },
    title: '',
    xaxis: {
      autotick: true,
      showgrid: false,
      showline: false,
      showticklabels: false,
      ticks: '',
      zeroline: false,
    },
    yaxis: {
      autotick: true,
      showgrid: false,
      showline: false,
      showticklabels: false,
      ticks: '',
      zeroline: false,
    },
  },
};
export const imgSelectColorscale2 = {
  data: [
    {
      hoverinfo: 'none',
      marker: {
        cmax: 100,
        cmin: 0,
        colorbar: {
          title: {
            side: 'right',
            text: 'Maximum % of mutations in annotated enzyme sequences',
          },
        },
        size: 0.1,
      },
      mode: 'markers',
      x: [1, 1],
      y: [0, 1],
    },
  ],
  layout: {
    showlegend: false,
    title: 'test img+colorscale',
    xaxis: {
      showgrid: false,
      showticklabels: false,
      zeroline: false,
    },
    yaxis: {
      showgrid: false,
      showticklabels: false,
      zeroline: false,
    },
  },
  images: [
    'data:image/png;base64, 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',
  ],
  titleSelect: 'Select an annotated (colored) enzyme',
  interactions: [
    {
      title: 'option a',
      traceNumber: 0,
      pointNumber: 0,
      children: ['viz1, viz2, viz3'],
    },
    {
      title: 'option b',
      traceNumber: 0,
      pointNumber: 1,
      children: ['viz4, viz5, viz6'],
    },
    {
      title: '',
      traceNumber: 1,
      pointNumber: 0,
      children: ['viz7, viz8, viz9'],
    },
    {
      title: 'option d',
      traceNumber: 1,
      pointNumber: 1,
      children: ['viz10, viz11, viz12'],
    },
  ],
};
export const imgSelect2 = {
  data: [],
  layout: {
    title: 'test image+select',
  },
  images: [
    'data:image/png;base64, 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',
  ],
  titleSelect: 'Select an annotated (colored) enzyme',
  interactions: [
    {
      title: 'option a',
      children: ['viz1, viz2, viz3'],
    },
    {
      title: 'option b',
      children: ['viz4, viz5, viz6'],
    },
    {
      title: '',
      children: ['viz7, viz8, viz9'],
    },
    {
      title: 'option d',
      children: ['viz10, viz11, viz12'],
    },
  ],
};

export const bar = {
  data: [
    {
      name: 'cluster1',
      type: 'bar',
      x: [
        'ind01',
        'ind02',
        'ind03',
        'ind04',
        'ind05',
        'ind06',
        'ind07',
        'ind08',
        'ind09',
        'ind10',
        'ind11',
        'ind12',
        'ind13',
        'ind14',
        'ind15',
        'ind16',
        'ind17',
        'ind18',
        'ind19',
        'ind20',
        'ind21',
        'ind22',
        'ind23',
        'ind24',
        'ind25',
        'ind26',
        'ind27',
        'ind28',
        'ind29',
        'ind30',
      ],
      y: [
        '0.701',
        '0.686',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '1',
        '1',
        '1',
        '1',
        '1',
        '1',
        '1',
        '1',
      ],
    },
    {
      name: 'cluster2',
      type: 'bar',
      x: [
        'ind01',
        'ind02',
        'ind03',
        'ind04',
        'ind05',
        'ind06',
        'ind07',
        'ind08',
        'ind09',
        'ind10',
        'ind11',
        'ind12',
        'ind13',
        'ind14',
        'ind15',
        'ind16',
        'ind17',
        'ind18',
        'ind19',
        'ind20',
        'ind21',
        'ind22',
        'ind23',
        'ind24',
        'ind25',
        'ind26',
        'ind27',
        'ind28',
        'ind29',
        'ind30',
      ],
      y: [
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0.999',
        '0.999',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
      ],
    },
    {
      name: 'cluster3',
      type: 'bar',
      x: [
        'ind01',
        'ind02',
        'ind03',
        'ind04',
        'ind05',
        'ind06',
        'ind07',
        'ind08',
        'ind09',
        'ind10',
        'ind11',
        'ind12',
        'ind13',
        'ind14',
        'ind15',
        'ind16',
        'ind17',
        'ind18',
        'ind19',
        'ind20',
        'ind21',
        'ind22',
        'ind23',
        'ind24',
        'ind25',
        'ind26',
        'ind27',
        'ind28',
        'ind29',
        'ind30',
      ],
      y: [
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
      ],
    },
    {
      name: 'cluster4',
      type: 'bar',
      x: [
        'ind01',
        'ind02',
        'ind03',
        'ind04',
        'ind05',
        'ind06',
        'ind07',
        'ind08',
        'ind09',
        'ind10',
        'ind11',
        'ind12',
        'ind13',
        'ind14',
        'ind15',
        'ind16',
        'ind17',
        'ind18',
        'ind19',
        'ind20',
        'ind21',
        'ind22',
        'ind23',
        'ind24',
        'ind25',
        'ind26',
        'ind27',
        'ind28',
        'ind29',
        'ind30',
      ],
      y: [
        '0.299',
        '0.313',
        '1',
        '1',
        '1',
        '1',
        '1',
        '1',
        '1',
        '1',
        '0.387',
        '0.372',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
      ],
    },
    {
      name: 'cluster5',
      type: 'bar',
      x: [
        'ind01',
        'ind02',
        'ind03',
        'ind04',
        'ind05',
        'ind06',
        'ind07',
        'ind08',
        'ind09',
        'ind10',
        'ind11',
        'ind12',
        'ind13',
        'ind14',
        'ind15',
        'ind16',
        'ind17',
        'ind18',
        'ind19',
        'ind20',
        'ind21',
        'ind22',
        'ind23',
        'ind24',
        'ind25',
        'ind26',
        'ind27',
        'ind28',
        'ind29',
        'ind30',
      ],
      y: [
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
      ],
    },
    {
      name: 'cluster6',
      type: 'bar',
      x: [
        'ind01',
        'ind02',
        'ind03',
        'ind04',
        'ind05',
        'ind06',
        'ind07',
        'ind08',
        'ind09',
        'ind10',
        'ind11',
        'ind12',
        'ind13',
        'ind14',
        'ind15',
        'ind16',
        'ind17',
        'ind18',
        'ind19',
        'ind20',
        'ind21',
        'ind22',
        'ind23',
        'ind24',
        'ind25',
        'ind26',
        'ind27',
        'ind28',
        'ind29',
        'ind30',
      ],
      y: [
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0.613',
        '0.627',
        '1',
        '1',
        '1',
        '1',
        '1',
        '1',
        '1',
        '1',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
        '0',
      ],
    },
  ],
  layout: {
    barmode: 'stack',
    // margin: {
    //     b: 150,
    //     l: 50,
    //     r: 30,
    //     t: 50
    // },
    title: 'GBS clustering',
    xaxis: {
      title: 'Strains',
    },
    yaxis: {
      title: 'Genome ancestry proportion',
    },
  },
};

export const tree = {
  data: [
    {
      error_x: {
        color: 'rgba(31,119,180,1)',
      },
      error_y: {
        color: 'rgba(31,119,180,1)',
      },
      frame: null,
      hoverinfo: [
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
      ],
      line: {
        color: '#202020',
        width: 0.75,
      },
      marker: {
        color: 'rgba(31,119,180,1)',
        line: {
          color: 'rgba(31,119,180,1)',
        },
      },
      mode: 'lines',
      type: 'scatter',
      x: [
        754.979567856817,
        905.828395981817,
        null,
        754.979567856817,
        911.130739731816,
        null,
        706.402224775144,
        729.907394811908,
        null,
        702.75971175431,
        733.617198733477,
        null,
        702.480938037792,
        732.202164321274,
        null,
        698.446272416548,
        726.358290238814,
        null,
        706.402224775144,
        733.897054738379,
        null,
        696.276123046875,
        734.512223677202,
        null,
        703.337571150773,
        732.529465682023,
        null,
        703.337571150773,
        733.145676619523,
        null,
        299.9423828125,
        401.868923611111,
        null,
        299.9423828125,
        378.015842013889,
        null,
        6.3348388671875,
        64.2885916573661,
        null,
        7.78380533854167,
        78.034619140625,
        null,
        2.046875,
        67.0430501302083,
        null,
        6.3348388671875,
        63.3810860770089,
        null,
        2.19378662109375,
        66.052734375,
        null,
        7.78380533854167,
        66.5329915364583,
        null,
        4.30069986979167,
        80.8175944010417,
        null,
        0,
        71.0562133789062,
        null,
        748.969265407986,
        921.076408265129,
        null,
        748.969265407986,
        932.862122550843,
        null,
        851.614109919683,
        961.715961771535,
        null,
        841.419803899616,
        959.97969973295,
        null,
        835.389518514711,
        960.266378633759,
        null,
        841.419803899616,
        966.859908066283,
        null,
        851.614109919683,
        960.512258067831,
        null,
        849.580456073529,
        958.046802227376,
        null,
        838.731408395664,
        959.663936804755,
        null,
        844.052956073529,
        964.275456073529,
        null,
        0,
        0.67633056640625,
        null,
        0.67633056640625,
        2.046875,
        null,
        0,
        2.19378662109375,
        null,
        2.046875,
        4.30069986979167,
        null,
        4.30069986979167,
        7.78380533854167,
        null,
        2.19378662109375,
        6.3348388671875,
        null,
        0.67633056640625,
        220.772827148438,
        null,
        220.772827148438,
        299.9423828125,
        null,
        220.772827148438,
        305.713348388672,
        null,
        305.713348388672,
        696.276123046875,
        null,
        696.276123046875,
        698.446272416548,
        null,
        698.446272416548,
        701.909254594283,
        null,
        701.909254594283,
        702.480938037792,
        null,
        702.480938037792,
        702.75971175431,
        null,
        701.909254594283,
        703.337571150773,
        null,
        702.75971175431,
        706.402224775144,
        null,
        305.713348388672,
        548.442138671875,
        null,
        548.442138671875,
        663.797824435764,
        null,
        663.797824435764,
        754.979567856817,
        null,
        663.797824435764,
        835.389518514711,
        null,
        835.389518514711,
        838.731408395664,
        null,
        838.731408395664,
        839.830129986573,
        null,
        839.830129986573,
        841.419803899616,
        null,
        839.830129986573,
        844.052956073529,
        null,
        844.052956073529,
        849.580456073529,
        null,
        849.580456073529,
        851.614109919683,
        null,
        548.442138671875,
        748.969265407986,
      ],
      xaxis: 'x',
      y: [
        19,
        19,
        null,
        20,
        20,
        null,
        11,
        11,
        null,
        13,
        13,
        null,
        14,
        14,
        null,
        17,
        17,
        null,
        12,
        12,
        null,
        18,
        18,
        null,
        15,
        15,
        null,
        16,
        16,
        null,
        9,
        9,
        null,
        10,
        10,
        null,
        2,
        2,
        null,
        5,
        5,
        null,
        8,
        8,
        null,
        3,
        3,
        null,
        4,
        4,
        null,
        6,
        6,
        null,
        7,
        7,
        null,
        1,
        1,
        null,
        29,
        29,
        null,
        30,
        30,
        null,
        23,
        23,
        null,
        21,
        21,
        null,
        28,
        28,
        null,
        22,
        22,
        null,
        24,
        24,
        null,
        25,
        25,
        null,
        27,
        27,
        null,
        26,
        26,
        null,
        11.32470703125,
        11.32470703125,
        null,
        7.125,
        7.125,
        null,
        3.25,
        3.25,
        null,
        6.25,
        6.25,
        null,
        5.5,
        5.5,
        null,
        2.5,
        2.5,
        null,
        15.5244140625,
        15.5244140625,
        null,
        9.5,
        9.5,
        null,
        21.548828125,
        21.548828125,
        null,
        16.828125,
        16.828125,
        null,
        15.65625,
        15.65625,
        null,
        14.3125,
        14.3125,
        null,
        13.125,
        13.125,
        null,
        12.25,
        12.25,
        null,
        15.5,
        15.5,
        null,
        11.5,
        11.5,
        null,
        26.26953125,
        26.26953125,
        null,
        23.0390625,
        23.0390625,
        null,
        19.5,
        19.5,
        null,
        26.578125,
        26.578125,
        null,
        25.15625,
        25.15625,
        null,
        23.3125,
        23.3125,
        null,
        21.5,
        21.5,
        null,
        25.125,
        25.125,
        null,
        24.25,
        24.25,
        null,
        23.5,
        23.5,
        null,
        29.5,
        29.5,
      ],
      yaxis: 'y',
    },
    {
      error_x: {
        color: 'rgba(255,127,14,1)',
      },
      error_y: {
        color: 'rgba(255,127,14,1)',
      },
      frame: null,
      hoverinfo: [
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
        null,
        'skip',
        'skip',
      ],
      line: {
        color: '#202020',
        width: 0.75,
      },
      marker: {
        color: 'rgba(255,127,14,1)',
        line: {
          color: 'rgba(255,127,14,1)',
        },
      },
      mode: 'lines',
      type: 'scatter',
      x: [
        754.979567856817,
        754.979567856817,
        null,
        706.402224775144,
        706.402224775144,
        null,
        702.75971175431,
        702.75971175431,
        null,
        702.480938037792,
        702.480938037792,
        null,
        698.446272416548,
        698.446272416548,
        null,
        696.276123046875,
        696.276123046875,
        null,
        703.337571150773,
        703.337571150773,
        null,
        299.9423828125,
        299.9423828125,
        null,
        6.3348388671875,
        6.3348388671875,
        null,
        7.78380533854167,
        7.78380533854167,
        null,
        2.046875,
        2.046875,
        null,
        2.19378662109375,
        2.19378662109375,
        null,
        4.30069986979167,
        4.30069986979167,
        null,
        0,
        0,
        null,
        748.969265407986,
        748.969265407986,
        null,
        851.614109919683,
        851.614109919683,
        null,
        841.419803899616,
        841.419803899616,
        null,
        835.389518514711,
        835.389518514711,
        null,
        849.580456073529,
        849.580456073529,
        null,
        838.731408395664,
        838.731408395664,
        null,
        844.052956073529,
        844.052956073529,
        null,
        0.67633056640625,
        0.67633056640625,
        null,
        220.772827148438,
        220.772827148438,
        null,
        305.713348388672,
        305.713348388672,
        null,
        701.909254594283,
        701.909254594283,
        null,
        548.442138671875,
        548.442138671875,
        null,
        663.797824435764,
        663.797824435764,
        null,
        839.830129986573,
        839.830129986573,
      ],
      xaxis: 'x',
      y: [
        19,
        20,
        null,
        11,
        12,
        null,
        11.5,
        13,
        null,
        12.25,
        14,
        null,
        14.3125,
        17,
        null,
        15.65625,
        18,
        null,
        15,
        16,
        null,
        9,
        10,
        null,
        2,
        3,
        null,
        5,
        6,
        null,
        6.25,
        8,
        null,
        2.5,
        4,
        null,
        5.5,
        7,
        null,
        1,
        11.32470703125,
        null,
        29,
        30,
        null,
        23,
        24,
        null,
        21,
        22,
        null,
        25.15625,
        28,
        null,
        23.5,
        25,
        null,
        23.3125,
        27,
        null,
        24.25,
        26,
        null,
        7.125,
        15.5244140625,
        null,
        9.5,
        21.548828125,
        null,
        16.828125,
        26.26953125,
        null,
        13.125,
        15.5,
        null,
        23.0390625,
        29.5,
        null,
        19.5,
        26.578125,
        null,
        21.5,
        25.125,
      ],
      yaxis: 'y',
    },
    {
      error_x: {
        color: 'rgba(44,160,44,1)',
      },
      error_y: {
        color: 'rgba(44,160,44,1)',
      },
      frame: null,
      hoverinfo: [
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
      ],
      line: {
        color: 'rgba(44,160,44,1)',
      },
      marker: {
        color: [
          '#660000',
          '#660000',
          '#660000',
          '#660000',
          '#660000',
          '#660000',
          '#660000',
          '#660000',
          '#660000',
          '#660000',
          '#660000',
          '#660000',
          '#660000',
          '#660000',
          '#660000',
          '#660000',
          '#660000',
          '#660000',
          '#660000',
          '#660000',
          '#660000',
          '#660000',
          '#660000',
          '#660000',
          '#660000',
          '#660000',
          '#660000',
          '#660000',
          '#660000',
          '#660000',
          '#000066',
          '#000066',
          '#000066',
          '#000066',
          '#000066',
          '#000066',
          '#000066',
          '#000066',
          '#000066',
          '#000066',
          '#000066',
          '#000066',
          '#000066',
          '#000066',
          '#000066',
          '#000066',
          '#000066',
          '#000066',
          '#000066',
          '#000066',
          '#000066',
          '#000066',
          '#000066',
          '#000066',
          '#000066',
          '#000066',
          '#000066',
        ],
        line: {
          color: 'rgba(44,160,44,1)',
        },
        //size: 5
        size: 1,
      },
      mode: 'markers',
      text: [
        'ind01',
        'ind02',
        'ind03',
        'ind04',
        'ind05',
        'ind06',
        'ind07',
        'ind08',
        'ind09',
        'ind10',
        'ind11',
        'ind12',
        'ind13',
        'ind14',
        'ind15',
        'ind16',
        'ind17',
        'ind18',
        'ind19',
        'ind20',
        'ind21',
        'ind22',
        'ind23',
        'ind24',
        'ind25',
        'ind26',
        'ind27',
        'ind28',
        'ind29',
        'ind30',
        null,
        null,
        null,
        null,
        null,
        null,
        '100',
        '100',
        '82',
        '100',
        null,
        null,
        null,
        null,
        null,
        '76',
        '99',
        '100',
        '100',
        '100',
        null,
        null,
        null,
        null,
        null,
        null,
        '100',
      ],
      type: 'scatter',
      x: [
        905.828395981817,
        911.130739731816,
        729.907394811908,
        733.617198733477,
        732.202164321274,
        726.358290238814,
        733.897054738379,
        734.512223677202,
        732.529465682023,
        733.145676619523,
        401.868923611111,
        378.015842013889,
        64.2885916573661,
        78.034619140625,
        67.0430501302083,
        63.3810860770089,
        66.052734375,
        66.5329915364583,
        80.8175944010417,
        71.0562133789062,
        921.076408265129,
        932.862122550843,
        961.715961771535,
        959.97969973295,
        960.266378633759,
        966.859908066283,
        960.512258067831,
        958.046802227376,
        959.663936804755,
        964.275456073529,
        0.67633056640625,
        2.046875,
        2.19378662109375,
        4.30069986979167,
        7.78380533854167,
        6.3348388671875,
        220.772827148438,
        299.9423828125,
        305.713348388672,
        696.276123046875,
        698.446272416548,
        701.909254594283,
        702.480938037792,
        702.75971175431,
        703.337571150773,
        706.402224775144,
        548.442138671875,
        663.797824435764,
        754.979567856817,
        835.389518514711,
        838.731408395664,
        839.830129986573,
        841.419803899616,
        844.052956073529,
        849.580456073529,
        851.614109919683,
        748.969265407986,
      ],
      xaxis: 'x',
      y: [
        19,
        20,
        11,
        13,
        14,
        17,
        12,
        18,
        15,
        16,
        9,
        10,
        2,
        5,
        8,
        3,
        4,
        6,
        7,
        1,
        29,
        30,
        23,
        21,
        28,
        22,
        24,
        25,
        27,
        26,
        11.32470703125,
        7.125,
        3.25,
        6.25,
        5.5,
        2.5,
        15.5244140625,
        9.5,
        21.548828125,
        16.828125,
        15.65625,
        14.3125,
        13.125,
        12.25,
        15.5,
        11.5,
        26.26953125,
        23.0390625,
        19.5,
        26.578125,
        25.15625,
        23.3125,
        21.5,
        25.125,
        24.25,
        23.5,
        29.5,
      ],
      yaxis: 'y',
    },
    {
      error_x: {
        color: 'rgba(214,39,40,1)',
      },
      error_y: {
        color: 'rgba(214,39,40,1)',
      },
      frame: null,
      hoverinfo: [
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
      ],
      line: {
        color: 'rgba(214,39,40,1)',
      },
      marker: {
        color: 'rgba(214,39,40,1)',
        line: {
          color: 'rgba(214,39,40,1)',
        },
      },
      mode: 'text',
      text: [
        'ind01',
        'ind02',
        'ind03',
        'ind04',
        'ind05',
        'ind06',
        'ind07',
        'ind08',
        'ind09',
        'ind10',
        'ind11',
        'ind12',
        'ind13',
        'ind14',
        'ind15',
        'ind16',
        'ind17',
        'ind18',
        'ind19',
        'ind20',
        'ind21',
        'ind22',
        'ind23',
        'ind24',
        'ind25',
        'ind26',
        'ind27',
        'ind28',
        'ind29',
        'ind30',
      ],
      type: 'scatter',
      x: [
        944.502792304468,
        949.805136054468,
        768.58179113456,
        772.291595056128,
        770.876560643926,
        765.032686561465,
        772.57145106103,
        773.186619999853,
        771.203862004674,
        771.820072942174,
        440.543319933762,
        416.69023833654,
        102.962987980017,
        116.709015463276,
        105.71744645286,
        102.05548239966,
        104.727130697651,
        105.20738785911,
        119.491990723693,
        109.730609701558,
        959.75080458778,
        971.536518873495,
        1000.39035809419,
        998.654096055601,
        998.94077495641,
        1005.53430438893,
        999.186654390483,
        996.721198550027,
        998.338333127406,
        1002.94985239618,
      ],
      xaxis: 'x',
      y: [
        19,
        20,
        11,
        13,
        14,
        17,
        12,
        18,
        15,
        16,
        9,
        10,
        2,
        5,
        8,
        3,
        4,
        6,
        7,
        1,
        29,
        30,
        23,
        21,
        28,
        22,
        24,
        25,
        27,
        26,
      ],
      yaxis: 'y',
    },
    {
      error_x: {
        color: 'rgba(148,103,189,1)',
      },
      error_y: {
        color: 'rgba(148,103,189,1)',
      },
      frame: null,
      hoverinfo: [
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
        'skip',
      ],
      line: {
        color: 'rgba(148,103,189,1)',
      },
      marker: {
        color: 'rgba(148,103,189,1)',
        line: {
          color: 'rgba(148,103,189,1)',
        },
      },
      mode: 'text',
      text: [
        null,
        null,
        null,
        null,
        null,
        null,
        '100',
        '100',
        '82',
        '100',
        null,
        null,
        null,
        null,
        null,
        '76',
        '99',
        '100',
        '100',
        '100',
        null,
        null,
        null,
        null,
        null,
        null,
        '100',
      ],
      textposition: [
        'top left',
        'top left',
        'top left',
        'top left',
        'top left',
        'top left',
        'top left',
        'top left',
        'top left',
        'top left',
        'top left',
        'top left',
        'top left',
        'top left',
        'top left',
        'top left',
        'top left',
        'top left',
        'top left',
        'top left',
        'top left',
        'top left',
        'top left',
        'top left',
        'top left',
        'top left',
        'top left',
      ],
      type: 'scatter',
      x: [
        -9.32366943359375,
        -7.953125,
        -7.80621337890625,
        -5.69930013020833,
        -2.21619466145833,
        -3.6651611328125,
        210.772827148438,
        289.9423828125,
        295.713348388672,
        686.276123046875,
        688.446272416548,
        691.909254594283,
        692.480938037792,
        692.75971175431,
        693.337571150773,
        696.402224775144,
        538.442138671875,
        653.797824435764,
        744.979567856817,
        825.389518514711,
        828.731408395664,
        829.830129986573,
        831.419803899616,
        834.052956073529,
        839.580456073529,
        841.614109919683,
        738.969265407986,
      ],
      xaxis: 'x',
      y: [
        11.32470703125,
        7.125,
        3.25,
        6.25,
        5.5,
        2.5,
        15.5244140625,
        9.5,
        21.548828125,
        16.828125,
        15.65625,
        14.3125,
        13.125,
        12.25,
        15.5,
        11.5,
        26.26953125,
        23.0390625,
        19.5,
        26.578125,
        25.15625,
        23.3125,
        21.5,
        25.125,
        24.25,
        23.5,
        29.5,
      ],
      yaxis: 'y',
    },
  ],
  layout: {
    // autosize: true,
    // font: {
    //     family: 'Balto',
    //     size: 12
    // },
    // hovermode: 'closest',
    // margin: {
    //     b: 30,
    //     l: 30,
    //     r: 30,
    //     t: 50
    // },
    // plot_bgcolor: '#f5f5f5',
    showlegend: false,
    title: 'GBS clustering --- Neighbor-joining (rooted) tree',
    xaxis: {
      // automargin: true,
      domain: [0, 1],
      showgrid: false,
      showline: false,
      showticklabels: false,
      title: '',
      zeroline: false,
    },
    yaxis: {
      // automargin: true,
      domain: [0, 1],
      showgrid: false,
      showline: false,
      showticklabels: false,
      title: '',
      zeroline: false,
    },
  },
};
export const tree2 = {
  data: [
    {
      hoverinfo: 'none',
      line: {
        color: 'black',
        width: 1,
      },
      mode: 'lines',
      type: 'scatter',
      x: [
        754.979567856817,
        905.828395981817,
        null,
        754.979567856817,
        911.130739731816,
        null,
        706.402224775144,
        729.907394811908,
        null,
        702.75971175431,
        733.617198733477,
        null,
        702.480938037792,
        732.202164321274,
        null,
        698.446272416548,
        726.358290238814,
        null,
        706.402224775144,
        733.897054738379,
        null,
        696.276123046875,
        734.512223677202,
        null,
        703.337571150773,
        732.529465682023,
        null,
        703.337571150773,
        733.145676619523,
        null,
        299.9423828125,
        401.868923611111,
        null,
        299.9423828125,
        378.015842013889,
        null,
        6.3348388671875,
        64.2885916573661,
        null,
        7.78380533854167,
        78.034619140625,
        null,
        2.046875,
        67.0430501302083,
        null,
        6.3348388671875,
        63.3810860770089,
        null,
        2.19378662109375,
        66.052734375,
        null,
        7.78380533854167,
        66.5329915364583,
        null,
        4.30069986979167,
        80.8175944010417,
        null,
        0,
        71.0562133789062,
        null,
        748.969265407986,
        921.076408265129,
        null,
        748.969265407986,
        932.862122550843,
        null,
        851.614109919683,
        961.715961771535,
        null,
        841.419803899616,
        959.97969973295,
        null,
        835.389518514711,
        960.266378633759,
        null,
        841.419803899616,
        966.859908066283,
        null,
        851.614109919683,
        960.512258067831,
        null,
        849.580456073529,
        958.046802227376,
        null,
        838.731408395664,
        959.663936804755,
        null,
        844.052956073529,
        964.275456073529,
        null,
        0,
        0.67633056640625,
        null,
        0.67633056640625,
        2.046875,
        null,
        0,
        2.19378662109375,
        null,
        2.046875,
        4.30069986979167,
        null,
        4.30069986979167,
        7.78380533854167,
        null,
        2.19378662109375,
        6.3348388671875,
        null,
        0.67633056640625,
        220.772827148438,
        null,
        220.772827148438,
        299.9423828125,
        null,
        220.772827148438,
        305.713348388672,
        null,
        305.713348388672,
        696.276123046875,
        null,
        696.276123046875,
        698.446272416548,
        null,
        698.446272416548,
        701.909254594283,
        null,
        701.909254594283,
        702.480938037792,
        null,
        702.480938037792,
        702.75971175431,
        null,
        701.909254594283,
        703.337571150773,
        null,
        702.75971175431,
        706.402224775144,
        null,
        305.713348388672,
        548.442138671875,
        null,
        548.442138671875,
        663.797824435764,
        null,
        663.797824435764,
        754.979567856817,
        null,
        663.797824435764,
        835.389518514711,
        null,
        835.389518514711,
        838.731408395664,
        null,
        838.731408395664,
        839.830129986573,
        null,
        839.830129986573,
        841.419803899616,
        null,
        839.830129986573,
        844.052956073529,
        null,
        844.052956073529,
        849.580456073529,
        null,
        849.580456073529,
        851.614109919683,
        null,
        548.442138671875,
        748.969265407986,
      ],
      y: [
        19,
        19,
        null,
        20,
        20,
        null,
        11,
        11,
        null,
        13,
        13,
        null,
        14,
        14,
        null,
        17,
        17,
        null,
        12,
        12,
        null,
        18,
        18,
        null,
        15,
        15,
        null,
        16,
        16,
        null,
        9,
        9,
        null,
        10,
        10,
        null,
        2,
        2,
        null,
        5,
        5,
        null,
        8,
        8,
        null,
        3,
        3,
        null,
        4,
        4,
        null,
        6,
        6,
        null,
        7,
        7,
        null,
        1,
        1,
        null,
        29,
        29,
        null,
        30,
        30,
        null,
        23,
        23,
        null,
        21,
        21,
        null,
        28,
        28,
        null,
        22,
        22,
        null,
        24,
        24,
        null,
        25,
        25,
        null,
        27,
        27,
        null,
        26,
        26,
        null,
        11.32470703125,
        11.32470703125,
        null,
        7.125,
        7.125,
        null,
        3.25,
        3.25,
        null,
        6.25,
        6.25,
        null,
        5.5,
        5.5,
        null,
        2.5,
        2.5,
        null,
        15.5244140625,
        15.5244140625,
        null,
        9.5,
        9.5,
        null,
        21.548828125,
        21.548828125,
        null,
        16.828125,
        16.828125,
        null,
        15.65625,
        15.65625,
        null,
        14.3125,
        14.3125,
        null,
        13.125,
        13.125,
        null,
        12.25,
        12.25,
        null,
        15.5,
        15.5,
        null,
        11.5,
        11.5,
        null,
        26.26953125,
        26.26953125,
        null,
        23.0390625,
        23.0390625,
        null,
        19.5,
        19.5,
        null,
        26.578125,
        26.578125,
        null,
        25.15625,
        25.15625,
        null,
        23.3125,
        23.3125,
        null,
        21.5,
        21.5,
        null,
        25.125,
        25.125,
        null,
        24.25,
        24.25,
        null,
        23.5,
        23.5,
        null,
        29.5,
        29.5,
      ],
    },
    {
      hoverinfo: 'none',
      line: {
        color: 'black',
        width: 1,
      },
      mode: 'lines',
      type: 'scatter',
      x: [
        754.979567856817,
        754.979567856817,
        null,
        706.402224775144,
        706.402224775144,
        null,
        702.75971175431,
        702.75971175431,
        null,
        702.480938037792,
        702.480938037792,
        null,
        698.446272416548,
        698.446272416548,
        null,
        696.276123046875,
        696.276123046875,
        null,
        703.337571150773,
        703.337571150773,
        null,
        299.9423828125,
        299.9423828125,
        null,
        6.3348388671875,
        6.3348388671875,
        null,
        7.78380533854167,
        7.78380533854167,
        null,
        2.046875,
        2.046875,
        null,
        2.19378662109375,
        2.19378662109375,
        null,
        4.30069986979167,
        4.30069986979167,
        null,
        0,
        0,
        null,
        748.969265407986,
        748.969265407986,
        null,
        851.614109919683,
        851.614109919683,
        null,
        841.419803899616,
        841.419803899616,
        null,
        835.389518514711,
        835.389518514711,
        null,
        849.580456073529,
        849.580456073529,
        null,
        838.731408395664,
        838.731408395664,
        null,
        844.052956073529,
        844.052956073529,
        null,
        0.67633056640625,
        0.67633056640625,
        null,
        220.772827148438,
        220.772827148438,
        null,
        305.713348388672,
        305.713348388672,
        null,
        701.909254594283,
        701.909254594283,
        null,
        548.442138671875,
        548.442138671875,
        null,
        663.797824435764,
        663.797824435764,
        null,
        839.830129986573,
        839.830129986573,
      ],
      y: [
        19,
        20,
        null,
        11,
        12,
        null,
        11.5,
        13,
        null,
        12.25,
        14,
        null,
        14.3125,
        17,
        null,
        15.65625,
        18,
        null,
        15,
        16,
        null,
        9,
        10,
        null,
        2,
        3,
        null,
        5,
        6,
        null,
        6.25,
        8,
        null,
        2.5,
        4,
        null,
        5.5,
        7,
        null,
        1,
        11.32470703125,
        null,
        29,
        30,
        null,
        23,
        24,
        null,
        21,
        22,
        null,
        25.15625,
        28,
        null,
        23.5,
        25,
        null,
        23.3125,
        27,
        null,
        24.25,
        26,
        null,
        7.125,
        15.5244140625,
        null,
        9.5,
        21.548828125,
        null,
        16.828125,
        26.26953125,
        null,
        13.125,
        15.5,
        null,
        23.0390625,
        29.5,
        null,
        19.5,
        26.578125,
        null,
        21.5,
        25.125,
      ],
    },
    {
      hoverinfo: 'text',
      marker: {
        color: 'rgba(0,0,0,0)',
        size: 7,
      },
      mode: 'markers+text',
      text: [
        'ind01',
        'ind02',
        'ind03',
        'ind04',
        'ind05',
        'ind06',
        'ind07',
        'ind08',
        'ind09',
        'ind10',
        'ind11',
        'ind12',
        'ind13',
        'ind14',
        'ind15',
        'ind16',
        'ind17',
        'ind18',
        'ind19',
        'ind20',
        'ind21',
        'ind22',
        'ind23',
        'ind24',
        'ind25',
        'ind26',
        'ind27',
        'ind28',
        'ind29',
        'ind30',
      ],
      textposition: 'right',
      cliponaxis: false,
      type: 'scatter',
      x: [
        905.828395981817,
        911.130739731816,
        729.907394811908,
        733.617198733477,
        732.202164321274,
        726.358290238814,
        733.897054738379,
        734.512223677202,
        732.529465682023,
        733.145676619523,
        401.868923611111,
        378.015842013889,
        64.2885916573661,
        78.034619140625,
        67.0430501302083,
        63.3810860770089,
        66.052734375,
        66.5329915364583,
        80.8175944010417,
        71.0562133789062,
        921.076408265129,
        932.862122550843,
        961.715961771535,
        959.97969973295,
        960.266378633759,
        966.859908066283,
        960.512258067831,
        958.046802227376,
        959.663936804755,
        964.275456073529,
      ],
      y: [
        19,
        20,
        11,
        13,
        14,
        17,
        12,
        18,
        15,
        16,
        9,
        10,
        2,
        5,
        8,
        3,
        4,
        6,
        7,
        1,
        29,
        30,
        23,
        21,
        28,
        22,
        24,
        25,
        27,
        26,
        11.32470703125,
      ],
    },
    {
      hoverinfo: 'text',
      marker: {
        color: 'rgba(0,0,0,0)',
        size: 7,
      },
      mode: 'markers+text',
      cliponaxis: false,
      text: [
        null,
        null,
        null,
        null,
        null,
        null,
        '100',
        '100',
        '82',
        '100',
        null,
        null,
        null,
        null,
        null,
        '76',
        '99',
        '100',
        '100',
        '100',
        null,
        null,
        null,
        null,
        null,
        null,
        '100',
      ],
      textposition: 'top left',
      type: 'scatter',
      x: [
        -9.32366943359375,
        -7.953125,
        -7.80621337890625,
        -5.69930013020833,
        -2.21619466145833,
        -3.6651611328125,
        210.772827148438,
        289.9423828125,
        295.713348388672,
        686.276123046875,
        688.446272416548,
        691.909254594283,
        692.480938037792,
        692.75971175431,
        693.337571150773,
        696.402224775144,
        538.442138671875,
        653.797824435764,
        744.979567856817,
        825.389518514711,
        828.731408395664,
        829.830129986573,
        831.419803899616,
        834.052956073529,
        839.580456073529,
        841.614109919683,
        738.969265407986,
      ],
      y: [
        11.32470703125,
        7.125,
        3.25,
        6.25,
        5.5,
        2.5,
        15.5244140625,
        9.5,
        21.548828125,
        16.828125,
        15.65625,
        14.3125,
        13.125,
        12.25,
        15.5,
        11.5,
        26.26953125,
        23.0390625,
        19.5,
        26.578125,
        25.15625,
        23.3125,
        21.5,
        25.125,
        24.25,
        23.5,
        29.5,
      ],
    },
  ],
  layout: {
    showlegend: false,
    title: 'GBS clustering --- Neighbor-joining (rooted) tree',
    xaxis: {
      showgrid: false,
      showline: false,
      showticklabels: false,
      zeroline: false,
    },
    yaxis: {
      showgrid: false,
      showline: false,
      showticklabels: false,
      zeroline: false,
    },
  },
};
export const alignment = {
  data: [
    {
      colorbar: {
        bgcolor: '#E2E2E2',
        tickmode: 'array',
        ticks: 'outside',
        ticktext: [
          'Hydrophobic',
          'Negative',
          'Stop',
          'Positive',
          'Special',
          'Polar',
        ],
        tickvals: [0.08, 0.24, 0.4, 0.567, 0.733, 0.9],
        title: 'AA categories',
        titleside: 'top',
        x: -0.0578842315369261,
      },
      colorscale: [
        [0, '#8DD3C7'],
        [0.167, '#8DD3C7'],
        [0.167, '#FFFFB3'],
        [0.333, '#FFFFB3'],
        [0.333, '#BEBADA'],
        [0.5, '#BEBADA'],
        [0.5, '#FB8072'],
        [0.667, '#FB8072'],
        [0.667, '#80B1D3'],
        [0.833, '#80B1D3'],
        [0.833, '#FDB462'],
        [1, '#FDB462'],
      ],
      hoverinfo: 'skip',
      showscale: true,
      type: 'heatmap',
      z: [
        [
          '1',
          '0',
          '1',
          '1',
          '0.8',
          '1',
          '1',
          '0.8',
          '1',
          '0',
          '0',
          '0.8',
          '0.6',
          '1',
          '1',
          '0.2',
          '0',
          '1',
          '1',
          '0.6',
          '1',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0.6',
          '0',
          '0',
          '0',
          '0',
          '0.6',
          '0.8',
          '1',
          '0.6',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '0',
          '0.2',
          '0',
          '0',
          '1',
          '0',
          '0.6',
          '0',
          '0.8',
          '1',
          '1',
          '0.2',
          '0',
          '0.8',
          '0',
          '0.8',
          '0.6',
          '0.8',
          '0',
          '0.2',
          '1',
          '0',
          '0.2',
          '0',
          '0',
          '0.8',
          '1',
          '0.8',
          '1',
          '0',
          '1',
          '0.8',
          '0.6',
          '0',
          '0',
          '0.2',
          '0',
          '1',
          '0.8',
          '0',
          '0',
          '0.2',
          '0.8',
          '1',
          '0',
          '0.2',
          '0.2',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0.6',
          '0.8',
          '0.2',
          '0.8',
          '0',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0',
          '0.8',
          '0',
          '0',
          '1',
          '0.2',
          '0',
          '0',
          '0',
          '0.6',
          '0',
          '0.8',
          '0',
          '0.8',
          '0.6',
          '0',
          '0',
          '0',
          '0.6',
          '0.8',
          '1',
          '1',
          '1',
          '0',
          '0',
          '0',
          '0.8',
          '0.8',
          '1',
          '0',
          '1',
          '0',
          '0',
          '0.6',
          '1',
          '0.6',
          '0.8',
          '0',
          '0.6',
          '0.6',
          '0',
          '1',
          '1',
          '0.2',
          '0',
          '0.2',
          '0.8',
          '0',
          '0',
          '0',
          '0.8',
          '1',
          '0',
          '0.8',
          '0.2',
          '0.6',
          '0',
          '0.2',
          '0',
          '1',
          '0',
          '1',
          '0.6',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0.6',
          '0.2',
          '0.2',
          '1',
          '0.2',
          '1',
          '0.2',
          '1',
          '0.2',
          '0.6',
          '0',
          '1',
          '0.6',
          '0',
          '0',
          '0.6',
          '0',
          '0',
          '0.6',
          '0.2',
          '0',
          '0.2',
          '0',
          '0.6',
          '1',
          '0',
          '0.8',
          '0',
          '0',
          '0',
          '1',
          '1',
          '0',
          '0',
          '0.2',
          '0',
          '0.2',
          '0.8',
          '0',
          '0',
          '0',
          '0.2',
          '0.6',
          '0',
          '0.8',
          '0.6',
          '0',
          '0',
          '1',
          '0.8',
          '0',
          '0.6',
          '1',
          '0',
          '1',
          '0',
          '0.8',
          '0.8',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '1',
          '1',
          '0',
          '0',
          '0',
          '0',
          '1',
          '0',
          '0.8',
          '1',
          '0',
          '0',
          '1',
          '0',
          '0.2',
          '0.2',
          '0.2',
          '1',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '1',
          '0.8',
          '0',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '0.8',
          '0',
          '0.2',
          '0.2',
          '0.6',
          '0',
          '0.2',
          '0.8',
          '0.6',
          '0.8',
          '0',
          '0',
          '0',
          '0.6',
          '0.8',
          '0',
          '0',
          '0.8',
          '1',
          '0',
          '0.8',
          '0',
          '0',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '0.2',
          '0.2',
          '0',
          '0.2',
          '0.2',
          '0',
          '0.6',
          '1',
          '0.6',
          '0',
          '0.6',
          '0.2',
          '0',
          '0',
          '0.2',
          '0.6',
          '0',
          '0.6',
          '1',
          '0',
          '0',
          '0',
          '0.2',
          '0.8',
          '0.8',
          '1',
          '1',
          '0',
          '0',
          '0.2',
          '0',
          '0.2',
          '0',
          '0',
          '0',
          '0.6',
          '0.2',
          '0',
          '0.6',
          '1',
          '0',
          '1',
          '0',
          '1',
          '0.6',
          '0.6',
        ],
        [
          '1',
          '0',
          '1',
          '1',
          '0.8',
          '1',
          '1',
          '0.8',
          '1',
          '0',
          '0',
          '0.8',
          '0.6',
          '1',
          '1',
          '0.2',
          '0',
          '1',
          '1',
          '0.6',
          '1',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0.6',
          '0',
          '0',
          '0',
          '0',
          '0.6',
          '0.8',
          '1',
          '0.6',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '0',
          '0.2',
          '0',
          '0',
          '1',
          '0',
          '0.6',
          '0',
          '0.8',
          '1',
          '1',
          '0.2',
          '0',
          '0.8',
          '0',
          '0.8',
          '0.6',
          '0.8',
          '0',
          '0.2',
          '1',
          '0',
          '0.2',
          '0',
          '0',
          '0.8',
          '1',
          '0.8',
          '1',
          '0',
          '1',
          '0.8',
          '0.6',
          '0',
          '0',
          '0.2',
          '0',
          '1',
          '0.8',
          '0',
          '0',
          '0.2',
          '0.8',
          '1',
          '0',
          '0.2',
          '0.2',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0.6',
          '0.8',
          '0.2',
          '0.8',
          '0',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0',
          '0.8',
          '0',
          '0',
          '1',
          '0.2',
          '0',
          '0',
          '0',
          '0.6',
          '0',
          '0.8',
          '0',
          '0.8',
          '0.6',
          '0',
          '0',
          '0',
          '0.6',
          '0.8',
          '1',
          '1',
          '1',
          '0',
          '0',
          '0',
          '0.8',
          '0.8',
          '1',
          '0',
          '1',
          '0',
          '0',
          '0.6',
          '1',
          '0.6',
          '0.8',
          '0',
          '0.6',
          '0.6',
          '0',
          '1',
          '1',
          '0.2',
          '0',
          '0.2',
          '0.8',
          '0',
          '0',
          '0',
          '0.8',
          '1',
          '0',
          '0.8',
          '0.2',
          '0.6',
          '0',
          '0.2',
          '0',
          '1',
          '0',
          '1',
          '0.6',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0.6',
          '0.2',
          '0.2',
          '1',
          '0.2',
          '1',
          '0.2',
          '1',
          '0.2',
          '0.6',
          '0',
          '1',
          '0.6',
          '0',
          '0',
          '0.6',
          '0',
          '0',
          '0.6',
          '0.2',
          '0',
          '0.2',
          '0',
          '0.6',
          '1',
          '0',
          '0.8',
          '0',
          '0',
          '0',
          '1',
          '1',
          '0',
          '0',
          '0.2',
          '0',
          '0.2',
          '0.8',
          '0',
          '0',
          '0',
          '0.2',
          '0.6',
          '0',
          '0.8',
          '0.6',
          '0',
          '0',
          '1',
          '0.8',
          '0',
          '0.6',
          '1',
          '0',
          '1',
          '0',
          '0.8',
          '0.8',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '1',
          '1',
          '0',
          '0',
          '0',
          '0',
          '1',
          '0',
          '0.8',
          '1',
          '0',
          '0',
          '1',
          '0',
          '0.2',
          '0.2',
          '0.2',
          '1',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '1',
          '0.8',
          '0',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '0.8',
          '0',
          '0.2',
          '0.2',
          '0.6',
          '0',
          '0.2',
          '0.8',
          '0.6',
          '0.8',
          '0',
          '0',
          '0',
          '0.6',
          '0.8',
          '0',
          '0',
          '0.8',
          '1',
          '0',
          '0.8',
          '0',
          '0',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '0.2',
          '0.2',
          '0',
          '0.2',
          '0.2',
          '0',
          '0.6',
          '1',
          '0.6',
          '0',
          '0.6',
          '0.2',
          '0',
          '0',
          '0.2',
          '0.6',
          '0',
          '0.6',
          '1',
          '0',
          '0',
          '0',
          '0.2',
          '0.8',
          '0.8',
          '1',
          '1',
          '0',
          '0',
          '0.2',
          '0',
          '0.2',
          '0',
          '0',
          '0',
          '0.6',
          '0.2',
          '0',
          '0.6',
          '1',
          '0',
          '1',
          '0',
          '1',
          '0.6',
          '0.6',
        ],
        [
          '1',
          '0',
          '1',
          '1',
          '0.8',
          '1',
          '1',
          '0.8',
          '1',
          '0',
          '0',
          '0.8',
          '0.6',
          '1',
          '1',
          '0.2',
          '0',
          '1',
          '1',
          '0.6',
          '1',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0.6',
          '0',
          '0',
          '0',
          '0',
          '0.6',
          '0.8',
          '1',
          '0.6',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '0',
          '0.2',
          '0',
          '0',
          '1',
          '0',
          '0.6',
          '0',
          '0.8',
          '1',
          '1',
          '0.2',
          '0',
          '0.8',
          '0',
          '0.8',
          '0.6',
          '0.8',
          '0',
          '0.2',
          '1',
          '0',
          '0.2',
          '0',
          '0',
          '0.8',
          '1',
          '0.8',
          '1',
          '0',
          '1',
          '0.8',
          '0.6',
          '0',
          '0',
          '0.2',
          '0',
          '1',
          '0.8',
          '0',
          '0',
          '0.2',
          '0.8',
          '1',
          '0',
          '0.2',
          '0.2',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0.6',
          '0.8',
          '0.2',
          '0.8',
          '0',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0',
          '0.8',
          '0',
          '0',
          '1',
          '0.2',
          '0',
          '0',
          '0',
          '0.6',
          '0',
          '0.8',
          '0',
          '0.8',
          '0.6',
          '0',
          '0',
          '0',
          '0.6',
          '0.8',
          '1',
          '1',
          '1',
          '0',
          '0',
          '0',
          '0.8',
          '0.8',
          '1',
          '0',
          '1',
          '0',
          '0',
          '0.6',
          '1',
          '0.6',
          '0.8',
          '0',
          '0.6',
          '0.6',
          '0',
          '1',
          '1',
          '0.2',
          '0',
          '0.2',
          '0.8',
          '0',
          '0',
          '0',
          '0.8',
          '1',
          '0',
          '0.8',
          '0.2',
          '0.6',
          '0',
          '0.2',
          '0',
          '1',
          '0',
          '1',
          '0.6',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0.6',
          '0.2',
          '0.2',
          '1',
          '0.2',
          '1',
          '0.2',
          '1',
          '0.2',
          '0.6',
          '0',
          '1',
          '0.6',
          '0',
          '0',
          '0.6',
          '0',
          '0',
          '0.6',
          '0.2',
          '0',
          '0.2',
          '0',
          '0.6',
          '1',
          '0',
          '0.8',
          '0',
          '0',
          '0',
          '1',
          '1',
          '0',
          '0',
          '0.2',
          '0',
          '0.2',
          '0.8',
          '0',
          '0',
          '0',
          '0.2',
          '0.6',
          '0',
          '0.8',
          '0.6',
          '0',
          '0',
          '1',
          '0.8',
          '0',
          '0.6',
          '1',
          '0',
          '1',
          '0',
          '0.8',
          '0.8',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '1',
          '1',
          '0',
          '0',
          '0',
          '0',
          '1',
          '0',
          '0.8',
          '1',
          '0',
          '0',
          '1',
          '0',
          '0.2',
          '0.2',
          '0.2',
          '1',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '1',
          '0.8',
          '0',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '0.8',
          '0',
          '0.2',
          '0.2',
          '0.6',
          '0',
          '0.2',
          '0.8',
          '0.6',
          '0.8',
          '0',
          '0',
          '0',
          '0.6',
          '0.8',
          '0',
          '0',
          '0.8',
          '1',
          '0',
          '0.8',
          '0',
          '0',
          '.',
          '0.6',
          '0.2',
          '0',
          '0',
          '0.8',
          '0.8',
          '0',
          '0',
          '1',
          '0.6',
          '0.8',
          '0.8',
          '0',
          '1',
          '1',
          '1',
          '0',
          '0.2',
          '1',
          '0',
          '0.8',
          '0',
          '0.8',
          '0',
          '0.8',
          '.',
          '.',
          '1',
          '0',
          '0.8',
          '0',
          '1',
          '0',
          '0.2',
          '1',
          '0',
          '0.8',
          '1',
          '0.2',
          '0.6',
          '0',
          '0',
          '1',
          '0.2',
          '0',
          '0',
          '0.6',
          '0',
          '0.8',
          '0',
          '0.2',
          '0',
          '0.8',
          '0',
          '0.6',
          '0.6',
          '0',
          '0.6',
          '0',
          '0',
          '0',
          '0.8',
          '0.2',
          '0',
          '0',
          '0.6',
          '0.6',
          '0.2',
          '0',
          '0',
          '0.2',
          '0.6',
          '0',
          '0',
          '1',
          '0.6',
          '0',
          '0',
          '0.6',
          '0.8',
          '0.2',
          '0.2',
          '0',
          '0.2',
          '0.2',
          '0',
          '0.6',
          '1',
          '0.6',
          '0',
          '0.6',
          '0.2',
          '0',
          '0',
          '0.2',
          '0.6',
          '0',
          '0.6',
          '1',
          '0',
          '0',
          '0',
          '0.2',
          '0.8',
          '0.8',
          '1',
          '1',
          '0',
          '0',
          '0.2',
          '0',
          '0.2',
          '0',
          '0',
          '0',
          '0.6',
          '0.2',
          '0',
          '0.6',
          '1',
          '0',
          '1',
          '0',
          '1',
          '0.6',
          '0.6',
        ],
        [
          '1',
          '0',
          '1',
          '1',
          '0.8',
          '1',
          '1',
          '0.8',
          '1',
          '0',
          '0',
          '0.8',
          '0.6',
          '1',
          '1',
          '0.2',
          '0',
          '1',
          '1',
          '0.6',
          '1',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0.6',
          '0',
          '0',
          '0',
          '0',
          '0.6',
          '0.8',
          '1',
          '0.6',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '0',
          '0.2',
          '0',
          '0',
          '1',
          '0',
          '0.6',
          '0',
          '0.8',
          '1',
          '1',
          '0.2',
          '0',
          '0.8',
          '0',
          '0.8',
          '0.6',
          '0.8',
          '0',
          '0.2',
          '1',
          '0',
          '0.2',
          '0',
          '0',
          '0.8',
          '1',
          '0.8',
          '1',
          '0',
          '1',
          '0.8',
          '0.6',
          '0',
          '0',
          '0.2',
          '0',
          '1',
          '0.8',
          '0',
          '0',
          '0.2',
          '0.8',
          '1',
          '0',
          '0.2',
          '0.2',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0.6',
          '0.8',
          '0.2',
          '0.8',
          '0',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0',
          '0.8',
          '0',
          '0',
          '1',
          '0.2',
          '0',
          '0',
          '0',
          '0.6',
          '0',
          '0.8',
          '0',
          '0.8',
          '0.6',
          '0',
          '0',
          '0',
          '0.6',
          '0.8',
          '1',
          '1',
          '1',
          '0',
          '0',
          '0',
          '0.8',
          '0.8',
          '1',
          '0',
          '1',
          '0',
          '0',
          '0.6',
          '1',
          '0.6',
          '0.8',
          '0',
          '0.6',
          '0.6',
          '0',
          '1',
          '1',
          '0.2',
          '0',
          '0.2',
          '0.8',
          '0',
          '0',
          '0',
          '0.8',
          '1',
          '0',
          '0.8',
          '0.2',
          '0.6',
          '0',
          '0.2',
          '0',
          '1',
          '0',
          '1',
          '0.6',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0.6',
          '0.2',
          '0.2',
          '1',
          '0.2',
          '1',
          '0.2',
          '1',
          '0.2',
          '0.6',
          '0',
          '1',
          '0.6',
          '0',
          '0',
          '0.6',
          '0',
          '0',
          '0.6',
          '0.2',
          '0',
          '0.2',
          '0',
          '0.6',
          '1',
          '0',
          '0.8',
          '0',
          '0',
          '0',
          '1',
          '1',
          '0',
          '0',
          '0.2',
          '0',
          '0.2',
          '0.8',
          '0',
          '0',
          '0',
          '0.2',
          '0.6',
          '0',
          '0.8',
          '0.6',
          '0',
          '0',
          '1',
          '0.8',
          '0',
          '0.6',
          '1',
          '0',
          '1',
          '0',
          '0.8',
          '0.8',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '1',
          '1',
          '0',
          '0',
          '0',
          '0',
          '1',
          '0',
          '0.8',
          '1',
          '0',
          '0',
          '1',
          '0',
          '0.2',
          '0.2',
          '0.2',
          '1',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '1',
          '0.8',
          '0',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '0.8',
          '0',
          '0.2',
          '0.2',
          '0.6',
          '0',
          '0.2',
          '0.8',
          '0.6',
          '0.8',
          '0',
          '0',
          '0',
          '0.6',
          '0.8',
          '0',
          '0',
          '0.8',
          '1',
          '0',
          '0.8',
          '0',
          '0',
          '.',
          '0.6',
          '0.2',
          '0',
          '0',
          '0.8',
          '0.8',
          '0',
          '0',
          '1',
          '0.6',
          '0.8',
          '0.8',
          '0',
          '1',
          '1',
          '1',
          '0',
          '0.2',
          '1',
          '0',
          '0.8',
          '0',
          '0.8',
          '0',
          '0.8',
          '.',
          '.',
          '1',
          '0',
          '0.8',
          '0',
          '1',
          '0',
          '0.2',
          '1',
          '0',
          '0.8',
          '1',
          '0.2',
          '0.6',
          '0',
          '0',
          '1',
          '0.2',
          '0',
          '0',
          '0.6',
          '0',
          '0.8',
          '0',
          '0.2',
          '0',
          '0.8',
          '0',
          '0.6',
          '0.6',
          '0',
          '0.6',
          '0',
          '0',
          '0',
          '0.8',
          '0.2',
          '0',
          '0',
          '0.6',
          '0.6',
          '0.2',
          '0',
          '0',
          '0.2',
          '0.6',
          '0',
          '0',
          '1',
          '0.6',
          '0',
          '0',
          '0.6',
          '0.8',
          '0.2',
          '0.2',
          '0',
          '0.2',
          '0.2',
          '0',
          '0.6',
          '1',
          '0.6',
          '0',
          '0.6',
          '0.2',
          '0',
          '0',
          '0.2',
          '0.6',
          '0',
          '0.6',
          '1',
          '0',
          '0',
          '0',
          '0.2',
          '0.8',
          '0.8',
          '1',
          '1',
          '0',
          '0',
          '0.2',
          '0',
          '0.2',
          '0',
          '0',
          '0',
          '0.6',
          '0.2',
          '0',
          '0.6',
          '1',
          '0',
          '1',
          '0',
          '1',
          '0.6',
          '0.6',
        ],
        [
          '1',
          '0',
          '1',
          '1',
          '0.8',
          '1',
          '1',
          '0.8',
          '1',
          '0',
          '0',
          '0.8',
          '0.6',
          '1',
          '1',
          '0.2',
          '0',
          '1',
          '1',
          '0.6',
          '1',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0.6',
          '0',
          '0',
          '0',
          '0',
          '0.6',
          '0.8',
          '1',
          '0.6',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '0',
          '0.2',
          '0',
          '0',
          '1',
          '0',
          '0.6',
          '0',
          '0.8',
          '1',
          '1',
          '0.2',
          '0',
          '0.8',
          '0',
          '0.8',
          '0.6',
          '0.8',
          '0',
          '0.2',
          '1',
          '0',
          '0.2',
          '0',
          '0',
          '0.8',
          '1',
          '0.8',
          '1',
          '0',
          '1',
          '0.8',
          '0.6',
          '0',
          '0',
          '0.2',
          '0',
          '1',
          '0.8',
          '0',
          '0',
          '0.2',
          '0.8',
          '1',
          '0',
          '0.2',
          '0.2',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0.6',
          '0.8',
          '0.2',
          '0.8',
          '0',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0',
          '0.8',
          '0',
          '0',
          '1',
          '0.2',
          '0',
          '0',
          '0',
          '0.6',
          '0',
          '0.8',
          '0',
          '0.8',
          '0.6',
          '0',
          '0',
          '0',
          '0.6',
          '0.8',
          '1',
          '1',
          '1',
          '0',
          '0',
          '0',
          '0.8',
          '0.8',
          '1',
          '0',
          '1',
          '0',
          '0',
          '0.6',
          '1',
          '0.6',
          '0.8',
          '0',
          '0.6',
          '0.6',
          '0',
          '1',
          '1',
          '0.2',
          '0',
          '0.2',
          '0.8',
          '0',
          '0',
          '0',
          '0.8',
          '1',
          '0',
          '0.8',
          '0.2',
          '0.6',
          '0',
          '0.2',
          '0',
          '1',
          '0',
          '1',
          '0.6',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0.6',
          '0.2',
          '0.2',
          '1',
          '0.2',
          '1',
          '0.2',
          '1',
          '0.2',
          '0.6',
          '0',
          '1',
          '0.6',
          '0',
          '0',
          '0.6',
          '0',
          '0',
          '0.6',
          '0.2',
          '0',
          '0.2',
          '0',
          '0.6',
          '1',
          '0',
          '0.8',
          '0',
          '0',
          '0',
          '1',
          '1',
          '0',
          '0',
          '0.2',
          '0',
          '0.2',
          '0.8',
          '0',
          '0',
          '0',
          '0.2',
          '0.6',
          '0',
          '0.8',
          '0.6',
          '0',
          '0',
          '1',
          '0.8',
          '0',
          '0.6',
          '1',
          '0',
          '1',
          '0',
          '0.8',
          '0.8',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '1',
          '1',
          '0',
          '0',
          '0',
          '0',
          '1',
          '0',
          '0.8',
          '1',
          '0',
          '0',
          '1',
          '0',
          '0.2',
          '0.2',
          '0.2',
          '1',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '1',
          '0.8',
          '0',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '0.8',
          '0',
          '0.2',
          '0.2',
          '0.6',
          '0',
          '0.2',
          '0.8',
          '0.6',
          '0.8',
          '0',
          '0',
          '0',
          '0.6',
          '0.8',
          '0',
          '0',
          '0.8',
          '1',
          '0',
          '0.8',
          '0',
          '0',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '0.2',
          '0.2',
          '0',
          '0.2',
          '0.2',
          '0',
          '0.6',
          '1',
          '0.6',
          '0',
          '0.6',
          '0.2',
          '0',
          '0',
          '0.2',
          '0.6',
          '0',
          '0.6',
          '1',
          '0',
          '0',
          '0',
          '0.2',
          '0.8',
          '0.8',
          '1',
          '1',
          '0',
          '0',
          '0.2',
          '0',
          '0.2',
          '0',
          '0',
          '0',
          '0.6',
          '0.2',
          '0',
          '0.6',
          '1',
          '0',
          '1',
          '0',
          '1',
          '0.6',
          '0.6',
        ],
        [
          '1',
          '0',
          '1',
          '1',
          '0.8',
          '1',
          '1',
          '0.8',
          '1',
          '0',
          '0',
          '0.8',
          '0.6',
          '1',
          '1',
          '0.2',
          '0',
          '1',
          '1',
          '0.6',
          '1',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0.6',
          '0',
          '0',
          '0',
          '0',
          '0.6',
          '0.8',
          '1',
          '0.6',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '0',
          '0.2',
          '0',
          '0',
          '1',
          '0',
          '0.6',
          '0',
          '0.8',
          '1',
          '1',
          '0.2',
          '0',
          '0.8',
          '0',
          '0.8',
          '0.6',
          '0.8',
          '0',
          '0.2',
          '1',
          '0',
          '0.2',
          '0',
          '0',
          '0.8',
          '1',
          '0.8',
          '1',
          '0',
          '1',
          '0.8',
          '0.6',
          '0',
          '0',
          '0.2',
          '0',
          '1',
          '0.8',
          '0',
          '0',
          '0.2',
          '0.8',
          '1',
          '0',
          '0.2',
          '0.2',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0.6',
          '0.8',
          '0.2',
          '0.8',
          '0',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0',
          '0.8',
          '0',
          '0',
          '1',
          '0.2',
          '0',
          '0',
          '0',
          '0.6',
          '0',
          '0.8',
          '0',
          '0.8',
          '0.6',
          '0',
          '0',
          '0',
          '0.6',
          '0.8',
          '1',
          '1',
          '1',
          '0',
          '0',
          '0',
          '0.8',
          '0.8',
          '1',
          '0',
          '1',
          '0',
          '0',
          '0.6',
          '1',
          '0.6',
          '0.8',
          '0',
          '0.6',
          '0.6',
          '0',
          '1',
          '1',
          '0.2',
          '0',
          '0.2',
          '0.8',
          '0',
          '0',
          '0',
          '0.8',
          '1',
          '0',
          '0.8',
          '0.2',
          '0.6',
          '0',
          '0.2',
          '0',
          '1',
          '0',
          '1',
          '0.6',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0.6',
          '0.2',
          '0.2',
          '1',
          '0.2',
          '1',
          '0.2',
          '1',
          '0.2',
          '0.6',
          '0',
          '1',
          '0.6',
          '0',
          '0',
          '0.6',
          '0',
          '0',
          '0.6',
          '0.2',
          '0',
          '0.2',
          '0',
          '0.6',
          '1',
          '0',
          '0.8',
          '0',
          '0',
          '0',
          '1',
          '1',
          '0',
          '0',
          '0.2',
          '0',
          '0.2',
          '0.8',
          '0',
          '0',
          '0',
          '0.2',
          '0.6',
          '0',
          '0.8',
          '0.6',
          '0',
          '0',
          '1',
          '0.8',
          '0',
          '0.6',
          '1',
          '0',
          '1',
          '0',
          '0.8',
          '0.8',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '1',
          '1',
          '0',
          '0',
          '0',
          '0',
          '1',
          '0',
          '0.8',
          '1',
          '0',
          '0',
          '1',
          '0',
          '0.2',
          '0.2',
          '0.2',
          '1',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '1',
          '0.8',
          '0',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '0.8',
          '0',
          '0.2',
          '0.2',
          '0.6',
          '0',
          '0.2',
          '0.8',
          '0.6',
          '0.8',
          '0',
          '0',
          '0',
          '0.6',
          '0.8',
          '0',
          '0',
          '0.8',
          '1',
          '0',
          '0.8',
          '0',
          '0',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '0.2',
          '0.2',
          '0',
          '0.2',
          '0.2',
          '0',
          '0.6',
          '1',
          '0.6',
          '0',
          '0.6',
          '0.2',
          '0',
          '0',
          '0.2',
          '0.6',
          '0',
          '0.6',
          '1',
          '0',
          '0',
          '0',
          '0.2',
          '0.8',
          '0.8',
          '1',
          '1',
          '0',
          '0',
          '0.2',
          '0',
          '0.2',
          '0',
          '0',
          '0',
          '0.6',
          '0.2',
          '0',
          '0.6',
          '1',
          '0',
          '1',
          '0',
          '1',
          '0.6',
          '0.6',
        ],
        [
          '1',
          '0',
          '1',
          '1',
          '0.8',
          '1',
          '1',
          '0.8',
          '1',
          '0',
          '0',
          '0.8',
          '0.6',
          '1',
          '1',
          '0.2',
          '0',
          '1',
          '1',
          '0.6',
          '1',
          '.',
          '0',
          '0',
          '1',
          '0.6',
          '1',
          '1',
          '1',
          '1',
          '0',
          '0.6',
          '0',
          '0',
          '0',
          '0',
          '0.8',
          '0',
          '0',
          '0',
          '1',
          '0.8',
          '0.6',
          '0',
          '0',
          '0.8',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0.6',
          '0',
          '0',
          '0',
          '0',
          '0.6',
          '0.8',
          '1',
          '0.6',
          '1',
          '1',
          '0',
          '0',
          '1',
          '1',
          '0.8',
          '0',
          '0',
          '1',
          '0.8',
          '0',
          '0',
          '1',
          '0.6',
          '1',
          '0',
          '0.2',
          '0.6',
          '1',
          '0.6',
          '1',
          '0',
          '0.6',
          '1',
          '0.8',
          '0',
          '0.2',
          '0',
          '0',
          '1',
          '0',
          '0.6',
          '0',
          '0.8',
          '1',
          '1',
          '0.2',
          '0',
          '0.8',
          '0',
          '0.8',
          '0.6',
          '0.8',
          '0',
          '0.2',
          '1',
          '0',
          '0.2',
          '0',
          '0',
          '0.8',
          '1',
          '0.8',
          '1',
          '0',
          '1',
          '0.8',
          '0.6',
          '0',
          '0',
          '0.2',
          '0',
          '1',
          '0.8',
          '0',
          '0',
          '0.2',
          '0.8',
          '1',
          '0',
          '0.2',
          '0.2',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0.6',
          '0.8',
          '0.2',
          '0.8',
          '0',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0',
          '0.8',
          '0',
          '0',
          '1',
          '0.2',
          '0',
          '0',
          '0',
          '0.6',
          '0',
          '0.8',
          '0',
          '0.8',
          '0.6',
          '0',
          '0',
          '0',
          '0.6',
          '0.8',
          '1',
          '1',
          '1',
          '0',
          '0',
          '0',
          '0.8',
          '0.8',
          '1',
          '0',
          '1',
          '0',
          '0',
          '0.6',
          '1',
          '0.6',
          '0.8',
          '0',
          '0.6',
          '0.6',
          '0',
          '1',
          '1',
          '0.2',
          '0',
          '0.2',
          '0.8',
          '0',
          '0',
          '0',
          '0.8',
          '1',
          '0',
          '0.8',
          '0.2',
          '0.6',
          '0',
          '0.2',
          '0',
          '1',
          '0',
          '1',
          '0.6',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0.6',
          '0.2',
          '0.2',
          '1',
          '0.2',
          '1',
          '0.2',
          '1',
          '0.2',
          '0.6',
          '0',
          '1',
          '0.6',
          '0',
          '0',
          '0.6',
          '0',
          '0',
          '0.6',
          '0.2',
          '0',
          '0.2',
          '0',
          '0.6',
          '1',
          '0',
          '0.8',
          '0',
          '0',
          '0',
          '1',
          '1',
          '0',
          '0',
          '0.2',
          '0',
          '0.2',
          '0.8',
          '0',
          '0',
          '0',
          '0.2',
          '0.6',
          '0',
          '0.8',
          '0.6',
          '0',
          '0',
          '1',
          '0.8',
          '0',
          '0.6',
          '1',
          '0',
          '1',
          '0',
          '0.8',
          '0.8',
          '.',
          '0',
          '0',
          '0',
          '0.2',
          '0.6',
          '0.8',
          '0',
          '1',
          '0',
          '0.2',
          '0.2',
          '0.6',
          '0.2',
          '0.8',
          '0',
          '0.6',
          '0',
          '0',
          '0.6',
          '0.8',
          '0.6',
          '0.6',
          '0.8',
          '1',
          '1',
          '0',
          '0',
          '0',
          '0',
          '1',
          '0',
          '0.8',
          '1',
          '0',
          '0',
          '1',
          '0',
          '0.2',
          '0.2',
          '0.2',
          '1',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '1',
          '0.8',
          '0',
          '0.2',
          '0',
          '1',
          '0.8',
          '1',
          '1',
          '0',
          '0',
          '0',
          '0',
          '0',
          '0.6',
          '0.6',
          '0.2',
          '0.6',
          '0.6',
          '0.2',
          '0.8',
          '0',
          '1',
          '0.2',
          '0.2',
          '0',
          '0',
          '0.8',
          '0.2',
          '0.8',
          '0',
          '0.2',
          '0.2',
          '0.6',
          '0',
          '0.2',
          '0.8',
          '0.6',
          '0.8',
          '0',
          '0',
          '0',
          '0.6',
          '0.8',
          '0',
          '0',
          '0.8',
          '1',
          '0',
          '0.8',
          '0',
          '0',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '0.2',
          '0.2',
          '0',
          '0.2',
          '0.2',
          '0',
          '0.6',
          '1',
          '0.6',
          '0',
          '0.6',
          '0.2',
          '0',
          '0',
          '0.2',
          '0.6',
          '0',
          '0.6',
          '1',
          '0',
          '0',
          '0',
          '0.2',
          '0.8',
          '0.8',
          '1',
          '1',
          '0',
          '0',
          '0.2',
          '0',
          '0.2',
          '0',
          '0',
          '0',
          '0.6',
          '0.2',
          '0',
          '0.6',
          '1',
          '0',
          '1',
          '0',
          '1',
          '0.6',
          '0.6',
        ],
        [
          '1',
          '0',
          '1',
          '1',
          '0.8',
          '1',
          '1',
          '0.8',
          '1',
          '0',
          '0',
          '0.8',
          '0.6',
          '1',
          '1',
          '0.2',
          '0',
          '1',
          '1',
          '0.6',
          '1',
          '.',
          '0',
          '0',
          '1',
          '0.6',
          '1',
          '1',
          '1',
          '1',
          '0',
          '0.6',
          '0',
          '0',
          '0',
          '0',
          '0.8',
          '0',
          '0',
          '0',
          '1',
          '0.8',
          '0.6',
          '0',
          '0',
          '0.8',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0.6',
          '0',
          '0',
          '0',
          '0',
          '0.6',
          '0.8',
          '1',
          '0.6',
          '1',
          '1',
          '0',
          '0',
          '1',
          '1',
          '0.8',
          '0',
          '0',
          '1',
          '0.8',
          '0',
          '0',
          '1',
          '0.6',
          '1',
          '0',
          '0.2',
          '0.6',
          '1',
          '0.6',
          '1',
          '0',
          '0.6',
          '1',
          '0.8',
          '0',
          '0.2',
          '0',
          '0',
          '1',
          '0',
          '0.6',
          '0',
          '0.8',
          '1',
          '1',
          '0.2',
          '0',
          '0.8',
          '0',
          '0.8',
          '0.6',
          '0.8',
          '0',
          '0.2',
          '1',
          '0',
          '0.2',
          '0',
          '0',
          '0.8',
          '1',
          '0.8',
          '1',
          '0',
          '1',
          '0.8',
          '0.6',
          '0',
          '0',
          '0.2',
          '0',
          '1',
          '0.8',
          '0',
          '0',
          '0.2',
          '0.8',
          '1',
          '0',
          '0.2',
          '0.2',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0.6',
          '0.8',
          '0.2',
          '0.8',
          '0',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0',
          '0.8',
          '0',
          '0',
          '1',
          '0.2',
          '0',
          '0',
          '0',
          '0.6',
          '0',
          '0.8',
          '0',
          '0.8',
          '0.6',
          '0',
          '0',
          '0',
          '0.6',
          '0.8',
          '1',
          '1',
          '1',
          '0',
          '0',
          '0',
          '0.8',
          '0.8',
          '1',
          '0',
          '1',
          '0',
          '0',
          '0.6',
          '1',
          '0.6',
          '0.8',
          '0',
          '0.6',
          '0.6',
          '0',
          '1',
          '1',
          '0.2',
          '0',
          '0.2',
          '0.8',
          '0',
          '0',
          '0',
          '0.8',
          '1',
          '0',
          '0.8',
          '0.2',
          '0.6',
          '0',
          '0.2',
          '0',
          '1',
          '0',
          '1',
          '0.6',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0.6',
          '0.2',
          '0.2',
          '1',
          '0.2',
          '1',
          '0.2',
          '1',
          '0.2',
          '0.6',
          '0',
          '1',
          '0.6',
          '0',
          '0',
          '0.6',
          '0',
          '0',
          '0.6',
          '0.2',
          '0',
          '0.2',
          '0',
          '0.6',
          '1',
          '0',
          '0.8',
          '0',
          '0',
          '0',
          '1',
          '1',
          '0',
          '0',
          '0.2',
          '0',
          '0.2',
          '0.8',
          '0',
          '0',
          '0',
          '0.2',
          '0.6',
          '0',
          '0.8',
          '0.6',
          '0',
          '0',
          '1',
          '0.8',
          '0',
          '0.6',
          '1',
          '0',
          '1',
          '0',
          '0.8',
          '0.8',
          '.',
          '0',
          '0',
          '0',
          '0.2',
          '0.6',
          '0.8',
          '0',
          '1',
          '0',
          '0.2',
          '0.2',
          '0.6',
          '0.2',
          '0.8',
          '0',
          '0.6',
          '0',
          '0',
          '0.6',
          '0.8',
          '0.6',
          '0.6',
          '0.8',
          '1',
          '1',
          '0',
          '0',
          '0',
          '0',
          '1',
          '0',
          '0.8',
          '1',
          '0',
          '0',
          '1',
          '0',
          '0.2',
          '0.2',
          '0.2',
          '1',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '1',
          '0.8',
          '0',
          '0.2',
          '0',
          '1',
          '0.8',
          '1',
          '1',
          '0',
          '0',
          '0',
          '0',
          '0',
          '0.6',
          '0.6',
          '0.2',
          '0.6',
          '0.6',
          '0.2',
          '0.8',
          '0',
          '1',
          '0.2',
          '0.2',
          '0',
          '0',
          '0.8',
          '0.2',
          '0.8',
          '0',
          '0.2',
          '0.2',
          '0.6',
          '0',
          '0.2',
          '0.8',
          '0.6',
          '0.8',
          '0',
          '0',
          '0',
          '0.6',
          '0.8',
          '0',
          '0',
          '0.8',
          '1',
          '0',
          '0.8',
          '0',
          '0',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '0.2',
          '0.2',
          '0',
          '0.2',
          '0.2',
          '0',
          '0.6',
          '1',
          '0.6',
          '0',
          '0.6',
          '0.2',
          '0',
          '0',
          '0.2',
          '0.6',
          '0',
          '0.6',
          '1',
          '0',
          '0',
          '0',
          '0.2',
          '0.8',
          '0.8',
          '1',
          '1',
          '0',
          '0',
          '0.2',
          '0',
          '0.2',
          '0',
          '0',
          '0',
          '0.6',
          '0.2',
          '0',
          '0.6',
          '1',
          '0',
          '1',
          '0',
          '1',
          '0.6',
          '0.6',
        ],
        [
          '1',
          '0',
          '1',
          '1',
          '0.8',
          '1',
          '1',
          '0.8',
          '1',
          '0',
          '0',
          '0.8',
          '0.6',
          '1',
          '1',
          '0.2',
          '0',
          '1',
          '1',
          '0.6',
          '1',
          '0.2',
          '0',
          '0',
          '1',
          '0.6',
          '1',
          '1',
          '1',
          '1',
          '0',
          '0.6',
          '0',
          '0',
          '0',
          '0',
          '0.8',
          '0',
          '0',
          '0',
          '1',
          '0.8',
          '0.6',
          '0',
          '0',
          '0.8',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0.6',
          '0',
          '0',
          '0',
          '0',
          '0.6',
          '0.8',
          '1',
          '0.6',
          '1',
          '1',
          '0',
          '0',
          '1',
          '1',
          '0.8',
          '0',
          '0',
          '1',
          '0.8',
          '0',
          '0',
          '1',
          '0.6',
          '1',
          '0',
          '0.2',
          '0.6',
          '1',
          '0.6',
          '1',
          '0',
          '0.6',
          '1',
          '0.8',
          '0',
          '0.2',
          '0',
          '0',
          '1',
          '0',
          '0.6',
          '0',
          '0.8',
          '1',
          '1',
          '0.2',
          '0',
          '0.8',
          '0',
          '0.8',
          '0.6',
          '0.8',
          '0',
          '0.2',
          '1',
          '0',
          '0.2',
          '0',
          '0',
          '0.8',
          '1',
          '0.8',
          '1',
          '0',
          '1',
          '0.8',
          '0.6',
          '0',
          '0',
          '0.2',
          '0',
          '1',
          '0.8',
          '0',
          '0',
          '0.2',
          '0.8',
          '1',
          '0',
          '0.2',
          '0.2',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0.6',
          '0.8',
          '0.2',
          '0.8',
          '0',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0',
          '0.8',
          '0',
          '0',
          '1',
          '0.2',
          '0',
          '0',
          '0',
          '0.6',
          '0',
          '0.8',
          '0',
          '0.8',
          '0.6',
          '0',
          '0',
          '0',
          '0.6',
          '0.8',
          '1',
          '1',
          '1',
          '0',
          '0',
          '0',
          '0.8',
          '0.8',
          '1',
          '0',
          '1',
          '0',
          '0',
          '0.6',
          '1',
          '0.6',
          '0.8',
          '0',
          '0.6',
          '0.6',
          '0',
          '1',
          '1',
          '0.2',
          '0',
          '0.2',
          '0.8',
          '0',
          '0',
          '0',
          '0.8',
          '1',
          '0',
          '0.8',
          '0.2',
          '0.6',
          '0',
          '0.2',
          '0',
          '1',
          '0',
          '1',
          '0.6',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '0.6',
          '0.2',
          '0.2',
          '1',
          '0.2',
          '1',
          '0.2',
          '1',
          '0.2',
          '0.6',
          '0',
          '1',
          '0.6',
          '0',
          '0',
          '0.6',
          '0',
          '0',
          '0.6',
          '0.2',
          '0',
          '0.2',
          '0',
          '0.6',
          '1',
          '0',
          '0.8',
          '0',
          '0',
          '0',
          '1',
          '1',
          '0',
          '0',
          '0.2',
          '0',
          '0.2',
          '0.8',
          '0',
          '0',
          '0',
          '0.2',
          '0.6',
          '0',
          '0.8',
          '0.6',
          '0',
          '0',
          '1',
          '0.8',
          '0',
          '0.6',
          '1',
          '0',
          '1',
          '0',
          '0.8',
          '0.8',
          '0',
          '0',
          '0',
          '0',
          '0.2',
          '0.6',
          '0.8',
          '0',
          '1',
          '0',
          '0.2',
          '0.2',
          '0.6',
          '0.2',
          '0.8',
          '0',
          '0.6',
          '0',
          '0',
          '0.6',
          '0.8',
          '0.6',
          '0.6',
          '0.8',
          '1',
          '1',
          '0',
          '0',
          '0',
          '0',
          '1',
          '0',
          '0.8',
          '1',
          '0',
          '0',
          '1',
          '0',
          '0.2',
          '0.2',
          '0.2',
          '1',
          '0',
          '0',
          '0.2',
          '0',
          '0',
          '1',
          '0.8',
          '0',
          '0.2',
          '0',
          '1',
          '0.8',
          '1',
          '1',
          '0',
          '0',
          '0',
          '0',
          '0',
          '0.6',
          '0.6',
          '0.2',
          '0.6',
          '0.6',
          '0.2',
          '0.8',
          '0',
          '1',
          '0.2',
          '0.2',
          '0',
          '0',
          '0.8',
          '0.2',
          '0.8',
          '0',
          '0.2',
          '0.2',
          '0.6',
          '0',
          '0.2',
          '0.8',
          '0.6',
          '0.8',
          '0',
          '0',
          '0',
          '0.6',
          '0.8',
          '0',
          '0',
          '0.8',
          '1',
          '0',
          '0.8',
          '0',
          '0',
          '0.2',
          '0.6',
          '0.2',
          '0',
          '0',
          '0.8',
          '0.8',
          '0',
          '0',
          '1',
          '0.6',
          '0.8',
          '0.8',
          '0',
          '1',
          '1',
          '1',
          '0',
          '0.2',
          '1',
          '0',
          '0.8',
          '0',
          '0.8',
          '0',
          '0.8',
          '0',
          '0',
          '1',
          '0',
          '0.8',
          '0',
          '1',
          '0',
          '0.2',
          '1',
          '0',
          '0.8',
          '1',
          '0.2',
          '0.6',
          '0',
          '0',
          '1',
          '0.2',
          '0',
          '0',
          '0.6',
          '0',
          '0.8',
          '0',
          '0.2',
          '0',
          '0.8',
          '0',
          '0.6',
          '0.6',
          '0',
          '0.6',
          '0',
          '0',
          '0',
          '0.8',
          '0.2',
          '0',
          '0',
          '0.6',
          '0.6',
          '0.2',
          '0',
          '0',
          '0.2',
          '0.6',
          '0',
          '0',
          '1',
          '0.6',
          '0',
          '0',
          '0.6',
          '0.8',
          '0.2',
          '0.2',
          '0',
          '0.2',
          '0.2',
          '0',
          '0.6',
          '1',
          '0.6',
          '0',
          '0.6',
          '0.2',
          '0',
          '0',
          '0.2',
          '0.6',
          '0',
          '0.6',
          '1',
          '0',
          '0',
          '0',
          '0.2',
          '0.8',
          '0.8',
          '1',
          '1',
          '0',
          '0',
          '0.2',
          '0',
          '0.2',
          '0',
          '0',
          '0',
          '0.6',
          '0.2',
          '0',
          '0.6',
          '1',
          '0',
          '1',
          '0',
          '1',
          '0.6',
          '0.6',
        ],
      ],
    },
    {
      mode: 'text',
      text: [
        'S',
        'L',
        'N',
        'S',
        'G',
        'N',
        'T',
        'P',
        'S',
        'Y',
        'I',
        'C',
        'K',
        'T',
        'S',
        'D',
        'L',
        'T',
        'Q',
        'K',
        'S',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'A',
        'I',
        'D',
        'M',
        'A',
        'K',
        'L',
        'F',
        'A',
        'L',
        'R',
        'G',
        'Q',
        'R',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'V',
        'D',
        'I',
        'L',
        'T',
        'I',
        'K',
        'I',
        'P',
        'S',
        'S',
        'E',
        'A',
        'G',
        'F',
        'P',
        'K',
        'G',
        'I',
        'E',
        'S',
        'L',
        'D',
        'M',
        'A',
        'P',
        'T',
        'P',
        'Q',
        'V',
        'Q',
        'G',
        'K',
        'F',
        'F',
        'E',
        'A',
        'S',
        'G',
        'L',
        'F',
        'E',
        'P',
        'Q',
        'I',
        'D',
        'E',
        'L',
        'L',
        'E',
        'L',
        'Y',
        'R',
        'P',
        'D',
        'C',
        'L',
        'V',
        'A',
        'D',
        'I',
        'F',
        'F',
        'P',
        'W',
        'A',
        'T',
        'D',
        'V',
        'A',
        'A',
        'K',
        'Y',
        'G',
        'I',
        'P',
        'R',
        'L',
        'I',
        'F',
        'H',
        'G',
        'S',
        'S',
        'N',
        'F',
        'A',
        'M',
        'C',
        'C',
        'N',
        'L',
        'S',
        'V',
        'F',
        'R',
        'S',
        'K',
        'P',
        'Y',
        'K',
        'H',
        'V',
        'S',
        'S',
        'E',
        'Y',
        'E',
        'P',
        'F',
        'I',
        'I',
        'P',
        'N',
        'L',
        'P',
        'D',
        'K',
        'I',
        'E',
        'F',
        'T',
        'A',
        'S',
        'R',
        'V',
        'A',
        'D',
        'F',
        'I',
        'K',
        'E',
        'D',
        'S',
        'E',
        'T',
        'E',
        'T',
        'D',
        'H',
        'F',
        'T',
        'K',
        'M',
        'Y',
        'K',
        'V',
        'M',
        'K',
        'E',
        'V',
        'E',
        'L',
        'R',
        'S',
        'Y',
        'G',
        'I',
        'L',
        'V',
        'N',
        'S',
        'F',
        'Y',
        'E',
        'L',
        'E',
        'P',
        'A',
        'Y',
        'A',
        'D',
        'H',
        'Y',
        'P',
        'K',
        'V',
        'I',
        'Q',
        'G',
        'I',
        'K',
        'T',
        'W',
        'Q',
        'I',
        'G',
        'P',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'N',
        'S',
        'V',
        'V',
        'Y',
        'V',
        'S',
        'F',
        'G',
        'S',
        'V',
        'A',
        'N',
        'F',
        'D',
        'D',
        'E',
        'Q',
        'L',
        'M',
        'E',
        'I',
        'A',
        'T',
        'G',
        'L',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'G',
        'F',
        'E',
        'E',
        'R',
        'M',
        'E',
        'G',
        'K',
        'G',
        'V',
        'I',
        'V',
        'R',
        'G',
        'W',
        'A',
        'P',
        'Q',
        'I',
        'P',
        'I',
        'L',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'D',
        'E',
        'A',
        'E',
        'E',
        'M',
        'R',
        'S',
        'R',
        'V',
        'K',
        'E',
        'L',
        'A',
        'D',
        'K',
        'A',
        'R',
        'N',
        'A',
        'I',
        'M',
        'D',
        'G',
        'G',
        'S',
        'S',
        'I',
        'L',
        'D',
        'L',
        'E',
        'A',
        'L',
        'F',
        'H',
        'D',
        'L',
        'K',
        'S',
        'A',
        'S',
        'A',
        'T',
        'R',
        'K',
        'S',
        'L',
        'N',
        'S',
        'G',
        'N',
        'T',
        'P',
        'S',
        'Y',
        'I',
        'C',
        'K',
        'T',
        'S',
        'D',
        'L',
        'T',
        'Q',
        'K',
        'S',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'A',
        'I',
        'D',
        'M',
        'A',
        'K',
        'L',
        'F',
        'A',
        'L',
        'R',
        'G',
        'Q',
        'R',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'V',
        'D',
        'I',
        'L',
        'T',
        'I',
        'K',
        'I',
        'P',
        'S',
        'S',
        'E',
        'A',
        'G',
        'F',
        'P',
        'K',
        'G',
        'I',
        'E',
        'S',
        'L',
        'D',
        'M',
        'A',
        'P',
        'T',
        'P',
        'Q',
        'V',
        'Q',
        'G',
        'K',
        'F',
        'F',
        'E',
        'A',
        'S',
        'G',
        'L',
        'F',
        'E',
        'P',
        'Q',
        'I',
        'D',
        'E',
        'L',
        'L',
        'E',
        'L',
        'Y',
        'R',
        'P',
        'D',
        'C',
        'L',
        'V',
        'A',
        'D',
        'I',
        'F',
        'F',
        'P',
        'W',
        'A',
        'T',
        'D',
        'V',
        'A',
        'A',
        'K',
        'Y',
        'G',
        'I',
        'P',
        'R',
        'L',
        'I',
        'F',
        'H',
        'G',
        'S',
        'S',
        'N',
        'F',
        'A',
        'M',
        'C',
        'C',
        'N',
        'L',
        'S',
        'V',
        'F',
        'R',
        'S',
        'K',
        'P',
        'Y',
        'K',
        'H',
        'V',
        'S',
        'S',
        'E',
        'Y',
        'E',
        'P',
        'F',
        'I',
        'I',
        'P',
        'N',
        'L',
        'P',
        'D',
        'K',
        'I',
        'E',
        'F',
        'T',
        'A',
        'S',
        'R',
        'V',
        'A',
        'D',
        'F',
        'I',
        'K',
        'E',
        'D',
        'S',
        'E',
        'T',
        'E',
        'T',
        'D',
        'H',
        'F',
        'T',
        'K',
        'M',
        'Y',
        'K',
        'V',
        'M',
        'K',
        'E',
        'V',
        'E',
        'L',
        'R',
        'S',
        'Y',
        'G',
        'I',
        'L',
        'V',
        'N',
        'S',
        'F',
        'Y',
        'E',
        'L',
        'E',
        'P',
        'A',
        'Y',
        'A',
        'D',
        'H',
        'Y',
        'P',
        'K',
        'V',
        'I',
        'Q',
        'G',
        'I',
        'K',
        'T',
        'W',
        'Q',
        'I',
        'G',
        'P',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'N',
        'S',
        'V',
        'V',
        'Y',
        'V',
        'S',
        'F',
        'G',
        'S',
        'V',
        'A',
        'N',
        'F',
        'D',
        'D',
        'E',
        'Q',
        'L',
        'M',
        'E',
        'I',
        'A',
        'T',
        'G',
        'L',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'G',
        'F',
        'E',
        'E',
        'R',
        'M',
        'E',
        'G',
        'K',
        'G',
        'V',
        'I',
        'V',
        'R',
        'G',
        'W',
        'A',
        'P',
        'Q',
        'I',
        'P',
        'I',
        'L',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'D',
        'E',
        'A',
        'E',
        'E',
        'M',
        'R',
        'S',
        'R',
        'V',
        'K',
        'E',
        'L',
        'A',
        'D',
        'K',
        'A',
        'R',
        'N',
        'A',
        'I',
        'M',
        'D',
        'G',
        'G',
        'S',
        'S',
        'I',
        'L',
        'D',
        'L',
        'E',
        'A',
        'L',
        'F',
        'H',
        'D',
        'L',
        'K',
        'S',
        'A',
        'S',
        'A',
        'T',
        'R',
        'K',
        'S',
        'L',
        'N',
        'S',
        'G',
        'N',
        'T',
        'P',
        'S',
        'Y',
        'I',
        'C',
        'K',
        'T',
        'S',
        'D',
        'L',
        'T',
        'Q',
        'K',
        'S',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'A',
        'I',
        'D',
        'M',
        'A',
        'K',
        'L',
        'F',
        'A',
        'L',
        'R',
        'G',
        'Q',
        'R',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'V',
        'D',
        'I',
        'L',
        'T',
        'I',
        'K',
        'I',
        'P',
        'S',
        'S',
        'E',
        'A',
        'G',
        'F',
        'P',
        'K',
        'G',
        'I',
        'E',
        'S',
        'L',
        'D',
        'M',
        'A',
        'P',
        'T',
        'P',
        'Q',
        'V',
        'Q',
        'G',
        'K',
        'F',
        'F',
        'E',
        'A',
        'S',
        'G',
        'L',
        'F',
        'E',
        'P',
        'Q',
        'I',
        'D',
        'E',
        'L',
        'L',
        'E',
        'L',
        'Y',
        'R',
        'P',
        'D',
        'C',
        'L',
        'V',
        'A',
        'D',
        'I',
        'F',
        'F',
        'P',
        'W',
        'A',
        'T',
        'D',
        'V',
        'A',
        'A',
        'K',
        'Y',
        'G',
        'I',
        'P',
        'R',
        'L',
        'I',
        'F',
        'H',
        'G',
        'S',
        'S',
        'N',
        'F',
        'A',
        'M',
        'C',
        'C',
        'N',
        'L',
        'S',
        'V',
        'F',
        'R',
        'S',
        'K',
        'P',
        'Y',
        'K',
        'H',
        'V',
        'S',
        'S',
        'E',
        'Y',
        'E',
        'P',
        'F',
        'I',
        'I',
        'P',
        'N',
        'L',
        'P',
        'D',
        'K',
        'I',
        'E',
        'F',
        'T',
        'A',
        'S',
        'R',
        'V',
        'A',
        'D',
        'F',
        'I',
        'K',
        'E',
        'D',
        'S',
        'E',
        'T',
        'E',
        'T',
        'D',
        'H',
        'F',
        'T',
        'K',
        'M',
        'Y',
        'K',
        'V',
        'M',
        'K',
        'E',
        'V',
        'E',
        'L',
        'R',
        'S',
        'Y',
        'G',
        'I',
        'L',
        'V',
        'N',
        'S',
        'F',
        'Y',
        'E',
        'L',
        'E',
        'P',
        'A',
        'Y',
        'A',
        'D',
        'H',
        'Y',
        'P',
        'K',
        'V',
        'I',
        'Q',
        'G',
        'I',
        'K',
        'T',
        'W',
        'Q',
        'I',
        'G',
        'P',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'N',
        'S',
        'V',
        'V',
        'Y',
        'V',
        'S',
        'F',
        'G',
        'S',
        'V',
        'A',
        'N',
        'F',
        'D',
        'D',
        'E',
        'Q',
        'L',
        'M',
        'E',
        'I',
        'A',
        'T',
        'G',
        'L',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'G',
        'F',
        'E',
        'E',
        'R',
        'M',
        'E',
        'G',
        'K',
        'G',
        'V',
        'I',
        'V',
        'R',
        'G',
        'W',
        'A',
        'P',
        'Q',
        'I',
        'P',
        'I',
        'L',
        '.',
        'H',
        'E',
        'A',
        'I',
        'G',
        'G',
        'F',
        'L',
        'T',
        'H',
        'C',
        'G',
        'W',
        'N',
        'S',
        'T',
        'L',
        'E',
        'S',
        'I',
        'C',
        'A',
        'G',
        'V',
        'P',
        '.',
        '.',
        'T',
        'W',
        'P',
        'V',
        'S',
        'A',
        'E',
        'Q',
        'F',
        'C',
        'N',
        'E',
        'K',
        'L',
        'V',
        'S',
        'E',
        'I',
        'L',
        'R',
        'V',
        'G',
        'I',
        'E',
        'V',
        'G',
        'A',
        'K',
        'K',
        'W',
        'K',
        'V',
        'L',
        'V',
        'G',
        'D',
        'F',
        'V',
        'K',
        'R',
        'D',
        'A',
        'I',
        'E',
        'R',
        'A',
        'V',
        'T',
        'R',
        'L',
        'M',
        'K',
        'G',
        'D',
        'E',
        'A',
        'E',
        'E',
        'M',
        'R',
        'S',
        'R',
        'V',
        'K',
        'E',
        'L',
        'A',
        'D',
        'K',
        'A',
        'R',
        'N',
        'A',
        'I',
        'M',
        'D',
        'G',
        'G',
        'S',
        'S',
        'I',
        'L',
        'D',
        'L',
        'E',
        'A',
        'L',
        'F',
        'H',
        'D',
        'L',
        'K',
        'S',
        'A',
        'S',
        'A',
        'T',
        'R',
        'K',
        'S',
        'L',
        'N',
        'S',
        'G',
        'N',
        'T',
        'P',
        'S',
        'Y',
        'I',
        'C',
        'K',
        'T',
        'S',
        'D',
        'L',
        'T',
        'Q',
        'K',
        'S',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'A',
        'I',
        'D',
        'M',
        'A',
        'K',
        'L',
        'F',
        'A',
        'L',
        'R',
        'G',
        'Q',
        'R',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'V',
        'D',
        'I',
        'L',
        'T',
        'I',
        'K',
        'I',
        'P',
        'S',
        'S',
        'E',
        'A',
        'G',
        'F',
        'P',
        'K',
        'G',
        'I',
        'E',
        'S',
        'L',
        'D',
        'M',
        'A',
        'P',
        'T',
        'P',
        'Q',
        'V',
        'Q',
        'G',
        'K',
        'F',
        'F',
        'E',
        'A',
        'S',
        'G',
        'L',
        'F',
        'E',
        'P',
        'Q',
        'I',
        'D',
        'E',
        'L',
        'L',
        'E',
        'L',
        'Y',
        'R',
        'P',
        'D',
        'C',
        'L',
        'V',
        'A',
        'D',
        'I',
        'F',
        'F',
        'P',
        'W',
        'A',
        'T',
        'D',
        'V',
        'A',
        'A',
        'K',
        'Y',
        'G',
        'I',
        'P',
        'R',
        'L',
        'I',
        'F',
        'H',
        'G',
        'S',
        'S',
        'N',
        'F',
        'A',
        'M',
        'C',
        'C',
        'N',
        'L',
        'S',
        'V',
        'F',
        'R',
        'S',
        'K',
        'P',
        'Y',
        'K',
        'H',
        'V',
        'S',
        'S',
        'E',
        'Y',
        'E',
        'P',
        'F',
        'I',
        'I',
        'P',
        'N',
        'L',
        'P',
        'D',
        'K',
        'I',
        'E',
        'F',
        'T',
        'A',
        'S',
        'R',
        'V',
        'A',
        'D',
        'F',
        'I',
        'K',
        'E',
        'D',
        'S',
        'E',
        'T',
        'E',
        'T',
        'D',
        'H',
        'F',
        'T',
        'K',
        'M',
        'Y',
        'K',
        'V',
        'M',
        'K',
        'E',
        'V',
        'E',
        'L',
        'R',
        'S',
        'Y',
        'G',
        'I',
        'L',
        'V',
        'N',
        'S',
        'F',
        'Y',
        'E',
        'L',
        'E',
        'P',
        'A',
        'Y',
        'A',
        'D',
        'H',
        'Y',
        'P',
        'K',
        'V',
        'I',
        'Q',
        'G',
        'I',
        'K',
        'T',
        'W',
        'Q',
        'I',
        'G',
        'P',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'N',
        'S',
        'V',
        'V',
        'Y',
        'V',
        'S',
        'F',
        'G',
        'S',
        'V',
        'A',
        'N',
        'F',
        'D',
        'D',
        'E',
        'Q',
        'L',
        'M',
        'E',
        'I',
        'A',
        'T',
        'G',
        'L',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'G',
        'F',
        'E',
        'E',
        'R',
        'M',
        'E',
        'G',
        'K',
        'G',
        'V',
        'I',
        'V',
        'R',
        'G',
        'W',
        'A',
        'P',
        'Q',
        'I',
        'P',
        'I',
        'L',
        '.',
        'H',
        'E',
        'A',
        'I',
        'G',
        'G',
        'F',
        'L',
        'T',
        'H',
        'C',
        'G',
        'W',
        'N',
        'S',
        'T',
        'L',
        'E',
        'S',
        'I',
        'C',
        'A',
        'G',
        'V',
        'P',
        '.',
        '.',
        'T',
        'W',
        'P',
        'V',
        'S',
        'A',
        'E',
        'Q',
        'F',
        'C',
        'N',
        'E',
        'K',
        'L',
        'V',
        'S',
        'E',
        'I',
        'L',
        'R',
        'V',
        'G',
        'I',
        'E',
        'V',
        'G',
        'A',
        'K',
        'K',
        'W',
        'K',
        'V',
        'L',
        'V',
        'G',
        'D',
        'F',
        'V',
        'K',
        'R',
        'D',
        'A',
        'I',
        'E',
        'R',
        'A',
        'V',
        'T',
        'R',
        'L',
        'M',
        'K',
        'G',
        'D',
        'E',
        'A',
        'E',
        'E',
        'M',
        'R',
        'S',
        'R',
        'V',
        'K',
        'E',
        'L',
        'A',
        'D',
        'K',
        'A',
        'R',
        'N',
        'A',
        'I',
        'M',
        'D',
        'G',
        'G',
        'S',
        'S',
        'I',
        'L',
        'D',
        'L',
        'E',
        'A',
        'L',
        'F',
        'H',
        'D',
        'L',
        'K',
        'S',
        'A',
        'S',
        'A',
        'T',
        'R',
        'K',
        'S',
        'L',
        'N',
        'S',
        'G',
        'N',
        'T',
        'P',
        'S',
        'Y',
        'I',
        'C',
        'K',
        'T',
        'S',
        'D',
        'L',
        'T',
        'Q',
        'K',
        'S',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'A',
        'I',
        'D',
        'M',
        'A',
        'K',
        'L',
        'F',
        'A',
        'L',
        'R',
        'G',
        'Q',
        'R',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'V',
        'D',
        'I',
        'L',
        'T',
        'I',
        'K',
        'I',
        'P',
        'S',
        'S',
        'E',
        'A',
        'G',
        'F',
        'P',
        'K',
        'G',
        'I',
        'E',
        'S',
        'L',
        'D',
        'M',
        'A',
        'P',
        'T',
        'P',
        'Q',
        'V',
        'Q',
        'G',
        'K',
        'F',
        'F',
        'E',
        'A',
        'S',
        'G',
        'L',
        'F',
        'E',
        'P',
        'Q',
        'I',
        'D',
        'E',
        'L',
        'L',
        'E',
        'L',
        'Y',
        'R',
        'P',
        'D',
        'C',
        'L',
        'V',
        'A',
        'D',
        'I',
        'F',
        'F',
        'P',
        'W',
        'A',
        'T',
        'D',
        'V',
        'A',
        'A',
        'K',
        'Y',
        'G',
        'I',
        'P',
        'R',
        'L',
        'I',
        'F',
        'H',
        'G',
        'S',
        'S',
        'N',
        'F',
        'A',
        'M',
        'C',
        'C',
        'N',
        'L',
        'S',
        'V',
        'F',
        'R',
        'S',
        'K',
        'P',
        'Y',
        'K',
        'H',
        'V',
        'S',
        'S',
        'E',
        'Y',
        'E',
        'P',
        'F',
        'I',
        'I',
        'P',
        'N',
        'L',
        'P',
        'D',
        'K',
        'I',
        'E',
        'F',
        'T',
        'A',
        'S',
        'R',
        'V',
        'A',
        'D',
        'F',
        'I',
        'K',
        'E',
        'D',
        'S',
        'E',
        'T',
        'E',
        'T',
        'D',
        'H',
        'F',
        'T',
        'K',
        'M',
        'Y',
        'K',
        'V',
        'M',
        'K',
        'E',
        'V',
        'E',
        'L',
        'R',
        'S',
        'Y',
        'G',
        'I',
        'L',
        'V',
        'N',
        'S',
        'F',
        'Y',
        'E',
        'L',
        'E',
        'P',
        'A',
        'Y',
        'A',
        'D',
        'H',
        'Y',
        'P',
        'K',
        'V',
        'I',
        'Q',
        'G',
        'I',
        'K',
        'T',
        'W',
        'Q',
        'I',
        'G',
        'P',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'N',
        'S',
        'V',
        'V',
        'Y',
        'V',
        'S',
        'F',
        'G',
        'S',
        'V',
        'A',
        'N',
        'F',
        'D',
        'D',
        'E',
        'Q',
        'L',
        'M',
        'E',
        'I',
        'A',
        'T',
        'G',
        'L',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'G',
        'F',
        'E',
        'E',
        'R',
        'M',
        'E',
        'G',
        'K',
        'G',
        'V',
        'I',
        'V',
        'R',
        'G',
        'W',
        'A',
        'P',
        'Q',
        'I',
        'P',
        'I',
        'L',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'D',
        'E',
        'A',
        'E',
        'E',
        'M',
        'R',
        'S',
        'R',
        'V',
        'K',
        'E',
        'L',
        'A',
        'D',
        'K',
        'A',
        'R',
        'N',
        'A',
        'I',
        'M',
        'D',
        'G',
        'G',
        'S',
        'S',
        'I',
        'L',
        'D',
        'L',
        'E',
        'A',
        'L',
        'F',
        'H',
        'D',
        'L',
        'K',
        'S',
        'A',
        'S',
        'A',
        'T',
        'R',
        'K',
        'S',
        'L',
        'N',
        'S',
        'G',
        'N',
        'T',
        'P',
        'S',
        'Y',
        'I',
        'C',
        'K',
        'T',
        'S',
        'D',
        'L',
        'T',
        'Q',
        'K',
        'S',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'A',
        'I',
        'D',
        'M',
        'A',
        'K',
        'L',
        'F',
        'A',
        'L',
        'R',
        'G',
        'Q',
        'R',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'V',
        'D',
        'I',
        'L',
        'T',
        'I',
        'K',
        'I',
        'P',
        'S',
        'S',
        'E',
        'A',
        'G',
        'F',
        'P',
        'K',
        'G',
        'I',
        'E',
        'S',
        'L',
        'D',
        'M',
        'A',
        'P',
        'T',
        'P',
        'Q',
        'V',
        'Q',
        'G',
        'K',
        'F',
        'F',
        'E',
        'A',
        'S',
        'G',
        'L',
        'F',
        'E',
        'P',
        'Q',
        'I',
        'D',
        'E',
        'L',
        'L',
        'E',
        'L',
        'Y',
        'R',
        'P',
        'D',
        'C',
        'L',
        'V',
        'A',
        'D',
        'I',
        'F',
        'F',
        'P',
        'W',
        'A',
        'T',
        'D',
        'V',
        'A',
        'A',
        'K',
        'Y',
        'G',
        'I',
        'P',
        'R',
        'L',
        'I',
        'F',
        'H',
        'G',
        'S',
        'S',
        'N',
        'F',
        'A',
        'M',
        'C',
        'C',
        'N',
        'L',
        'S',
        'V',
        'F',
        'R',
        'S',
        'K',
        'P',
        'Y',
        'K',
        'H',
        'V',
        'S',
        'S',
        'E',
        'Y',
        'E',
        'P',
        'F',
        'I',
        'I',
        'P',
        'N',
        'L',
        'P',
        'D',
        'K',
        'I',
        'E',
        'F',
        'T',
        'A',
        'S',
        'R',
        'V',
        'A',
        'D',
        'F',
        'I',
        'K',
        'E',
        'D',
        'S',
        'E',
        'T',
        'E',
        'T',
        'D',
        'H',
        'F',
        'T',
        'K',
        'M',
        'Y',
        'K',
        'V',
        'M',
        'K',
        'E',
        'V',
        'E',
        'L',
        'R',
        'S',
        'Y',
        'G',
        'I',
        'L',
        'V',
        'N',
        'S',
        'F',
        'Y',
        'E',
        'L',
        'E',
        'P',
        'A',
        'Y',
        'A',
        'D',
        'H',
        'Y',
        'P',
        'K',
        'V',
        'I',
        'Q',
        'G',
        'I',
        'K',
        'T',
        'W',
        'Q',
        'I',
        'G',
        'P',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'N',
        'S',
        'V',
        'V',
        'Y',
        'V',
        'S',
        'F',
        'G',
        'S',
        'V',
        'A',
        'N',
        'F',
        'D',
        'D',
        'E',
        'Q',
        'L',
        'M',
        'E',
        'I',
        'A',
        'T',
        'G',
        'L',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'G',
        'F',
        'E',
        'E',
        'R',
        'M',
        'E',
        'G',
        'K',
        'G',
        'V',
        'I',
        'V',
        'R',
        'G',
        'W',
        'A',
        'P',
        'Q',
        'I',
        'P',
        'I',
        'L',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'D',
        'E',
        'A',
        'E',
        'E',
        'M',
        'R',
        'S',
        'R',
        'V',
        'K',
        'E',
        'L',
        'A',
        'D',
        'K',
        'A',
        'R',
        'N',
        'A',
        'I',
        'M',
        'D',
        'G',
        'G',
        'S',
        'S',
        'I',
        'L',
        'D',
        'L',
        'E',
        'A',
        'L',
        'F',
        'H',
        'D',
        'L',
        'K',
        'S',
        'A',
        'S',
        'A',
        'T',
        'R',
        'K',
        'S',
        'L',
        'N',
        'S',
        'G',
        'N',
        'T',
        'P',
        'S',
        'Y',
        'I',
        'C',
        'K',
        'T',
        'S',
        'D',
        'L',
        'T',
        'Q',
        'K',
        'S',
        '.',
        'M',
        'A',
        'T',
        'K',
        'T',
        'Q',
        'N',
        'Q',
        'L',
        'H',
        'V',
        'F',
        'F',
        'F',
        'P',
        'F',
        'M',
        'A',
        'Q',
        'G',
        'H',
        'L',
        'I',
        'P',
        'A',
        'I',
        'D',
        'M',
        'A',
        'K',
        'L',
        'F',
        'A',
        'L',
        'R',
        'G',
        'Q',
        'R',
        'S',
        'T',
        'I',
        'I',
        'T',
        'T',
        'P',
        'Y',
        'F',
        'T',
        'P',
        'F',
        'L',
        'T',
        'K',
        'S',
        'L',
        'E',
        'K',
        'N',
        'R',
        'N',
        'L',
        'H',
        'T',
        'P',
        'V',
        'D',
        'I',
        'L',
        'T',
        'I',
        'K',
        'I',
        'P',
        'S',
        'S',
        'E',
        'A',
        'G',
        'F',
        'P',
        'K',
        'G',
        'I',
        'E',
        'S',
        'L',
        'D',
        'M',
        'A',
        'P',
        'T',
        'P',
        'Q',
        'V',
        'Q',
        'G',
        'K',
        'F',
        'F',
        'E',
        'A',
        'S',
        'G',
        'L',
        'F',
        'E',
        'P',
        'Q',
        'I',
        'D',
        'E',
        'L',
        'L',
        'E',
        'L',
        'Y',
        'R',
        'P',
        'D',
        'C',
        'L',
        'V',
        'A',
        'D',
        'I',
        'F',
        'F',
        'P',
        'W',
        'A',
        'T',
        'D',
        'V',
        'A',
        'A',
        'K',
        'Y',
        'G',
        'I',
        'P',
        'R',
        'L',
        'I',
        'F',
        'H',
        'G',
        'S',
        'S',
        'N',
        'F',
        'A',
        'M',
        'C',
        'C',
        'N',
        'L',
        'S',
        'V',
        'F',
        'R',
        'S',
        'K',
        'P',
        'Y',
        'K',
        'H',
        'V',
        'S',
        'S',
        'E',
        'Y',
        'E',
        'P',
        'F',
        'I',
        'I',
        'P',
        'N',
        'L',
        'P',
        'D',
        'K',
        'I',
        'E',
        'F',
        'T',
        'A',
        'S',
        'R',
        'V',
        'A',
        'D',
        'F',
        'I',
        'K',
        'E',
        'D',
        'S',
        'E',
        'T',
        'E',
        'T',
        'D',
        'H',
        'F',
        'T',
        'K',
        'M',
        'Y',
        'K',
        'V',
        'M',
        'K',
        'E',
        'V',
        'E',
        'L',
        'R',
        'S',
        'Y',
        'G',
        'I',
        'L',
        'V',
        'N',
        'S',
        'F',
        'Y',
        'E',
        'L',
        'E',
        'P',
        'A',
        'Y',
        'A',
        'D',
        'H',
        'Y',
        'P',
        'K',
        'V',
        'I',
        'Q',
        'G',
        'I',
        'K',
        'T',
        'W',
        'Q',
        'I',
        'G',
        'P',
        '.',
        'F',
        'L',
        'Y',
        'D',
        'K',
        'G',
        'L',
        'N',
        'L',
        'E',
        'E',
        'H',
        'D',
        'C',
        'L',
        'K',
        'W',
        'L',
        'H',
        'C',
        'K',
        'K',
        'P',
        'N',
        'S',
        'V',
        'V',
        'Y',
        'V',
        'S',
        'F',
        'G',
        'S',
        'V',
        'A',
        'N',
        'F',
        'D',
        'D',
        'E',
        'Q',
        'L',
        'M',
        'E',
        'I',
        'A',
        'T',
        'G',
        'L',
        'E',
        'A',
        'S',
        'G',
        'Q',
        'Q',
        'F',
        'I',
        'W',
        'V',
        'V',
        'R',
        'R',
        'E',
        'K',
        'K',
        'E',
        'G',
        'V',
        'S',
        'E',
        'E',
        'W',
        'L',
        'P',
        'E',
        'G',
        'F',
        'E',
        'E',
        'R',
        'M',
        'E',
        'G',
        'K',
        'G',
        'V',
        'I',
        'V',
        'R',
        'G',
        'W',
        'A',
        'P',
        'Q',
        'I',
        'P',
        'I',
        'L',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'D',
        'E',
        'A',
        'E',
        'E',
        'M',
        'R',
        'S',
        'R',
        'V',
        'K',
        'E',
        'L',
        'A',
        'D',
        'K',
        'A',
        'R',
        'N',
        'A',
        'I',
        'M',
        'D',
        'G',
        'G',
        'S',
        'S',
        'I',
        'L',
        'D',
        'L',
        'E',
        'A',
        'L',
        'F',
        'H',
        'D',
        'L',
        'K',
        'S',
        'A',
        'S',
        'A',
        'T',
        'R',
        'K',
        'S',
        'L',
        'N',
        'S',
        'G',
        'N',
        'T',
        'P',
        'S',
        'Y',
        'I',
        'C',
        'K',
        'T',
        'S',
        'D',
        'L',
        'T',
        'Q',
        'K',
        'S',
        '.',
        'M',
        'A',
        'T',
        'K',
        'T',
        'Q',
        'N',
        'Q',
        'L',
        'H',
        'V',
        'F',
        'F',
        'F',
        'P',
        'F',
        'M',
        'A',
        'Q',
        'G',
        'H',
        'L',
        'I',
        'P',
        'A',
        'I',
        'D',
        'M',
        'A',
        'K',
        'L',
        'F',
        'A',
        'L',
        'R',
        'G',
        'Q',
        'R',
        'S',
        'T',
        'I',
        'I',
        'T',
        'T',
        'P',
        'Y',
        'F',
        'T',
        'P',
        'F',
        'L',
        'T',
        'K',
        'S',
        'L',
        'E',
        'K',
        'N',
        'R',
        'N',
        'L',
        'H',
        'T',
        'P',
        'V',
        'D',
        'I',
        'L',
        'T',
        'I',
        'K',
        'I',
        'P',
        'S',
        'S',
        'E',
        'A',
        'G',
        'F',
        'P',
        'K',
        'G',
        'I',
        'E',
        'S',
        'L',
        'D',
        'M',
        'A',
        'P',
        'T',
        'P',
        'Q',
        'V',
        'Q',
        'G',
        'K',
        'F',
        'F',
        'E',
        'A',
        'S',
        'G',
        'L',
        'F',
        'E',
        'P',
        'Q',
        'I',
        'D',
        'E',
        'L',
        'L',
        'E',
        'L',
        'Y',
        'R',
        'P',
        'D',
        'C',
        'L',
        'V',
        'A',
        'D',
        'I',
        'F',
        'F',
        'P',
        'W',
        'A',
        'T',
        'D',
        'V',
        'A',
        'A',
        'K',
        'Y',
        'G',
        'I',
        'P',
        'R',
        'L',
        'I',
        'F',
        'H',
        'G',
        'S',
        'S',
        'N',
        'F',
        'A',
        'M',
        'C',
        'C',
        'N',
        'L',
        'S',
        'V',
        'F',
        'R',
        'S',
        'K',
        'P',
        'Y',
        'K',
        'H',
        'V',
        'S',
        'S',
        'E',
        'Y',
        'E',
        'P',
        'F',
        'I',
        'I',
        'P',
        'N',
        'L',
        'P',
        'D',
        'K',
        'I',
        'E',
        'F',
        'T',
        'A',
        'S',
        'R',
        'V',
        'A',
        'D',
        'F',
        'I',
        'K',
        'E',
        'D',
        'S',
        'E',
        'T',
        'E',
        'T',
        'D',
        'H',
        'F',
        'T',
        'K',
        'M',
        'Y',
        'K',
        'V',
        'M',
        'K',
        'E',
        'V',
        'E',
        'L',
        'R',
        'S',
        'Y',
        'G',
        'I',
        'L',
        'V',
        'N',
        'S',
        'F',
        'Y',
        'E',
        'L',
        'E',
        'P',
        'A',
        'Y',
        'A',
        'D',
        'H',
        'Y',
        'P',
        'K',
        'V',
        'I',
        'Q',
        'G',
        'I',
        'K',
        'T',
        'W',
        'Q',
        'I',
        'G',
        'P',
        '.',
        'F',
        'L',
        'Y',
        'D',
        'K',
        'G',
        'L',
        'N',
        'L',
        'E',
        'E',
        'H',
        'D',
        'C',
        'L',
        'K',
        'W',
        'L',
        'H',
        'C',
        'K',
        'K',
        'P',
        'N',
        'S',
        'V',
        'V',
        'Y',
        'V',
        'S',
        'F',
        'G',
        'S',
        'V',
        'A',
        'N',
        'F',
        'D',
        'D',
        'E',
        'Q',
        'L',
        'M',
        'E',
        'I',
        'A',
        'T',
        'G',
        'L',
        'E',
        'A',
        'S',
        'G',
        'Q',
        'Q',
        'F',
        'I',
        'W',
        'V',
        'V',
        'R',
        'R',
        'E',
        'K',
        'K',
        'E',
        'G',
        'V',
        'S',
        'E',
        'E',
        'W',
        'L',
        'P',
        'E',
        'G',
        'F',
        'E',
        'E',
        'R',
        'M',
        'E',
        'G',
        'K',
        'G',
        'V',
        'I',
        'V',
        'R',
        'G',
        'W',
        'A',
        'P',
        'Q',
        'I',
        'P',
        'I',
        'L',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        'D',
        'E',
        'A',
        'E',
        'E',
        'M',
        'R',
        'S',
        'R',
        'V',
        'K',
        'E',
        'L',
        'A',
        'D',
        'K',
        'A',
        'R',
        'N',
        'A',
        'I',
        'M',
        'D',
        'G',
        'G',
        'S',
        'S',
        'I',
        'L',
        'D',
        'L',
        'E',
        'A',
        'L',
        'F',
        'H',
        'D',
        'L',
        'K',
        'S',
        'A',
        'S',
        'A',
        'T',
        'R',
        'K',
        'S',
        'L',
        'N',
        'S',
        'G',
        'N',
        'T',
        'P',
        'S',
        'Y',
        'I',
        'C',
        'K',
        'T',
        'S',
        'D',
        'L',
        'T',
        'Q',
        'K',
        'S',
        'D',
        'M',
        'A',
        'T',
        'K',
        'T',
        'Q',
        'N',
        'Q',
        'L',
        'H',
        'V',
        'F',
        'F',
        'F',
        'P',
        'F',
        'M',
        'A',
        'Q',
        'G',
        'H',
        'L',
        'I',
        'P',
        'A',
        'I',
        'D',
        'M',
        'A',
        'K',
        'L',
        'F',
        'A',
        'L',
        'R',
        'G',
        'Q',
        'R',
        'S',
        'T',
        'I',
        'I',
        'T',
        'T',
        'P',
        'Y',
        'F',
        'T',
        'P',
        'F',
        'L',
        'T',
        'K',
        'S',
        'L',
        'E',
        'K',
        'N',
        'R',
        'N',
        'L',
        'H',
        'T',
        'P',
        'V',
        'D',
        'I',
        'L',
        'T',
        'I',
        'K',
        'I',
        'P',
        'S',
        'S',
        'E',
        'A',
        'G',
        'F',
        'P',
        'K',
        'G',
        'I',
        'E',
        'S',
        'L',
        'D',
        'M',
        'A',
        'P',
        'T',
        'P',
        'Q',
        'V',
        'Q',
        'G',
        'K',
        'F',
        'F',
        'E',
        'A',
        'S',
        'G',
        'L',
        'F',
        'E',
        'P',
        'Q',
        'I',
        'D',
        'E',
        'L',
        'L',
        'E',
        'L',
        'Y',
        'R',
        'P',
        'D',
        'C',
        'L',
        'V',
        'A',
        'D',
        'I',
        'F',
        'F',
        'P',
        'W',
        'A',
        'T',
        'D',
        'V',
        'A',
        'A',
        'K',
        'Y',
        'G',
        'I',
        'P',
        'R',
        'L',
        'I',
        'F',
        'H',
        'G',
        'S',
        'S',
        'N',
        'F',
        'A',
        'M',
        'C',
        'C',
        'N',
        'L',
        'S',
        'V',
        'F',
        'R',
        'S',
        'K',
        'P',
        'Y',
        'K',
        'H',
        'V',
        'S',
        'S',
        'E',
        'Y',
        'E',
        'P',
        'F',
        'I',
        'I',
        'P',
        'N',
        'L',
        'P',
        'D',
        'K',
        'I',
        'E',
        'F',
        'T',
        'A',
        'S',
        'R',
        'V',
        'A',
        'D',
        'F',
        'I',
        'K',
        'E',
        'D',
        'S',
        'E',
        'T',
        'E',
        'T',
        'D',
        'H',
        'F',
        'T',
        'K',
        'M',
        'Y',
        'K',
        'V',
        'M',
        'K',
        'E',
        'V',
        'E',
        'L',
        'R',
        'S',
        'Y',
        'G',
        'I',
        'L',
        'V',
        'N',
        'S',
        'F',
        'Y',
        'E',
        'L',
        'E',
        'P',
        'A',
        'Y',
        'A',
        'D',
        'H',
        'Y',
        'P',
        'K',
        'V',
        'I',
        'Q',
        'G',
        'I',
        'K',
        'T',
        'W',
        'Q',
        'I',
        'G',
        'P',
        'L',
        'F',
        'L',
        'Y',
        'D',
        'K',
        'G',
        'L',
        'N',
        'L',
        'E',
        'E',
        'H',
        'D',
        'C',
        'L',
        'K',
        'W',
        'L',
        'H',
        'C',
        'K',
        'K',
        'P',
        'N',
        'S',
        'V',
        'V',
        'Y',
        'V',
        'S',
        'F',
        'G',
        'S',
        'V',
        'A',
        'N',
        'F',
        'D',
        'D',
        'E',
        'Q',
        'L',
        'M',
        'E',
        'I',
        'A',
        'T',
        'G',
        'L',
        'E',
        'A',
        'S',
        'G',
        'Q',
        'Q',
        'F',
        'I',
        'W',
        'V',
        'V',
        'R',
        'R',
        'E',
        'K',
        'K',
        'E',
        'G',
        'V',
        'S',
        'E',
        'E',
        'W',
        'L',
        'P',
        'E',
        'G',
        'F',
        'E',
        'E',
        'R',
        'M',
        'E',
        'G',
        'K',
        'G',
        'V',
        'I',
        'V',
        'R',
        'G',
        'W',
        'A',
        'P',
        'Q',
        'I',
        'P',
        'I',
        'L',
        'E',
        'H',
        'E',
        'A',
        'I',
        'G',
        'G',
        'F',
        'L',
        'T',
        'H',
        'C',
        'G',
        'W',
        'N',
        'S',
        'T',
        'L',
        'E',
        'S',
        'I',
        'C',
        'A',
        'G',
        'V',
        'P',
        'M',
        'V',
        'T',
        'W',
        'P',
        'V',
        'S',
        'A',
        'E',
        'Q',
        'F',
        'C',
        'N',
        'E',
        'K',
        'L',
        'V',
        'S',
        'E',
        'I',
        'L',
        'R',
        'V',
        'G',
        'I',
        'E',
        'V',
        'G',
        'A',
        'K',
        'K',
        'W',
        'K',
        'V',
        'L',
        'V',
        'G',
        'D',
        'F',
        'V',
        'K',
        'R',
        'D',
        'A',
        'I',
        'E',
        'R',
        'A',
        'V',
        'T',
        'R',
        'L',
        'M',
        'K',
        'G',
        'D',
        'E',
        'A',
        'E',
        'E',
        'M',
        'R',
        'S',
        'R',
        'V',
        'K',
        'E',
        'L',
        'A',
        'D',
        'K',
        'A',
        'R',
        'N',
        'A',
        'I',
        'M',
        'D',
        'G',
        'G',
        'S',
        'S',
        'I',
        'L',
        'D',
        'L',
        'E',
        'A',
        'L',
        'F',
        'H',
        'D',
        'L',
        'K',
        'S',
        'A',
        'S',
        'A',
        'T',
        'R',
        'K',
      ],
      type: 'scatter',
      x: [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        59,
        60,
        61,
        62,
        63,
        64,
        65,
        66,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        75,
        76,
        77,
        78,
        79,
        80,
        81,
        82,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        91,
        92,
        93,
        94,
        95,
        96,
        97,
        98,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        107,
        108,
        109,
        110,
        111,
        112,
        113,
        114,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        123,
        124,
        125,
        126,
        127,
        128,
        129,
        130,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        139,
        140,
        141,
        142,
        143,
        144,
        145,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        155,
        156,
        157,
        158,
        159,
        160,
        161,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        171,
        172,
        173,
        174,
        175,
        176,
        177,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        187,
        188,
        189,
        190,
        191,
        192,
        193,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        203,
        204,
        205,
        206,
        207,
        208,
        209,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        219,
        220,
        221,
        222,
        223,
        224,
        225,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        235,
        236,
        237,
        238,
        239,
        240,
        241,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250,
        251,
        252,
        253,
        254,
        255,
        256,
        257,
        258,
        259,
        260,
        261,
        262,
        263,
        264,
        265,
        266,
        267,
        268,
        269,
        270,
        271,
        272,
        273,
        274,
        275,
        276,
        277,
        278,
        279,
        280,
        281,
        282,
        283,
        284,
        285,
        286,
        287,
        288,
        289,
        290,
        291,
        292,
        293,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        307,
        308,
        309,
        310,
        311,
        312,
        313,
        314,
        315,
        316,
        317,
        318,
        319,
        320,
        321,
        322,
        323,
        324,
        325,
        326,
        327,
        328,
        329,
        330,
        331,
        332,
        333,
        334,
        335,
        336,
        337,
        338,
        339,
        340,
        341,
        342,
        343,
        344,
        345,
        346,
        347,
        348,
        349,
        350,
        351,
        352,
        353,
        354,
        355,
        356,
        357,
        358,
        359,
        360,
        361,
        362,
        363,
        364,
        365,
        366,
        367,
        368,
        369,
        370,
        371,
        372,
        373,
        374,
        375,
        376,
        377,
        378,
        379,
        380,
        381,
        382,
        383,
        384,
        385,
        386,
        387,
        388,
        389,
        390,
        391,
        392,
        393,
        394,
        395,
        396,
        397,
        398,
        399,
        400,
        401,
        402,
        403,
        404,
        405,
        406,
        407,
        408,
        409,
        410,
        411,
        412,
        413,
        414,
        415,
        416,
        417,
        418,
        419,
        420,
        421,
        422,
        423,
        424,
        425,
        426,
        427,
        428,
        429,
        430,
        431,
        432,
        433,
        434,
        435,
        436,
        437,
        438,
        439,
        440,
        441,
        442,
        443,
        444,
        445,
        446,
        447,
        448,
        449,
        450,
        451,
        452,
        453,
        454,
        455,
        456,
        457,
        458,
        459,
        460,
        461,
        462,
        463,
        464,
        465,
        466,
        467,
        468,
        469,
        470,
        471,
        472,
        473,
        474,
        475,
        476,
        477,
        478,
        479,
        480,
        481,
        482,
        483,
        484,
        485,
        486,
        487,
        488,
        489,
        490,
        491,
        492,
        493,
        494,
        495,
        496,
        497,
        498,
        499,
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        59,
        60,
        61,
        62,
        63,
        64,
        65,
        66,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        75,
        76,
        77,
        78,
        79,
        80,
        81,
        82,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        91,
        92,
        93,
        94,
        95,
        96,
        97,
        98,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        107,
        108,
        109,
        110,
        111,
        112,
        113,
        114,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        123,
        124,
        125,
        126,
        127,
        128,
        129,
        130,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        139,
        140,
        141,
        142,
        143,
        144,
        145,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        155,
        156,
        157,
        158,
        159,
        160,
        161,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        171,
        172,
        173,
        174,
        175,
        176,
        177,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        187,
        188,
        189,
        190,
        191,
        192,
        193,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        203,
        204,
        205,
        206,
        207,
        208,
        209,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        219,
        220,
        221,
        222,
        223,
        224,
        225,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        235,
        236,
        237,
        238,
        239,
        240,
        241,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250,
        251,
        252,
        253,
        254,
        255,
        256,
        257,
        258,
        259,
        260,
        261,
        262,
        263,
        264,
        265,
        266,
        267,
        268,
        269,
        270,
        271,
        272,
        273,
        274,
        275,
        276,
        277,
        278,
        279,
        280,
        281,
        282,
        283,
        284,
        285,
        286,
        287,
        288,
        289,
        290,
        291,
        292,
        293,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        307,
        308,
        309,
        310,
        311,
        312,
        313,
        314,
        315,
        316,
        317,
        318,
        319,
        320,
        321,
        322,
        323,
        324,
        325,
        326,
        327,
        328,
        329,
        330,
        331,
        332,
        333,
        334,
        335,
        336,
        337,
        338,
        339,
        340,
        341,
        342,
        343,
        344,
        345,
        346,
        347,
        348,
        349,
        350,
        351,
        352,
        353,
        354,
        355,
        356,
        357,
        358,
        359,
        360,
        361,
        362,
        363,
        364,
        365,
        366,
        367,
        368,
        369,
        370,
        371,
        372,
        373,
        374,
        375,
        376,
        377,
        378,
        379,
        380,
        381,
        382,
        383,
        384,
        385,
        386,
        387,
        388,
        389,
        390,
        391,
        392,
        393,
        394,
        395,
        396,
        397,
        398,
        399,
        400,
        401,
        402,
        403,
        404,
        405,
        406,
        407,
        408,
        409,
        410,
        411,
        412,
        413,
        414,
        415,
        416,
        417,
        418,
        419,
        420,
        421,
        422,
        423,
        424,
        425,
        426,
        427,
        428,
        429,
        430,
        431,
        432,
        433,
        434,
        435,
        436,
        437,
        438,
        439,
        440,
        441,
        442,
        443,
        444,
        445,
        446,
        447,
        448,
        449,
        450,
        451,
        452,
        453,
        454,
        455,
        456,
        457,
        458,
        459,
        460,
        461,
        462,
        463,
        464,
        465,
        466,
        467,
        468,
        469,
        470,
        471,
        472,
        473,
        474,
        475,
        476,
        477,
        478,
        479,
        480,
        481,
        482,
        483,
        484,
        485,
        486,
        487,
        488,
        489,
        490,
        491,
        492,
        493,
        494,
        495,
        496,
        497,
        498,
        499,
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        59,
        60,
        61,
        62,
        63,
        64,
        65,
        66,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        75,
        76,
        77,
        78,
        79,
        80,
        81,
        82,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        91,
        92,
        93,
        94,
        95,
        96,
        97,
        98,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        107,
        108,
        109,
        110,
        111,
        112,
        113,
        114,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        123,
        124,
        125,
        126,
        127,
        128,
        129,
        130,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        139,
        140,
        141,
        142,
        143,
        144,
        145,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        155,
        156,
        157,
        158,
        159,
        160,
        161,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        171,
        172,
        173,
        174,
        175,
        176,
        177,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        187,
        188,
        189,
        190,
        191,
        192,
        193,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        203,
        204,
        205,
        206,
        207,
        208,
        209,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        219,
        220,
        221,
        222,
        223,
        224,
        225,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        235,
        236,
        237,
        238,
        239,
        240,
        241,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250,
        251,
        252,
        253,
        254,
        255,
        256,
        257,
        258,
        259,
        260,
        261,
        262,
        263,
        264,
        265,
        266,
        267,
        268,
        269,
        270,
        271,
        272,
        273,
        274,
        275,
        276,
        277,
        278,
        279,
        280,
        281,
        282,
        283,
        284,
        285,
        286,
        287,
        288,
        289,
        290,
        291,
        292,
        293,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        307,
        308,
        309,
        310,
        311,
        312,
        313,
        314,
        315,
        316,
        317,
        318,
        319,
        320,
        321,
        322,
        323,
        324,
        325,
        326,
        327,
        328,
        329,
        330,
        331,
        332,
        333,
        334,
        335,
        336,
        337,
        338,
        339,
        340,
        341,
        342,
        343,
        344,
        345,
        346,
        347,
        348,
        349,
        350,
        351,
        352,
        353,
        354,
        355,
        356,
        357,
        358,
        359,
        360,
        361,
        362,
        363,
        364,
        365,
        366,
        367,
        368,
        369,
        370,
        371,
        372,
        373,
        374,
        375,
        376,
        377,
        378,
        379,
        380,
        381,
        382,
        383,
        384,
        385,
        386,
        387,
        388,
        389,
        390,
        391,
        392,
        393,
        394,
        395,
        396,
        397,
        398,
        399,
        400,
        401,
        402,
        403,
        404,
        405,
        406,
        407,
        408,
        409,
        410,
        411,
        412,
        413,
        414,
        415,
        416,
        417,
        418,
        419,
        420,
        421,
        422,
        423,
        424,
        425,
        426,
        427,
        428,
        429,
        430,
        431,
        432,
        433,
        434,
        435,
        436,
        437,
        438,
        439,
        440,
        441,
        442,
        443,
        444,
        445,
        446,
        447,
        448,
        449,
        450,
        451,
        452,
        453,
        454,
        455,
        456,
        457,
        458,
        459,
        460,
        461,
        462,
        463,
        464,
        465,
        466,
        467,
        468,
        469,
        470,
        471,
        472,
        473,
        474,
        475,
        476,
        477,
        478,
        479,
        480,
        481,
        482,
        483,
        484,
        485,
        486,
        487,
        488,
        489,
        490,
        491,
        492,
        493,
        494,
        495,
        496,
        497,
        498,
        499,
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        59,
        60,
        61,
        62,
        63,
        64,
        65,
        66,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        75,
        76,
        77,
        78,
        79,
        80,
        81,
        82,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        91,
        92,
        93,
        94,
        95,
        96,
        97,
        98,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        107,
        108,
        109,
        110,
        111,
        112,
        113,
        114,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        123,
        124,
        125,
        126,
        127,
        128,
        129,
        130,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        139,
        140,
        141,
        142,
        143,
        144,
        145,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        155,
        156,
        157,
        158,
        159,
        160,
        161,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        171,
        172,
        173,
        174,
        175,
        176,
        177,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        187,
        188,
        189,
        190,
        191,
        192,
        193,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        203,
        204,
        205,
        206,
        207,
        208,
        209,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        219,
        220,
        221,
        222,
        223,
        224,
        225,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        235,
        236,
        237,
        238,
        239,
        240,
        241,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250,
        251,
        252,
        253,
        254,
        255,
        256,
        257,
        258,
        259,
        260,
        261,
        262,
        263,
        264,
        265,
        266,
        267,
        268,
        269,
        270,
        271,
        272,
        273,
        274,
        275,
        276,
        277,
        278,
        279,
        280,
        281,
        282,
        283,
        284,
        285,
        286,
        287,
        288,
        289,
        290,
        291,
        292,
        293,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        307,
        308,
        309,
        310,
        311,
        312,
        313,
        314,
        315,
        316,
        317,
        318,
        319,
        320,
        321,
        322,
        323,
        324,
        325,
        326,
        327,
        328,
        329,
        330,
        331,
        332,
        333,
        334,
        335,
        336,
        337,
        338,
        339,
        340,
        341,
        342,
        343,
        344,
        345,
        346,
        347,
        348,
        349,
        350,
        351,
        352,
        353,
        354,
        355,
        356,
        357,
        358,
        359,
        360,
        361,
        362,
        363,
        364,
        365,
        366,
        367,
        368,
        369,
        370,
        371,
        372,
        373,
        374,
        375,
        376,
        377,
        378,
        379,
        380,
        381,
        382,
        383,
        384,
        385,
        386,
        387,
        388,
        389,
        390,
        391,
        392,
        393,
        394,
        395,
        396,
        397,
        398,
        399,
        400,
        401,
        402,
        403,
        404,
        405,
        406,
        407,
        408,
        409,
        410,
        411,
        412,
        413,
        414,
        415,
        416,
        417,
        418,
        419,
        420,
        421,
        422,
        423,
        424,
        425,
        426,
        427,
        428,
        429,
        430,
        431,
        432,
        433,
        434,
        435,
        436,
        437,
        438,
        439,
        440,
        441,
        442,
        443,
        444,
        445,
        446,
        447,
        448,
        449,
        450,
        451,
        452,
        453,
        454,
        455,
        456,
        457,
        458,
        459,
        460,
        461,
        462,
        463,
        464,
        465,
        466,
        467,
        468,
        469,
        470,
        471,
        472,
        473,
        474,
        475,
        476,
        477,
        478,
        479,
        480,
        481,
        482,
        483,
        484,
        485,
        486,
        487,
        488,
        489,
        490,
        491,
        492,
        493,
        494,
        495,
        496,
        497,
        498,
        499,
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        59,
        60,
        61,
        62,
        63,
        64,
        65,
        66,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        75,
        76,
        77,
        78,
        79,
        80,
        81,
        82,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        91,
        92,
        93,
        94,
        95,
        96,
        97,
        98,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        107,
        108,
        109,
        110,
        111,
        112,
        113,
        114,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        123,
        124,
        125,
        126,
        127,
        128,
        129,
        130,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        139,
        140,
        141,
        142,
        143,
        144,
        145,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        155,
        156,
        157,
        158,
        159,
        160,
        161,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        171,
        172,
        173,
        174,
        175,
        176,
        177,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        187,
        188,
        189,
        190,
        191,
        192,
        193,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        203,
        204,
        205,
        206,
        207,
        208,
        209,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        219,
        220,
        221,
        222,
        223,
        224,
        225,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        235,
        236,
        237,
        238,
        239,
        240,
        241,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250,
        251,
        252,
        253,
        254,
        255,
        256,
        257,
        258,
        259,
        260,
        261,
        262,
        263,
        264,
        265,
        266,
        267,
        268,
        269,
        270,
        271,
        272,
        273,
        274,
        275,
        276,
        277,
        278,
        279,
        280,
        281,
        282,
        283,
        284,
        285,
        286,
        287,
        288,
        289,
        290,
        291,
        292,
        293,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        307,
        308,
        309,
        310,
        311,
        312,
        313,
        314,
        315,
        316,
        317,
        318,
        319,
        320,
        321,
        322,
        323,
        324,
        325,
        326,
        327,
        328,
        329,
        330,
        331,
        332,
        333,
        334,
        335,
        336,
        337,
        338,
        339,
        340,
        341,
        342,
        343,
        344,
        345,
        346,
        347,
        348,
        349,
        350,
        351,
        352,
        353,
        354,
        355,
        356,
        357,
        358,
        359,
        360,
        361,
        362,
        363,
        364,
        365,
        366,
        367,
        368,
        369,
        370,
        371,
        372,
        373,
        374,
        375,
        376,
        377,
        378,
        379,
        380,
        381,
        382,
        383,
        384,
        385,
        386,
        387,
        388,
        389,
        390,
        391,
        392,
        393,
        394,
        395,
        396,
        397,
        398,
        399,
        400,
        401,
        402,
        403,
        404,
        405,
        406,
        407,
        408,
        409,
        410,
        411,
        412,
        413,
        414,
        415,
        416,
        417,
        418,
        419,
        420,
        421,
        422,
        423,
        424,
        425,
        426,
        427,
        428,
        429,
        430,
        431,
        432,
        433,
        434,
        435,
        436,
        437,
        438,
        439,
        440,
        441,
        442,
        443,
        444,
        445,
        446,
        447,
        448,
        449,
        450,
        451,
        452,
        453,
        454,
        455,
        456,
        457,
        458,
        459,
        460,
        461,
        462,
        463,
        464,
        465,
        466,
        467,
        468,
        469,
        470,
        471,
        472,
        473,
        474,
        475,
        476,
        477,
        478,
        479,
        480,
        481,
        482,
        483,
        484,
        485,
        486,
        487,
        488,
        489,
        490,
        491,
        492,
        493,
        494,
        495,
        496,
        497,
        498,
        499,
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        59,
        60,
        61,
        62,
        63,
        64,
        65,
        66,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        75,
        76,
        77,
        78,
        79,
        80,
        81,
        82,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        91,
        92,
        93,
        94,
        95,
        96,
        97,
        98,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        107,
        108,
        109,
        110,
        111,
        112,
        113,
        114,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        123,
        124,
        125,
        126,
        127,
        128,
        129,
        130,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        139,
        140,
        141,
        142,
        143,
        144,
        145,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        155,
        156,
        157,
        158,
        159,
        160,
        161,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        171,
        172,
        173,
        174,
        175,
        176,
        177,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        187,
        188,
        189,
        190,
        191,
        192,
        193,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        203,
        204,
        205,
        206,
        207,
        208,
        209,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        219,
        220,
        221,
        222,
        223,
        224,
        225,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        235,
        236,
        237,
        238,
        239,
        240,
        241,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250,
        251,
        252,
        253,
        254,
        255,
        256,
        257,
        258,
        259,
        260,
        261,
        262,
        263,
        264,
        265,
        266,
        267,
        268,
        269,
        270,
        271,
        272,
        273,
        274,
        275,
        276,
        277,
        278,
        279,
        280,
        281,
        282,
        283,
        284,
        285,
        286,
        287,
        288,
        289,
        290,
        291,
        292,
        293,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        307,
        308,
        309,
        310,
        311,
        312,
        313,
        314,
        315,
        316,
        317,
        318,
        319,
        320,
        321,
        322,
        323,
        324,
        325,
        326,
        327,
        328,
        329,
        330,
        331,
        332,
        333,
        334,
        335,
        336,
        337,
        338,
        339,
        340,
        341,
        342,
        343,
        344,
        345,
        346,
        347,
        348,
        349,
        350,
        351,
        352,
        353,
        354,
        355,
        356,
        357,
        358,
        359,
        360,
        361,
        362,
        363,
        364,
        365,
        366,
        367,
        368,
        369,
        370,
        371,
        372,
        373,
        374,
        375,
        376,
        377,
        378,
        379,
        380,
        381,
        382,
        383,
        384,
        385,
        386,
        387,
        388,
        389,
        390,
        391,
        392,
        393,
        394,
        395,
        396,
        397,
        398,
        399,
        400,
        401,
        402,
        403,
        404,
        405,
        406,
        407,
        408,
        409,
        410,
        411,
        412,
        413,
        414,
        415,
        416,
        417,
        418,
        419,
        420,
        421,
        422,
        423,
        424,
        425,
        426,
        427,
        428,
        429,
        430,
        431,
        432,
        433,
        434,
        435,
        436,
        437,
        438,
        439,
        440,
        441,
        442,
        443,
        444,
        445,
        446,
        447,
        448,
        449,
        450,
        451,
        452,
        453,
        454,
        455,
        456,
        457,
        458,
        459,
        460,
        461,
        462,
        463,
        464,
        465,
        466,
        467,
        468,
        469,
        470,
        471,
        472,
        473,
        474,
        475,
        476,
        477,
        478,
        479,
        480,
        481,
        482,
        483,
        484,
        485,
        486,
        487,
        488,
        489,
        490,
        491,
        492,
        493,
        494,
        495,
        496,
        497,
        498,
        499,
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        59,
        60,
        61,
        62,
        63,
        64,
        65,
        66,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        75,
        76,
        77,
        78,
        79,
        80,
        81,
        82,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        91,
        92,
        93,
        94,
        95,
        96,
        97,
        98,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        107,
        108,
        109,
        110,
        111,
        112,
        113,
        114,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        123,
        124,
        125,
        126,
        127,
        128,
        129,
        130,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        139,
        140,
        141,
        142,
        143,
        144,
        145,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        155,
        156,
        157,
        158,
        159,
        160,
        161,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        171,
        172,
        173,
        174,
        175,
        176,
        177,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        187,
        188,
        189,
        190,
        191,
        192,
        193,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        203,
        204,
        205,
        206,
        207,
        208,
        209,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        219,
        220,
        221,
        222,
        223,
        224,
        225,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        235,
        236,
        237,
        238,
        239,
        240,
        241,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250,
        251,
        252,
        253,
        254,
        255,
        256,
        257,
        258,
        259,
        260,
        261,
        262,
        263,
        264,
        265,
        266,
        267,
        268,
        269,
        270,
        271,
        272,
        273,
        274,
        275,
        276,
        277,
        278,
        279,
        280,
        281,
        282,
        283,
        284,
        285,
        286,
        287,
        288,
        289,
        290,
        291,
        292,
        293,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        307,
        308,
        309,
        310,
        311,
        312,
        313,
        314,
        315,
        316,
        317,
        318,
        319,
        320,
        321,
        322,
        323,
        324,
        325,
        326,
        327,
        328,
        329,
        330,
        331,
        332,
        333,
        334,
        335,
        336,
        337,
        338,
        339,
        340,
        341,
        342,
        343,
        344,
        345,
        346,
        347,
        348,
        349,
        350,
        351,
        352,
        353,
        354,
        355,
        356,
        357,
        358,
        359,
        360,
        361,
        362,
        363,
        364,
        365,
        366,
        367,
        368,
        369,
        370,
        371,
        372,
        373,
        374,
        375,
        376,
        377,
        378,
        379,
        380,
        381,
        382,
        383,
        384,
        385,
        386,
        387,
        388,
        389,
        390,
        391,
        392,
        393,
        394,
        395,
        396,
        397,
        398,
        399,
        400,
        401,
        402,
        403,
        404,
        405,
        406,
        407,
        408,
        409,
        410,
        411,
        412,
        413,
        414,
        415,
        416,
        417,
        418,
        419,
        420,
        421,
        422,
        423,
        424,
        425,
        426,
        427,
        428,
        429,
        430,
        431,
        432,
        433,
        434,
        435,
        436,
        437,
        438,
        439,
        440,
        441,
        442,
        443,
        444,
        445,
        446,
        447,
        448,
        449,
        450,
        451,
        452,
        453,
        454,
        455,
        456,
        457,
        458,
        459,
        460,
        461,
        462,
        463,
        464,
        465,
        466,
        467,
        468,
        469,
        470,
        471,
        472,
        473,
        474,
        475,
        476,
        477,
        478,
        479,
        480,
        481,
        482,
        483,
        484,
        485,
        486,
        487,
        488,
        489,
        490,
        491,
        492,
        493,
        494,
        495,
        496,
        497,
        498,
        499,
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        59,
        60,
        61,
        62,
        63,
        64,
        65,
        66,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        75,
        76,
        77,
        78,
        79,
        80,
        81,
        82,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        91,
        92,
        93,
        94,
        95,
        96,
        97,
        98,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        107,
        108,
        109,
        110,
        111,
        112,
        113,
        114,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        123,
        124,
        125,
        126,
        127,
        128,
        129,
        130,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        139,
        140,
        141,
        142,
        143,
        144,
        145,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        155,
        156,
        157,
        158,
        159,
        160,
        161,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        171,
        172,
        173,
        174,
        175,
        176,
        177,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        187,
        188,
        189,
        190,
        191,
        192,
        193,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        203,
        204,
        205,
        206,
        207,
        208,
        209,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        219,
        220,
        221,
        222,
        223,
        224,
        225,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        235,
        236,
        237,
        238,
        239,
        240,
        241,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250,
        251,
        252,
        253,
        254,
        255,
        256,
        257,
        258,
        259,
        260,
        261,
        262,
        263,
        264,
        265,
        266,
        267,
        268,
        269,
        270,
        271,
        272,
        273,
        274,
        275,
        276,
        277,
        278,
        279,
        280,
        281,
        282,
        283,
        284,
        285,
        286,
        287,
        288,
        289,
        290,
        291,
        292,
        293,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        307,
        308,
        309,
        310,
        311,
        312,
        313,
        314,
        315,
        316,
        317,
        318,
        319,
        320,
        321,
        322,
        323,
        324,
        325,
        326,
        327,
        328,
        329,
        330,
        331,
        332,
        333,
        334,
        335,
        336,
        337,
        338,
        339,
        340,
        341,
        342,
        343,
        344,
        345,
        346,
        347,
        348,
        349,
        350,
        351,
        352,
        353,
        354,
        355,
        356,
        357,
        358,
        359,
        360,
        361,
        362,
        363,
        364,
        365,
        366,
        367,
        368,
        369,
        370,
        371,
        372,
        373,
        374,
        375,
        376,
        377,
        378,
        379,
        380,
        381,
        382,
        383,
        384,
        385,
        386,
        387,
        388,
        389,
        390,
        391,
        392,
        393,
        394,
        395,
        396,
        397,
        398,
        399,
        400,
        401,
        402,
        403,
        404,
        405,
        406,
        407,
        408,
        409,
        410,
        411,
        412,
        413,
        414,
        415,
        416,
        417,
        418,
        419,
        420,
        421,
        422,
        423,
        424,
        425,
        426,
        427,
        428,
        429,
        430,
        431,
        432,
        433,
        434,
        435,
        436,
        437,
        438,
        439,
        440,
        441,
        442,
        443,
        444,
        445,
        446,
        447,
        448,
        449,
        450,
        451,
        452,
        453,
        454,
        455,
        456,
        457,
        458,
        459,
        460,
        461,
        462,
        463,
        464,
        465,
        466,
        467,
        468,
        469,
        470,
        471,
        472,
        473,
        474,
        475,
        476,
        477,
        478,
        479,
        480,
        481,
        482,
        483,
        484,
        485,
        486,
        487,
        488,
        489,
        490,
        491,
        492,
        493,
        494,
        495,
        496,
        497,
        498,
        499,
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        59,
        60,
        61,
        62,
        63,
        64,
        65,
        66,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        75,
        76,
        77,
        78,
        79,
        80,
        81,
        82,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        91,
        92,
        93,
        94,
        95,
        96,
        97,
        98,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        107,
        108,
        109,
        110,
        111,
        112,
        113,
        114,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        123,
        124,
        125,
        126,
        127,
        128,
        129,
        130,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        139,
        140,
        141,
        142,
        143,
        144,
        145,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        155,
        156,
        157,
        158,
        159,
        160,
        161,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        171,
        172,
        173,
        174,
        175,
        176,
        177,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        187,
        188,
        189,
        190,
        191,
        192,
        193,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        203,
        204,
        205,
        206,
        207,
        208,
        209,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        219,
        220,
        221,
        222,
        223,
        224,
        225,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        235,
        236,
        237,
        238,
        239,
        240,
        241,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250,
        251,
        252,
        253,
        254,
        255,
        256,
        257,
        258,
        259,
        260,
        261,
        262,
        263,
        264,
        265,
        266,
        267,
        268,
        269,
        270,
        271,
        272,
        273,
        274,
        275,
        276,
        277,
        278,
        279,
        280,
        281,
        282,
        283,
        284,
        285,
        286,
        287,
        288,
        289,
        290,
        291,
        292,
        293,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        307,
        308,
        309,
        310,
        311,
        312,
        313,
        314,
        315,
        316,
        317,
        318,
        319,
        320,
        321,
        322,
        323,
        324,
        325,
        326,
        327,
        328,
        329,
        330,
        331,
        332,
        333,
        334,
        335,
        336,
        337,
        338,
        339,
        340,
        341,
        342,
        343,
        344,
        345,
        346,
        347,
        348,
        349,
        350,
        351,
        352,
        353,
        354,
        355,
        356,
        357,
        358,
        359,
        360,
        361,
        362,
        363,
        364,
        365,
        366,
        367,
        368,
        369,
        370,
        371,
        372,
        373,
        374,
        375,
        376,
        377,
        378,
        379,
        380,
        381,
        382,
        383,
        384,
        385,
        386,
        387,
        388,
        389,
        390,
        391,
        392,
        393,
        394,
        395,
        396,
        397,
        398,
        399,
        400,
        401,
        402,
        403,
        404,
        405,
        406,
        407,
        408,
        409,
        410,
        411,
        412,
        413,
        414,
        415,
        416,
        417,
        418,
        419,
        420,
        421,
        422,
        423,
        424,
        425,
        426,
        427,
        428,
        429,
        430,
        431,
        432,
        433,
        434,
        435,
        436,
        437,
        438,
        439,
        440,
        441,
        442,
        443,
        444,
        445,
        446,
        447,
        448,
        449,
        450,
        451,
        452,
        453,
        454,
        455,
        456,
        457,
        458,
        459,
        460,
        461,
        462,
        463,
        464,
        465,
        466,
        467,
        468,
        469,
        470,
        471,
        472,
        473,
        474,
        475,
        476,
        477,
        478,
        479,
        480,
        481,
        482,
        483,
        484,
        485,
        486,
        487,
        488,
        489,
        490,
        491,
        492,
        493,
        494,
        495,
        496,
        497,
        498,
        499,
      ],
      y: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8,
      ],
    },
  ],
  layout: {
    height: 225,
    margin: {
      b: 30,
      l: 180,
      r: 30,
      t: 50,
    },
    title:
      'Alignment of the amino acid sequences for the selected Enzyme/Transcript',
    width: 5900,
    xaxis: {
      range: [-0.5, 500.5],
      showgrid: false,
      showline: false,
      showticklabels: true,
      tickvals: [
        0,
        20,
        40,
        60,
        80,
        100,
        120,
        140,
        160,
        180,
        200,
        220,
        240,
        260,
        280,
        300,
        320,
        340,
        360,
        380,
        400,
        420,
        440,
        460,
        480,
        500,
      ],
      zeroline: false,
    },
    yaxis: {
      showgrid: false,
      showline: false,
      tickmode: 'array',
      ticktext: [
        'SRR3996360_haplotype2',
        'SRR3996360_haplotype1',
        'SRR3996359_haplotype2',
        'SRR3996359_haplotype1',
        'SRR5210004_haplotype2',
        'SRR5210004_haplotype1',
        'SRR3996358_haplotype2',
        'SRR3996358_haplotype1',
        'PRO02636.1',
      ],
      tickvals: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      zeroline: false,
    },
  },
};
export const alignment2 = {
  data: [
    {
      cells: [
        [
          'SRR3996360_haplotype2',
          'S',
          'L',
          'N',
          'S',
          'G',
          'N',
          'T',
          'P',
          'S',
          'Y',
          'I',
          'C',
          'K',
          'T',
          'S',
          'D',
          'L',
          'T',
          'Q',
          'K',
          'S',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'A',
          'I',
          'D',
          'M',
          'A',
          'K',
          'L',
          'F',
          'A',
          'L',
          'R',
          'G',
          'Q',
          'R',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'V',
          'D',
          'I',
          'L',
          'T',
          'I',
          'K',
          'I',
          'P',
          'S',
          'S',
          'E',
          'A',
          'G',
          'F',
          'P',
          'K',
          'G',
          'I',
          'E',
          'S',
          'L',
          'D',
          'M',
          'A',
          'P',
          'T',
          'P',
          'Q',
          'V',
          'Q',
          'G',
          'K',
          'F',
          'F',
          'E',
          'A',
          'S',
          'G',
          'L',
          'F',
          'E',
          'P',
          'Q',
          'I',
          'D',
          'E',
          'L',
          'L',
          'E',
          'L',
          'Y',
          'R',
          'P',
          'D',
          'C',
          'L',
          'V',
          'A',
          'D',
          'I',
          'F',
          'F',
          'P',
          'W',
          'A',
          'T',
          'D',
          'V',
          'A',
          'A',
          'K',
          'Y',
          'G',
          'I',
          'P',
          'R',
          'L',
          'I',
          'F',
          'H',
          'G',
          'S',
          'S',
          'N',
          'F',
          'A',
          'M',
          'C',
          'C',
          'N',
          'L',
          'S',
          'V',
          'F',
          'R',
          'S',
          'K',
          'P',
          'Y',
          'K',
          'H',
          'V',
          'S',
          'S',
          'E',
          'Y',
          'E',
          'P',
          'F',
          'I',
          'I',
          'P',
          'N',
          'L',
          'P',
          'D',
          'K',
          'I',
          'E',
          'F',
          'T',
          'A',
          'S',
          'R',
          'V',
          'A',
          'D',
          'F',
          'I',
          'K',
          'E',
          'D',
          'S',
          'E',
          'T',
          'E',
          'T',
          'D',
          'H',
          'F',
          'T',
          'K',
          'M',
          'Y',
          'K',
          'V',
          'M',
          'K',
          'E',
          'V',
          'E',
          'L',
          'R',
          'S',
          'Y',
          'G',
          'I',
          'L',
          'V',
          'N',
          'S',
          'F',
          'Y',
          'E',
          'L',
          'E',
          'P',
          'A',
          'Y',
          'A',
          'D',
          'H',
          'Y',
          'P',
          'K',
          'V',
          'I',
          'Q',
          'G',
          'I',
          'K',
          'T',
          'W',
          'Q',
          'I',
          'G',
          'P',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'N',
          'S',
          'V',
          'V',
          'Y',
          'V',
          'S',
          'F',
          'G',
          'S',
          'V',
          'A',
          'N',
          'F',
          'D',
          'D',
          'E',
          'Q',
          'L',
          'M',
          'E',
          'I',
          'A',
          'T',
          'G',
          'L',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'G',
          'F',
          'E',
          'E',
          'R',
          'M',
          'E',
          'G',
          'K',
          'G',
          'V',
          'I',
          'V',
          'R',
          'G',
          'W',
          'A',
          'P',
          'Q',
          'I',
          'P',
          'I',
          'L',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'D',
          'E',
          'A',
          'E',
          'E',
          'M',
          'R',
          'S',
          'R',
          'V',
          'K',
          'E',
          'L',
          'A',
          'D',
          'K',
          'A',
          'R',
          'N',
          'A',
          'I',
          'M',
          'D',
          'G',
          'G',
          'S',
          'S',
          'I',
          'L',
          'D',
          'L',
          'E',
          'A',
          'L',
          'F',
          'H',
          'D',
          'L',
          'K',
          'S',
          'A',
          'S',
          'A',
          'T',
          'R',
          'K',
        ],
        [
          'SRR3996360_haplotype1',
          'S',
          'L',
          'N',
          'S',
          'T',
          'N',
          'T',
          '.',
          'S',
          'Y',
          'I',
          'C',
          'K',
          'T',
          'S',
          'D',
          'L',
          'T',
          'Q',
          'K',
          'S',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'A',
          'I',
          'D',
          'M',
          'A',
          'K',
          'L',
          'F',
          'A',
          'L',
          'R',
          'G',
          'Q',
          'R',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'V',
          'D',
          'I',
          'L',
          'T',
          'I',
          'K',
          'I',
          'P',
          'S',
          'S',
          'E',
          'A',
          'G',
          'F',
          'P',
          'K',
          'G',
          'I',
          'E',
          'S',
          'L',
          'D',
          'M',
          'A',
          'P',
          'T',
          'P',
          'Q',
          'V',
          'Q',
          'G',
          'K',
          'F',
          'F',
          'E',
          'A',
          'S',
          'G',
          'L',
          'F',
          'E',
          'P',
          'Q',
          'I',
          'D',
          'E',
          'L',
          'L',
          'E',
          'L',
          'Y',
          'R',
          'P',
          'D',
          'C',
          'L',
          'V',
          'A',
          'D',
          'I',
          'F',
          'F',
          'P',
          'W',
          'A',
          'T',
          'D',
          'V',
          'A',
          'A',
          'K',
          'Y',
          'G',
          'I',
          'P',
          'R',
          'L',
          'I',
          'F',
          'H',
          'G',
          'S',
          'S',
          'N',
          'F',
          'A',
          'M',
          'C',
          'C',
          'N',
          'L',
          'S',
          'V',
          'F',
          'R',
          'S',
          'K',
          'P',
          'Y',
          'K',
          'H',
          'V',
          'S',
          'S',
          'E',
          'Y',
          'E',
          'P',
          'F',
          'I',
          'I',
          'P',
          'N',
          'L',
          'P',
          'D',
          'K',
          'I',
          'E',
          'F',
          'T',
          'A',
          'S',
          'R',
          'V',
          'A',
          'D',
          'F',
          'I',
          'K',
          'E',
          'D',
          'S',
          'E',
          'T',
          'E',
          'T',
          'D',
          'H',
          'F',
          'T',
          'K',
          'M',
          'Y',
          'K',
          'V',
          'M',
          'K',
          'E',
          'V',
          'E',
          'L',
          'R',
          'S',
          'Y',
          'G',
          'I',
          'L',
          'V',
          'N',
          'S',
          'F',
          'Y',
          'E',
          'L',
          'E',
          'P',
          'A',
          'Y',
          'A',
          'D',
          'H',
          'Y',
          'P',
          'K',
          'V',
          'I',
          'Q',
          'G',
          'I',
          'K',
          'T',
          'W',
          'Q',
          'I',
          'G',
          'P',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'N',
          'S',
          'V',
          'V',
          'Y',
          'V',
          'S',
          'F',
          'G',
          'S',
          'V',
          'A',
          'N',
          'F',
          'D',
          'D',
          'E',
          'Q',
          'L',
          'M',
          'E',
          'I',
          'A',
          'T',
          'G',
          'L',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'G',
          'F',
          'E',
          'E',
          'R',
          'M',
          'E',
          'G',
          'K',
          'G',
          'V',
          'I',
          'V',
          'R',
          'G',
          'W',
          'A',
          'P',
          'Q',
          'I',
          'P',
          'I',
          'L',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'D',
          'E',
          'A',
          'E',
          'E',
          'M',
          'R',
          'S',
          'R',
          'V',
          'K',
          'E',
          'L',
          'A',
          'D',
          'K',
          'A',
          'R',
          'N',
          'A',
          'I',
          'M',
          'D',
          'G',
          'G',
          'S',
          'S',
          'I',
          'L',
          'D',
          'L',
          'E',
          'A',
          'L',
          'F',
          'H',
          'D',
          'L',
          'K',
          'S',
          'A',
          'S',
          'A',
          'T',
          'R',
          'K',
        ],
        [
          'SRR3996360_haplotype1',
          'S',
          'L',
          'N',
          'S',
          'T',
          'N',
          'T',
          '.',
          'S',
          'Y',
          'I',
          'C',
          'K',
          'T',
          'S',
          'D',
          'L',
          'T',
          'Q',
          'K',
          'S',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'A',
          'I',
          'D',
          'M',
          'A',
          'K',
          'L',
          'F',
          'A',
          'L',
          'R',
          'G',
          'Q',
          'R',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'V',
          'D',
          'I',
          'L',
          'T',
          'I',
          'K',
          'I',
          'P',
          'S',
          'S',
          'E',
          'A',
          'G',
          'F',
          'P',
          'K',
          'G',
          'I',
          'E',
          'S',
          'L',
          'D',
          'M',
          'A',
          'P',
          'T',
          'P',
          'Q',
          'V',
          'Q',
          'G',
          'K',
          'F',
          'F',
          'E',
          'A',
          'S',
          'G',
          'L',
          'F',
          'E',
          'P',
          'Q',
          'I',
          'D',
          'E',
          'L',
          'L',
          'E',
          'L',
          'Y',
          'R',
          'P',
          'D',
          'C',
          'L',
          'V',
          'A',
          'D',
          'I',
          'F',
          'F',
          'P',
          'W',
          'A',
          'T',
          'D',
          'V',
          'A',
          'A',
          'K',
          'Y',
          'G',
          'I',
          'P',
          'R',
          'L',
          'I',
          'F',
          'H',
          'G',
          'S',
          'S',
          'N',
          'F',
          'A',
          'M',
          'C',
          'C',
          'N',
          'L',
          'S',
          'V',
          'F',
          'R',
          'S',
          'K',
          'P',
          'Y',
          'K',
          'H',
          'V',
          'S',
          'S',
          'E',
          'Y',
          'E',
          'P',
          'F',
          'I',
          'I',
          'P',
          'N',
          'L',
          'P',
          'D',
          'K',
          'I',
          'E',
          'F',
          'T',
          'A',
          'S',
          'R',
          'V',
          'A',
          'D',
          'F',
          'I',
          'K',
          'E',
          'D',
          'S',
          'E',
          'T',
          'E',
          'T',
          'D',
          'H',
          'F',
          'T',
          'K',
          'M',
          'Y',
          'K',
          'V',
          'M',
          'K',
          'E',
          'V',
          'E',
          'L',
          'R',
          'S',
          'Y',
          'G',
          'I',
          'L',
          'V',
          'N',
          'S',
          'F',
          'Y',
          'E',
          'L',
          'E',
          'P',
          'A',
          'Y',
          'A',
          'D',
          'H',
          'Y',
          'P',
          'K',
          'V',
          'I',
          'Q',
          'G',
          'I',
          'K',
          'T',
          'W',
          'Q',
          'I',
          'G',
          'P',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'N',
          'S',
          'V',
          'V',
          'Y',
          'V',
          'S',
          'F',
          'G',
          'S',
          'V',
          'A',
          'N',
          'F',
          'D',
          'D',
          'E',
          'Q',
          'L',
          'M',
          'E',
          'I',
          'A',
          'T',
          'G',
          'L',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'G',
          'F',
          'E',
          'E',
          'R',
          'M',
          'E',
          'G',
          'K',
          'G',
          'V',
          'I',
          'V',
          'R',
          'G',
          'W',
          'A',
          'P',
          'Q',
          'I',
          'P',
          'I',
          'L',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'D',
          'E',
          'A',
          'E',
          'E',
          'M',
          'R',
          'S',
          'R',
          'V',
          'K',
          'E',
          'L',
          'A',
          'D',
          'K',
          'A',
          'R',
          'N',
          'A',
          'I',
          'M',
          'D',
          'G',
          'G',
          'S',
          'S',
          'I',
          'L',
          'D',
          'L',
          'E',
          'A',
          'L',
          'F',
          'H',
          'D',
          'L',
          'K',
          'S',
          'A',
          'S',
          'A',
          'T',
          'R',
          'K',
        ],
        [
          'SRR3996360_haplotype1',
          'S',
          'L',
          'N',
          'S',
          'T',
          'N',
          'T',
          '.',
          'S',
          'Y',
          'I',
          'C',
          'K',
          'T',
          'S',
          'D',
          'L',
          'T',
          'Q',
          'K',
          'S',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'A',
          'I',
          'D',
          'M',
          'A',
          'K',
          'L',
          'F',
          'A',
          'L',
          'R',
          'G',
          'Q',
          'R',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'V',
          'D',
          'I',
          'L',
          'T',
          'I',
          'K',
          'I',
          'P',
          'S',
          'S',
          'E',
          'A',
          'G',
          'F',
          'P',
          'K',
          'G',
          'I',
          'E',
          'S',
          'L',
          'D',
          'M',
          'A',
          'P',
          'T',
          'P',
          'Q',
          'V',
          'Q',
          'G',
          'K',
          'F',
          'F',
          'E',
          'A',
          'S',
          'G',
          'L',
          'F',
          'E',
          'P',
          'Q',
          'I',
          'D',
          'E',
          'L',
          'L',
          'E',
          'L',
          'Y',
          'R',
          'P',
          'D',
          'C',
          'L',
          'V',
          'A',
          'D',
          'I',
          'F',
          'F',
          'P',
          'W',
          'A',
          'T',
          'D',
          'V',
          'A',
          'A',
          'K',
          'Y',
          'G',
          'I',
          'P',
          'R',
          'L',
          'I',
          'F',
          'H',
          'G',
          'S',
          'S',
          'N',
          'F',
          'A',
          'M',
          'C',
          'C',
          'N',
          'L',
          'S',
          'V',
          'F',
          'R',
          'S',
          'K',
          'P',
          'Y',
          'K',
          'H',
          'V',
          'S',
          'S',
          'E',
          'Y',
          'E',
          'P',
          'F',
          'I',
          'I',
          'P',
          'N',
          'L',
          'P',
          'D',
          'K',
          'I',
          'E',
          'F',
          'T',
          'A',
          'S',
          'R',
          'V',
          'A',
          'D',
          'F',
          'I',
          'K',
          'E',
          'D',
          'S',
          'E',
          'T',
          'E',
          'T',
          'D',
          'H',
          'F',
          'T',
          'K',
          'M',
          'Y',
          'K',
          'V',
          'M',
          'K',
          'E',
          'V',
          'E',
          'L',
          'R',
          'S',
          'Y',
          'G',
          'I',
          'L',
          'V',
          'N',
          'S',
          'F',
          'Y',
          'E',
          'L',
          'E',
          'P',
          'A',
          'Y',
          'A',
          'D',
          'H',
          'Y',
          'P',
          'K',
          'V',
          'I',
          'Q',
          'G',
          'I',
          'K',
          'T',
          'W',
          'Q',
          'I',
          'G',
          'P',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'N',
          'S',
          'V',
          'V',
          'Y',
          'V',
          'S',
          'F',
          'G',
          'S',
          'V',
          'A',
          'N',
          'F',
          'D',
          'D',
          'E',
          'Q',
          'L',
          'M',
          'E',
          'I',
          'A',
          'T',
          'G',
          'L',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'G',
          'F',
          'E',
          'E',
          'R',
          'M',
          'E',
          'G',
          'K',
          'G',
          'V',
          'I',
          'V',
          'R',
          'G',
          'W',
          'A',
          'P',
          'Q',
          'I',
          'P',
          'I',
          'L',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'D',
          'E',
          'A',
          'E',
          'E',
          'M',
          'R',
          'S',
          'R',
          'V',
          'K',
          'E',
          'L',
          'A',
          'D',
          'K',
          'A',
          'R',
          'N',
          'A',
          'I',
          'M',
          'D',
          'G',
          'G',
          'S',
          'S',
          'I',
          'L',
          'D',
          'L',
          'E',
          'A',
          'L',
          'F',
          'H',
          'D',
          'L',
          'K',
          'S',
          'A',
          'S',
          'A',
          'T',
          'R',
          'K',
        ],
        [
          'SRR3996360_haplotype1',
          'S',
          'L',
          'N',
          'S',
          'T',
          'N',
          'T',
          '.',
          'S',
          'Y',
          'I',
          'C',
          'K',
          'T',
          'S',
          'D',
          'L',
          'T',
          'Q',
          'K',
          'S',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'A',
          'I',
          'D',
          'M',
          'A',
          'K',
          'L',
          'F',
          'A',
          'L',
          'R',
          'G',
          'Q',
          'R',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'V',
          'D',
          'I',
          'L',
          'T',
          'I',
          'K',
          'I',
          'P',
          'S',
          'S',
          'E',
          'A',
          'G',
          'F',
          'P',
          'K',
          'G',
          'I',
          'E',
          'S',
          'L',
          'D',
          'M',
          'A',
          'P',
          'T',
          'P',
          'Q',
          'V',
          'Q',
          'G',
          'K',
          'F',
          'F',
          'E',
          'A',
          'S',
          'G',
          'L',
          'F',
          'E',
          'P',
          'Q',
          'I',
          'D',
          'E',
          'L',
          'L',
          'E',
          'L',
          'Y',
          'R',
          'P',
          'D',
          'C',
          'L',
          'V',
          'A',
          'D',
          'I',
          'F',
          'F',
          'P',
          'W',
          'A',
          'T',
          'D',
          'V',
          'A',
          'A',
          'K',
          'Y',
          'G',
          'I',
          'P',
          'R',
          'L',
          'I',
          'F',
          'H',
          'G',
          'S',
          'S',
          'N',
          'F',
          'A',
          'M',
          'C',
          'C',
          'N',
          'L',
          'S',
          'V',
          'F',
          'R',
          'S',
          'K',
          'P',
          'Y',
          'K',
          'H',
          'V',
          'S',
          'S',
          'E',
          'Y',
          'E',
          'P',
          'F',
          'I',
          'I',
          'P',
          'N',
          'L',
          'P',
          'D',
          'K',
          'I',
          'E',
          'F',
          'T',
          'A',
          'S',
          'R',
          'V',
          'A',
          'D',
          'F',
          'I',
          'K',
          'E',
          'D',
          'S',
          'E',
          'T',
          'E',
          'T',
          'D',
          'H',
          'F',
          'T',
          'K',
          'M',
          'Y',
          'K',
          'V',
          'M',
          'K',
          'E',
          'V',
          'E',
          'L',
          'R',
          'S',
          'Y',
          'G',
          'I',
          'L',
          'V',
          'N',
          'S',
          'F',
          'Y',
          'E',
          'L',
          'E',
          'P',
          'A',
          'Y',
          'A',
          'D',
          'H',
          'Y',
          'P',
          'K',
          'V',
          'I',
          'Q',
          'G',
          'I',
          'K',
          'T',
          'W',
          'Q',
          'I',
          'G',
          'P',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'N',
          'S',
          'V',
          'V',
          'Y',
          'V',
          'S',
          'F',
          'G',
          'S',
          'V',
          'A',
          'N',
          'F',
          'D',
          'D',
          'E',
          'Q',
          'L',
          'M',
          'E',
          'I',
          'A',
          'T',
          'G',
          'L',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'G',
          'F',
          'E',
          'E',
          'R',
          'M',
          'E',
          'G',
          'K',
          'G',
          'V',
          'I',
          'V',
          'R',
          'G',
          'W',
          'A',
          'P',
          'Q',
          'I',
          'P',
          'I',
          'L',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'D',
          'E',
          'A',
          'E',
          'E',
          'M',
          'R',
          'S',
          'R',
          'V',
          'K',
          'E',
          'L',
          'A',
          'D',
          'K',
          'A',
          'R',
          'N',
          'A',
          'I',
          'M',
          'D',
          'G',
          'G',
          'S',
          'S',
          'I',
          'L',
          'D',
          'L',
          'E',
          'A',
          'L',
          'F',
          'H',
          'D',
          'L',
          'K',
          'S',
          'A',
          'S',
          'A',
          'T',
          'R',
          'K',
        ],
        [
          'SRR3996360_haplotype1',
          'S',
          'L',
          'N',
          'S',
          'T',
          'N',
          'T',
          '.',
          'S',
          'Y',
          'I',
          'C',
          'K',
          'T',
          'S',
          'D',
          'L',
          'T',
          'Q',
          'K',
          'S',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'A',
          'I',
          'D',
          'M',
          'A',
          'K',
          'L',
          'F',
          'A',
          'L',
          'R',
          'G',
          'Q',
          'R',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'V',
          'D',
          'I',
          'L',
          'T',
          'I',
          'K',
          'I',
          'P',
          'S',
          'S',
          'E',
          'A',
          'G',
          'F',
          'P',
          'K',
          'G',
          'I',
          'E',
          'S',
          'L',
          'D',
          'M',
          'A',
          'P',
          'T',
          'P',
          'Q',
          'V',
          'Q',
          'G',
          'K',
          'F',
          'F',
          'E',
          'A',
          'S',
          'G',
          'L',
          'F',
          'E',
          'P',
          'Q',
          'I',
          'D',
          'E',
          'L',
          'L',
          'E',
          'L',
          'Y',
          'R',
          'P',
          'D',
          'C',
          'L',
          'V',
          'A',
          'D',
          'I',
          'F',
          'F',
          'P',
          'W',
          'A',
          'T',
          'D',
          'V',
          'A',
          'A',
          'K',
          'Y',
          'G',
          'I',
          'P',
          'R',
          'L',
          'I',
          'F',
          'H',
          'G',
          'S',
          'S',
          'N',
          'F',
          'A',
          'M',
          'C',
          'C',
          'N',
          'L',
          'S',
          'V',
          'F',
          'R',
          'S',
          'K',
          'P',
          'Y',
          'K',
          'H',
          'V',
          'S',
          'S',
          'E',
          'Y',
          'E',
          'P',
          'F',
          'I',
          'I',
          'P',
          'N',
          'L',
          'P',
          'D',
          'K',
          'I',
          'E',
          'F',
          'T',
          'A',
          'S',
          'R',
          'V',
          'A',
          'D',
          'F',
          'I',
          'K',
          'E',
          'D',
          'S',
          'E',
          'T',
          'E',
          'T',
          'D',
          'H',
          'F',
          'T',
          'K',
          'M',
          'Y',
          'K',
          'V',
          'M',
          'K',
          'E',
          'V',
          'E',
          'L',
          'R',
          'S',
          'Y',
          'G',
          'I',
          'L',
          'V',
          'N',
          'S',
          'F',
          'Y',
          'E',
          'L',
          'E',
          'P',
          'A',
          'Y',
          'A',
          'D',
          'H',
          'Y',
          'P',
          'K',
          'V',
          'I',
          'Q',
          'G',
          'I',
          'K',
          'T',
          'W',
          'Q',
          'I',
          'G',
          'P',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'N',
          'S',
          'V',
          'V',
          'Y',
          'V',
          'S',
          'F',
          'G',
          'S',
          'V',
          'A',
          'N',
          'F',
          'D',
          'D',
          'E',
          'Q',
          'L',
          'M',
          'E',
          'I',
          'A',
          'T',
          'G',
          'L',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'G',
          'F',
          'E',
          'E',
          'R',
          'M',
          'E',
          'G',
          'K',
          'G',
          'V',
          'I',
          'V',
          'R',
          'G',
          'W',
          'A',
          'P',
          'Q',
          'I',
          'P',
          'I',
          'L',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'D',
          'E',
          'A',
          'E',
          'E',
          'M',
          'R',
          'S',
          'R',
          'V',
          'K',
          'E',
          'L',
          'A',
          'D',
          'K',
          'A',
          'R',
          'N',
          'A',
          'I',
          'M',
          'D',
          'G',
          'G',
          'S',
          'S',
          'I',
          'L',
          'D',
          'L',
          'E',
          'A',
          'L',
          'F',
          'H',
          'D',
          'L',
          'K',
          'S',
          'A',
          'S',
          'A',
          'T',
          'R',
          'K',
        ],
        [
          'SRR3996360_haplotype1',
          'S',
          '.',
          'N',
          'S',
          'T',
          'N',
          'T',
          '.',
          'S',
          'Y',
          'I',
          'C',
          'K',
          'T',
          'S',
          'D',
          'L',
          'T',
          'Q',
          'K',
          'S',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'A',
          'I',
          'D',
          'M',
          'A',
          'K',
          'L',
          'F',
          'A',
          'L',
          'R',
          'G',
          'Q',
          'R',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'V',
          'D',
          'I',
          'L',
          'T',
          'I',
          'K',
          'I',
          'P',
          'S',
          'S',
          'E',
          'A',
          'G',
          'F',
          'P',
          'K',
          'G',
          'I',
          'E',
          'S',
          'L',
          'D',
          'M',
          'A',
          'P',
          'T',
          'P',
          'Q',
          'V',
          'Q',
          'G',
          'K',
          'F',
          'F',
          'E',
          'A',
          'S',
          'G',
          'L',
          'F',
          'E',
          'P',
          'Q',
          'I',
          'D',
          'E',
          'L',
          'L',
          'E',
          'L',
          'Y',
          'R',
          'P',
          'D',
          'C',
          'L',
          'V',
          'A',
          'D',
          'I',
          'F',
          'F',
          'P',
          'W',
          'A',
          'T',
          'D',
          'V',
          'A',
          'A',
          'K',
          'Y',
          'G',
          'I',
          'P',
          'R',
          'L',
          'I',
          'F',
          'H',
          'G',
          'S',
          'S',
          'N',
          'F',
          'A',
          'M',
          'C',
          'C',
          'N',
          'L',
          'S',
          'V',
          'F',
          'R',
          'S',
          'K',
          'P',
          'Y',
          'K',
          'H',
          'V',
          'S',
          'S',
          'E',
          'Y',
          'E',
          'P',
          'F',
          'I',
          'I',
          'P',
          'N',
          'L',
          'P',
          'D',
          'K',
          'I',
          'E',
          'F',
          'T',
          'A',
          'S',
          'R',
          'V',
          'A',
          'D',
          'F',
          'I',
          'K',
          'E',
          'D',
          'S',
          'E',
          'T',
          'E',
          'T',
          'D',
          'H',
          'F',
          'T',
          'K',
          'M',
          'Y',
          'K',
          'V',
          'M',
          'K',
          'E',
          'V',
          'E',
          'L',
          'R',
          'S',
          'Y',
          'G',
          'I',
          'L',
          'V',
          'N',
          'S',
          'F',
          'Y',
          'E',
          'L',
          'E',
          'P',
          'A',
          'Y',
          'A',
          'D',
          'H',
          'Y',
          'P',
          'K',
          'V',
          'I',
          'Q',
          'G',
          'I',
          'K',
          'T',
          'W',
          'Q',
          'I',
          'G',
          'P',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'N',
          'S',
          'V',
          'V',
          'Y',
          'V',
          'S',
          'F',
          'G',
          'S',
          'V',
          'A',
          'N',
          'F',
          'D',
          'D',
          'E',
          'Q',
          'L',
          'M',
          'E',
          'I',
          'A',
          'T',
          'G',
          'L',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'G',
          'F',
          'E',
          'E',
          'R',
          'M',
          'E',
          'G',
          'K',
          'G',
          'V',
          'I',
          'V',
          'R',
          'G',
          'W',
          'A',
          'P',
          'Q',
          'I',
          'P',
          'I',
          'L',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'D',
          'E',
          'A',
          'E',
          'E',
          'M',
          'R',
          'S',
          'R',
          'V',
          'K',
          'E',
          'L',
          'A',
          'D',
          'K',
          'A',
          'R',
          'N',
          'A',
          'I',
          'M',
          'D',
          'G',
          'G',
          'S',
          'S',
          'I',
          'L',
          'D',
          'L',
          'E',
          'A',
          'L',
          'F',
          'H',
          'D',
          'L',
          'K',
          'S',
          'A',
          'S',
          'A',
          'T',
          'R',
          'K',
        ],
        [
          'SRR3996360_haplotype1',
          'S',
          '.',
          'N',
          'S',
          'T',
          'N',
          'T',
          '.',
          'S',
          'Y',
          'I',
          'C',
          'K',
          'T',
          'S',
          'D',
          'L',
          'T',
          'Q',
          'K',
          'S',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'A',
          'I',
          'D',
          'M',
          'A',
          'K',
          'L',
          'F',
          'A',
          'L',
          'R',
          'G',
          'Q',
          'R',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'V',
          'D',
          'I',
          'L',
          'T',
          'I',
          'K',
          'I',
          'P',
          'S',
          'S',
          'E',
          'A',
          'G',
          'F',
          'P',
          'K',
          'G',
          'I',
          'E',
          'S',
          'L',
          'D',
          'M',
          'A',
          'P',
          'T',
          'P',
          'Q',
          'V',
          'Q',
          'G',
          'K',
          'F',
          'F',
          'E',
          'A',
          'S',
          'G',
          'L',
          'F',
          'E',
          'P',
          'Q',
          'I',
          'D',
          'E',
          'L',
          'L',
          'E',
          'L',
          'Y',
          'R',
          'P',
          'D',
          'C',
          'L',
          'V',
          'A',
          'D',
          'I',
          'F',
          'F',
          'P',
          'W',
          'A',
          'T',
          'D',
          'V',
          'A',
          'A',
          'K',
          'Y',
          'G',
          'I',
          'P',
          'R',
          'L',
          'I',
          'F',
          'H',
          'G',
          'S',
          'S',
          'N',
          'F',
          'A',
          'M',
          'C',
          'C',
          'N',
          'L',
          'S',
          'V',
          'F',
          'R',
          'S',
          'K',
          'P',
          'Y',
          'K',
          'H',
          'V',
          'S',
          'S',
          'E',
          'Y',
          'E',
          'P',
          'F',
          'I',
          'I',
          'P',
          'N',
          'L',
          'P',
          'D',
          'K',
          'I',
          'E',
          'F',
          'T',
          'A',
          'S',
          'R',
          'V',
          'A',
          'D',
          'F',
          'I',
          'K',
          'E',
          'D',
          'S',
          'E',
          'T',
          'E',
          'T',
          'D',
          'H',
          'F',
          'T',
          'K',
          'M',
          'Y',
          'K',
          'V',
          'M',
          'K',
          'E',
          'V',
          'E',
          'L',
          'R',
          'S',
          'Y',
          'G',
          'I',
          'L',
          'V',
          'N',
          'S',
          'F',
          'Y',
          'E',
          'L',
          'E',
          'P',
          'A',
          'Y',
          'A',
          'D',
          'H',
          'Y',
          'P',
          'K',
          'V',
          'I',
          'Q',
          'G',
          'I',
          'K',
          'T',
          'W',
          'Q',
          'I',
          'G',
          'P',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'N',
          'S',
          'V',
          'V',
          'Y',
          'V',
          'S',
          'F',
          'G',
          'S',
          'V',
          'A',
          'N',
          'F',
          'D',
          'D',
          'E',
          'Q',
          'L',
          'M',
          'E',
          'I',
          'A',
          'T',
          'G',
          'L',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'G',
          'F',
          'E',
          'E',
          'R',
          'M',
          'E',
          'G',
          'K',
          'G',
          'V',
          'I',
          'V',
          'R',
          'G',
          'W',
          'A',
          'P',
          'Q',
          'I',
          'P',
          'I',
          'L',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'D',
          'E',
          'A',
          'E',
          'E',
          'M',
          'R',
          'S',
          'R',
          'V',
          'K',
          'E',
          'L',
          'A',
          'D',
          'K',
          'A',
          'R',
          'N',
          'A',
          'I',
          'M',
          'D',
          'G',
          'G',
          'S',
          'S',
          'I',
          'L',
          'D',
          'L',
          'E',
          'A',
          'L',
          'F',
          'H',
          'D',
          'L',
          'K',
          'S',
          'A',
          'S',
          'A',
          'T',
          'R',
          'K',
        ],
        [
          'SRR3996360_haplotype1',
          'S',
          '.',
          'N',
          'S',
          'T',
          'N',
          'T',
          '.',
          'S',
          'Y',
          'I',
          'C',
          'K',
          'T',
          'S',
          'D',
          'L',
          'T',
          'Q',
          'K',
          'S',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'A',
          'I',
          'D',
          'M',
          'A',
          'K',
          'L',
          'F',
          'A',
          'L',
          'R',
          'G',
          'Q',
          'R',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'V',
          'D',
          'I',
          'L',
          'T',
          'I',
          'K',
          'I',
          'P',
          'S',
          'S',
          'E',
          'A',
          'G',
          'F',
          'P',
          'K',
          'G',
          'I',
          'E',
          'S',
          'L',
          'D',
          'M',
          'A',
          'P',
          'T',
          'P',
          'Q',
          'V',
          'Q',
          'G',
          'K',
          'F',
          'F',
          'E',
          'A',
          'S',
          'G',
          'L',
          'F',
          'E',
          'P',
          'Q',
          'I',
          'D',
          'E',
          'L',
          'L',
          'E',
          'L',
          'Y',
          'R',
          'P',
          'D',
          'C',
          'L',
          'V',
          'A',
          'D',
          'I',
          'F',
          'F',
          'P',
          'W',
          'A',
          'T',
          'D',
          'V',
          'A',
          'A',
          'K',
          'Y',
          'G',
          'I',
          'P',
          'R',
          'L',
          'I',
          'F',
          'H',
          'G',
          'S',
          'S',
          'N',
          'F',
          'A',
          'M',
          'C',
          'C',
          'N',
          'L',
          'S',
          'V',
          'F',
          'R',
          'S',
          'K',
          'P',
          'Y',
          'K',
          'H',
          'V',
          'S',
          'S',
          'E',
          'Y',
          'E',
          'P',
          'F',
          'I',
          'I',
          'P',
          'N',
          'L',
          'P',
          'D',
          'K',
          'I',
          'E',
          'F',
          'T',
          'A',
          'S',
          'R',
          'V',
          'A',
          'D',
          'F',
          'I',
          'K',
          'E',
          'D',
          'S',
          'E',
          'T',
          'E',
          'T',
          'D',
          'H',
          'F',
          'T',
          'K',
          'M',
          'Y',
          'K',
          'V',
          'M',
          'K',
          'E',
          'V',
          'E',
          'L',
          'R',
          'S',
          'Y',
          'G',
          'I',
          'L',
          'V',
          'N',
          'S',
          'F',
          'Y',
          'E',
          'L',
          'E',
          'P',
          'A',
          'Y',
          'A',
          'D',
          'H',
          'Y',
          'P',
          'K',
          'V',
          'I',
          'Q',
          'G',
          'I',
          'K',
          'T',
          'W',
          'Q',
          'I',
          'G',
          'P',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'N',
          'S',
          'V',
          'V',
          'Y',
          'V',
          'S',
          'F',
          'G',
          'S',
          'V',
          'A',
          'N',
          'F',
          'D',
          'D',
          'E',
          'Q',
          'L',
          'M',
          'E',
          'I',
          'A',
          'T',
          'G',
          'L',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'G',
          'F',
          'E',
          'E',
          'R',
          'M',
          'E',
          'G',
          'K',
          'G',
          'V',
          'I',
          'V',
          'R',
          'G',
          'W',
          'A',
          'P',
          'Q',
          'I',
          'P',
          'I',
          'L',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          '.',
          'D',
          'E',
          'A',
          'E',
          'E',
          'M',
          'R',
          'S',
          'R',
          'V',
          'K',
          'E',
          'L',
          'A',
          'D',
          'K',
          'A',
          'R',
          'N',
          'A',
          'I',
          'M',
          'D',
          'G',
          'G',
          'S',
          'S',
          'I',
          'L',
          'D',
          'L',
          'E',
          'A',
          'L',
          'F',
          'H',
          'D',
          'L',
          'K',
          'S',
          'A',
          'S',
          'A',
          'T',
          'R',
          'K',
        ],
      ],
    },
  ],
  layout: {
    title:
      'Alignment of the amino acid sequences for the selected Enzyme/Transcript',
  },
  dataType: 'AA',
};
export const alignment3 = {
  data: [
    {
      cells: [
        [
          'SRR3996360_haplotype2',
          'A',
          'C',
          'G',
          'T',
          'A',
          'C',
          'G',
          'T',
          'A',
          'C',
          'G',
          'T',
          'M',
          '.',
          'A',
          'C',
          'G',
          'T',
          'M',
          '.',
          'A',
          'C',
          'G',
          'T',
          'M',
          'A',
          'C',
          'G',
          'T',
          'M',
        ],
        [
          'SRR3996360_haplotype2',
          'A',
          'C',
          'G',
          'T',
          'A',
          'C',
          'G',
          'T',
          'A',
          'C',
          'G',
          'T',
          'M',
          '.',
          'A',
          'C',
          'G',
          'T',
          'M',
          '.',
          'A',
          'C',
          'G',
          'T',
          'M',
          'A',
          'C',
          'G',
          'T',
          'M',
        ],
        [
          'SRR3996360_haplotype2',
          'A',
          'C',
          'G',
          'T',
          'A',
          'C',
          'G',
          'T',
          'A',
          'M',
          'G',
          'T',
          'M',
          '.',
          'A',
          'C',
          'G',
          'T',
          'M',
          '.',
          'A',
          'C',
          'G',
          'T',
          'M',
          'A',
          'C',
          'G',
          'T',
          'M',
        ],
        [
          'SRR3996360_haplotype2',
          'A',
          'C',
          'G',
          'T',
          'A',
          'C',
          'G',
          'T',
          'A',
          'C',
          'C',
          'T',
          'M',
          '.',
          'A',
          'C',
          'G',
          'T',
          'M',
          '.',
          'A',
          'C',
          'C',
          'T',
          'M',
          'A',
          'C',
          'G',
          'T',
          'M',
        ],
      ],
    },
  ],
  layout: {
    title: 'Alignment of the DNA sequences',
  },
  dataType: 'DNA',
};
export const alignment4 = {
  data: [
    {
      cells: [
        [
          'SRR3996360_haplotype2',
          'A',
          'C',
          'G',
          'U',
          'M',
          'A',
          'C',
          'G',
          'U',
          'M',
          'A',
          'C',
          'G',
          'U',
          'M',
          'A',
          'C',
          'G',
          'U',
          'M',
          '.',
          'A',
          'C',
          'G',
          'T',
          'W',
          '.',
          'A',
          'C',
          'G',
          'T',
          'M',
          'A',
          'C',
          'G',
          'T',
          'M',
        ],
        [
          'SRR3996360_haplotype2',
          'A',
          'C',
          'G',
          'U',
          'M',
          'A',
          'C',
          'G',
          'U',
          'M',
          'A',
          'C',
          'G',
          'U',
          'M',
          'A',
          'C',
          'G',
          'T',
          'N',
          '.',
          'A',
          'C',
          'G',
          'T',
          'M',
          '.',
          'A',
          'C',
          'G',
          'T',
          'M',
          'A',
          'C',
          'G',
          'T',
          'M',
        ],
        [
          'SRR3996360_haplotype2',
          'A',
          'C',
          'G',
          'U',
          'M',
          'A',
          'C',
          'G',
          'U',
          'M',
          'A',
          'C',
          'G',
          'U',
          'M',
          'A',
          'M',
          'G',
          'U',
          'W',
          '.',
          'A',
          'C',
          'G',
          'T',
          'M',
          '.',
          'A',
          'C',
          'G',
          'T',
          'M',
          'A',
          'C',
          'G',
          'T',
          'M',
        ],
        [
          'SRR3996360_haplotype2',
          'A',
          'C',
          'G',
          'U',
          'M',
          'A',
          'C',
          'G',
          'U',
          'M',
          'A',
          'C',
          'G',
          'U',
          'M',
          'A',
          'C',
          'C',
          'T',
          'M',
          '.',
          'A',
          'C',
          'G',
          'T',
          'M',
          '.',
          'A',
          'C',
          'C',
          'T',
          'M',
          'A',
          'C',
          'G',
          'T',
          'M',
        ],
      ],
    },
  ],
  layout: {
    title: 'Alignment of the RNA sequences',
  },
  dataType: 'RNA',
};

export const scatter = {
  data: [
    {
      error_x: {
        color: 'rgba(31,119,180,1)',
        width: 55,
      },
      error_y: {
        color: 'rgba(31,119,180,1)',
        width: 55,
      },
      hoverinfo: ['none', 'none', 'none'],
      line: {
        color: 'rgba(31,119,180,1)',
        width: 55,
      },
      marker: {
        color: 'rgba(31,119,180,1)',
        line: {
          color: 'rgba(31,119,180,1)',
        },
        size: [55, 55, 55],
        sizemode: 'area',
        symbol: 'square',
      },
      mode: 'markers',
      name: 'cluster1',
      text: {},
      textfont: {
        color: 'rgba(31,119,180,1)',
        size: 55,
      },
      type: 'scatter',
      x: [-4.6873, -3.6437, 0.376],
      xaxis: 'x',
      y: [-0.756, -2.4669, -1.1831],
      yaxis: 'y',
    },
    {
      error_x: {
        color: 'rgba(255,127,14,1)',
        width: 55,
      },
      error_y: {
        color: 'rgba(255,127,14,1)',
        width: 55,
      },
      hoverinfo: ['none'],
      line: {
        color: 'rgba(255,127,14,1)',
        width: 55,
      },
      marker: {
        color: 'rgba(255,127,14,1)',
        line: {
          color: 'rgba(255,127,14,1)',
        },
        size: [55],
        sizemode: 'area',
        symbol: 'square',
      },
      mode: 'markers',
      name: 'cluster2',
      text: {},
      textfont: {
        color: 'rgba(255,127,14,1)',
        size: 55,
      },
      type: 'scatter',
      x: [-3.2103],
      xaxis: 'x',
      y: [2.2695],
      yaxis: 'y',
    },
    {
      error_x: {
        color: 'rgba(214,39,40,1)',
        width: 55,
      },
      error_y: {
        color: 'rgba(214,39,40,1)',
        width: 55,
      },
      hoverinfo: ['none', 'none'],
      line: {
        color: 'rgba(214,39,40,1)',
        width: 55,
      },
      marker: {
        color: 'rgba(214,39,40,1)',
        line: {
          color: 'rgba(214,39,40,1)',
        },
        size: [55, 55],
        sizemode: 'area',
        symbol: 'square',
      },
      mode: 'markers',
      name: 'cluster4',
      text: {},
      textfont: {
        color: 'rgba(214,39,40,1)',
        size: 55,
      },
      type: 'scatter',
      x: [3.6471, -1.4229],
      xaxis: 'x',
      y: [0.9434, 0.5926],
      yaxis: 'y',
    },
    {
      error_x: {
        color: 'rgba(140,86,75,1)',
        width: 55,
      },
      error_y: {
        color: 'rgba(140,86,75,1)',
        width: 55,
      },
      hoverinfo: [
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
      ],
      line: {
        color: 'rgba(140,86,75,1)',
        width: 55,
      },
      marker: {
        color: 'rgba(140,86,75,1)',
        line: {
          color: 'rgba(140,86,75,1)',
        },
        size: [55, 55, 55, 55, 55, 55, 55, 55, 55],
        sizemode: 'area',
        symbol: 'square',
      },
      mode: 'markers',
      name: 'cluster6',
      text: {},
      textfont: {
        color: 'rgba(140,86,75,1)',
        size: 55,
      },
      type: 'scatter',
      x: [
        -4.8876,
        4.0482,
        -0.6329,
        4.1133,
        3.7566,
        -0.7764,
        -1.2388,
        5.8785,
        -1.3196,
      ],
      xaxis: 'x',
      y: [
        1.0875,
        -0.3865,
        -2.758,
        -7.6523,
        -0.1821,
        -2.6861,
        2.0063,
        6.2569,
        4.9148,
      ],
      yaxis: 'y',
    },
    {
      error_x: {
        color: 'rgba(31,119,180,1)',
        width: 55,
      },
      error_y: {
        color: 'rgba(31,119,180,1)',
        width: 55,
      },
      hoverinfo: ['text', 'text', 'text'],
      line: {
        color: 'rgba(31,119,180,1)',
        width: 55,
      },
      marker: {
        color: 'rgba(31,119,180,1)',
        line: {
          color: 'rgba(31,119,180,1)',
        },
        size: [55, 55, 55],
        sizemode: 'area',
        symbol: 'square',
      },
      mode: 'markers',
      name: 'cluster1',
      showlegend: false,
      text: ['RB4p', 'TP1p', 'YH1p'],
      textfont: {
        color: 'rgba(31,119,180,1)',
        size: 55,
      },
      type: 'scatter',
      x: [-4.6873, -3.6437, 0.376],
      xaxis: 'x',
      y: [-0.756, -2.4669, -1.1831],
      yaxis: 'y',
    },
    {
      error_x: {
        color: 'rgba(255,127,14,1)',
        width: 55,
      },
      error_y: {
        color: 'rgba(255,127,14,1)',
        width: 55,
      },
      hoverinfo: ['text'],
      line: {
        color: 'rgba(255,127,14,1)',
        width: 55,
      },
      marker: {
        color: 'rgba(255,127,14,1)',
        line: {
          color: 'rgba(255,127,14,1)',
        },
        size: [55],
        sizemode: 'area',
        symbol: 'square',
      },
      mode: 'markers',
      name: 'cluster2',
      showlegend: false,
      text: ['RB2p'],
      textfont: {
        color: 'rgba(255,127,14,1)',
        size: 55,
      },
      type: 'scatter',
      x: [-3.2103],
      xaxis: 'x',
      y: [2.2695],
      yaxis: 'y',
    },
    {
      error_x: {
        color: 'rgba(214,39,40,1)',
        width: 55,
      },
      error_y: {
        color: 'rgba(214,39,40,1)',
        width: 55,
      },
      hoverinfo: ['text', 'text'],
      line: {
        color: 'rgba(214,39,40,1)',
        width: 55,
      },
      marker: {
        color: 'rgba(214,39,40,1)',
        line: {
          color: 'rgba(214,39,40,1)',
        },
        size: [55, 55],
        sizemode: 'area',
        symbol: 'square',
      },
      mode: 'markers',
      name: 'cluster4',
      showlegend: false,
      text: ['BL2p', 'BR1p'],
      textfont: {
        color: 'rgba(214,39,40,1)',
        size: 55,
      },
      type: 'scatter',
      x: [3.6471, -1.4229],
      xaxis: 'x',
      y: [0.9434, 0.5926],
      yaxis: 'y',
    },
    {
      error_x: {
        color: 'rgba(140,86,75,1)',
        width: 55,
      },
      error_y: {
        color: 'rgba(140,86,75,1)',
        width: 55,
      },
      hoverinfo: [
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
        'text',
      ],
      line: {
        color: 'rgba(140,86,75,1)',
        width: 55,
      },
      marker: {
        color: 'rgba(140,86,75,1)',
        line: {
          color: 'rgba(140,86,75,1)',
        },
        size: [55, 55, 55, 55, 55, 55, 55, 55, 55],
        sizemode: 'area',
        symbol: 'square',
      },
      mode: 'markers',
      name: 'cluster6',
      showlegend: false,
      text: [
        'EX1p',
        'Fustyp',
        'KA1p',
        'LP1p',
        'Mustyp',
        'NB1p',
        'PA1p',
        'Rancidp',
        'RB1p',
      ],
      textfont: {
        color: 'rgba(140,86,75,1)',
        size: 55,
      },
      type: 'scatter',
      x: [
        -4.8876,
        4.0482,
        -0.6329,
        4.1133,
        3.7566,
        -0.7764,
        -1.2388,
        5.8785,
        -1.3196,
      ],
      xaxis: 'x',
      y: [
        1.0875,
        -0.3865,
        -2.758,
        -7.6523,
        -0.1821,
        -2.6861,
        2.0063,
        6.2569,
        4.9148,
      ],
      yaxis: 'y',
    },
  ],
  layout: {
    hovermode: 'closest',
    margin: {
      b: 40,
      l: 60,
      r: 10,
      t: 25,
    },
    showlegend: true,
    title: 'Principal Component Analysis based on LCMS profiles - PC34',
    xaxis: {
      automargin: true,
      domain: [0, 1],
      title: 'PC3 (variance explained: 10%)',
    },
    yaxis: {
      automargin: true,
      domain: [0, 1],
      title: 'PC4 (variance explained: 9.2%)',
    },
  },
};
export const scatter2 = {
  data: [
    {
      hoverinfo: ['text', 'text', 'text'],
      name: 'cluster1',
      marker: {
        size: 7,
        sizemode: 'area',
        symbol: 'square',
      },
      mode: 'markers',
      text: ['RB4p', 'TP1p', 'YH1p'],
      type: 'scatter',
      x: [-4.6873, -3.6437, 0.376],
      y: [-0.756, -2.4669, -1.1831],
    },
    {
      hoverinfo: 'text',
      name: 'cluster2',
      marker: {
        size: 7,
        sizemode: 'area',
        symbol: 'square',
      },
      mode: 'markers',
      text: ['RB2p'],
      type: 'scatter',
      x: [-3.2103],
      y: [2.2695],
    },
    {
      hoverinfo: 'text',
      name: 'cluster4',
      marker: {
        size: 7,
        sizemode: 'area',
        symbol: 'square',
      },
      mode: 'markers',
      text: ['BL2p', 'BR1p'],
      type: 'scatter',
      x: [3.6471, -1.4229],
      y: [0.9434, 0.5926],
    },
    {
      hoverinfo: 'text',
      name: 'cluster6',
      marker: {
        size: 7,
        sizemode: 'area',
        symbol: 'square',
      },
      mode: 'markers',
      text: [
        'EX1p',
        'Fustyp',
        'KA1p',
        'LP1p',
        'Mustyp',
        'NB1p',
        'PA1p',
        'Rancidp',
        'RB1p',
      ],
      type: 'scatter',
      x: [
        -4.8876,
        4.0482,
        -0.6329,
        4.1133,
        3.7566,
        -0.7764,
        -1.2388,
        5.8785,
        -1.3196,
      ],
      y: [
        1.0875,
        -0.3865,
        -2.758,
        -7.6523,
        -0.1821,
        -2.6861,
        2.0063,
        6.2569,
        4.9148,
      ],
    },
  ],
  layout: {
    title: 'Principal Component Analysis based on LCMS profiles - PC34',
    xaxis: {
      title: 'PC3 (variance explained: 10%)',
    },
    yaxis: {
      title: 'PC4 (variance explained: 9.2%)',
    },
  },
};

export const network = {
  data: [
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.892,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.0917, 0.1292],
      xaxis: 'x',
      y: [0.6276, 0.6481],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.8981,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7728, 0.6825],
      xaxis: 'x',
      y: [0.5641, 0.4368],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9007,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.552, 0.3918],
      xaxis: 'x',
      y: [0.3713, 0.3033],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9079,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7285, 0.7626, 'NA', 0.6937, 0.6075],
      xaxis: 'x',
      y: [0.3752, 0.367, 'NA', 0.3612, 0.3043],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9132,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.5222, 0.6727],
      xaxis: 'x',
      y: [0.4129, 0.4699],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9151,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.552, 0.6825],
      xaxis: 'x',
      y: [0.3713, 0.4368],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9166,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7443, 0.7626],
      xaxis: 'x',
      y: [0.3945, 0.367],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9177,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7732, 0.7237],
      xaxis: 'x',
      y: [0.4444, 0.3477],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9181,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.2556, 0.1766],
      xaxis: 'x',
      y: [0.8671, 0.7485],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9223,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.8576, 0.9083],
      xaxis: 'x',
      y: [0.6705, 0.6557],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9226,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6727, 0.5553, 'NA', 0.1192, 0.1292],
      xaxis: 'x',
      y: [0.4699, 0.549, 'NA', 0.7486, 0.6481],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9238,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6135, 0.7285],
      xaxis: 'x',
      y: [0.3516, 0.3752],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9249,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6662, 0.6075],
      xaxis: 'x',
      y: [0.4582, 0.3043],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9276,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6386, 0.7606],
      xaxis: 'x',
      y: [0.4172, 0.4842],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9287,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.1094, 0.0865],
      xaxis: 'x',
      y: [0.8343, 0.793],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9306,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6662, 0.5222],
      xaxis: 'x',
      y: [0.4582, 0.4129],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9317,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.5988, 0.5251],
      xaxis: 'x',
      y: [1, 0.9978],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9366,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7285, 0.7791],
      xaxis: 'x',
      y: [0.3752, 0.4055],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9374,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.0387, 0.1766],
      xaxis: 'x',
      y: [0.7881, 0.7485],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9378,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.3036, 0.1766],
      xaxis: 'x',
      y: [0.8399, 0.7485],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9381,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.5102, 0.6727],
      xaxis: 'x',
      y: [0.4693, 0.4699],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9385,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6727, 0.8491],
      xaxis: 'x',
      y: [0.4699, 0.4717],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9453,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7443, 0.7791],
      xaxis: 'x',
      y: [0.3945, 0.4055],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9476,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6727, 0.753],
      xaxis: 'x',
      y: [0.4699, 0.6109],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9502,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6075, 0.6559],
      xaxis: 'x',
      y: [0.3043, 0.4394],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9517,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7606, 0.6825],
      xaxis: 'x',
      y: [0.4842, 0.4368],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9551,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.1192, 0.1094],
      xaxis: 'x',
      y: [0.7486, 0.8343],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9555,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7728, 0.6845],
      xaxis: 'x',
      y: [0.5641, 0.4527],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9589,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7728, 0.6559, 'NA', 0.6937, 0.6792],
      xaxis: 'x',
      y: [0.5641, 0.4394, 'NA', 0.3612, 0.3355],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9604,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.1192, 0.0991, 'NA', 0.6662, 0.5102],
      xaxis: 'x',
      y: [0.7486, 0.8612, 'NA', 0.4582, 0.4693],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.962,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6971, 0.6937],
      xaxis: 'x',
      y: [0.516, 0.3612],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9631,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [1, 0.8491],
      xaxis: 'x',
      y: [0.4862, 0.4717],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9638,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6662, 0.8491],
      xaxis: 'x',
      y: [0.4582, 0.4717],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9642,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.0491, 0.0991],
      xaxis: 'x',
      y: [0.7461, 0.8612],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9654,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.5553, 0.6559],
      xaxis: 'x',
      y: [0.549, 0.4394],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9729,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.552, 0.6845],
      xaxis: 'x',
      y: [0.3713, 0.4527],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.974,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6662, 0.5553],
      xaxis: 'x',
      y: [0.4582, 0.549],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9752,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.235, 0.3257],
      xaxis: 'x',
      y: [0.9116, 0.902],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9763,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.552, 0.6559],
      xaxis: 'x',
      y: [0.3713, 0.4394],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9805,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.0491, 0.1766],
      xaxis: 'x',
      y: [0.7461, 0.7485],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9812,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.102, 0.0722],
      xaxis: 'x',
      y: [0.4428, 0.3871],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.988,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6135, 0.7237],
      xaxis: 'x',
      y: [0.3516, 0.3477],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 1.9994,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6662, 0.753],
      xaxis: 'x',
      y: [0.4582, 0.6109],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.0013,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.2979, 0.1766],
      xaxis: 'x',
      y: [0.8169, 0.7485],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.002,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7285, 0.6792],
      xaxis: 'x',
      y: [0.3752, 0.3355],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.0039,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6971, 0.7606],
      xaxis: 'x',
      y: [0.516, 0.4842],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.0043,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.2979, 0.235],
      xaxis: 'x',
      y: [0.8169, 0.9116],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.0047,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7732, 0.6937],
      xaxis: 'x',
      y: [0.4444, 0.3612],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.005,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6971, 0.7285],
      xaxis: 'x',
      y: [0.516, 0.3752],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.0081,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6386, 0.5652],
      xaxis: 'x',
      y: [0.4172, 0.5023],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.0103,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6063, 0.6845],
      xaxis: 'x',
      y: [0.5356, 0.4527],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.0111,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7443, 0.6792],
      xaxis: 'x',
      y: [0.3945, 0.3355],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.0141,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7606, 0.6559],
      xaxis: 'x',
      y: [0.4842, 0.4394],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.016,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.0865, 0.2114],
      xaxis: 'x',
      y: [0.793, 0.8287],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.0171,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.0722, 0],
      xaxis: 'x',
      y: [0.3871, 0.4009],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.0209,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6135, 0.481],
      xaxis: 'x',
      y: [0.3516, 0.2641],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.022,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7732, 0.7728],
      xaxis: 'x',
      y: [0.4444, 0.5641],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.0247,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.1192, 0.1766],
      xaxis: 'x',
      y: [0.7486, 0.7485],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.0319,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6135, 0.7443],
      xaxis: 'x',
      y: [0.3516, 0.3945],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.033,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.5652, 0.6825],
      xaxis: 'x',
      y: [0.5023, 0.4368],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.036,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6727, 0.7728],
      xaxis: 'x',
      y: [0.4699, 0.5641],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.0387,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.1192, 0.2114],
      xaxis: 'x',
      y: [0.7486, 0.8287],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.0413,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6135, 0.6937],
      xaxis: 'x',
      y: [0.3516, 0.3612],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.044,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.8398, 0.9083],
      xaxis: 'x',
      y: [0.6954, 0.6557],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.0481,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6386, 0.7626],
      xaxis: 'x',
      y: [0.4172, 0.367],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.0485,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7285, 0.7732],
      xaxis: 'x',
      y: [0.3752, 0.4444],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.0493,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7237, 0.7791],
      xaxis: 'x',
      y: [0.3477, 0.4055],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.0511,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.8133, 0.8936],
      xaxis: 'x',
      y: [0.9545, 0.9157],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.0542,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7443, 0.7606, 'NA', 0.552, 0.6727],
      xaxis: 'x',
      y: [0.3945, 0.4842, 'NA', 0.3713, 0.4699],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.0568,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7606, 0.6845],
      xaxis: 'x',
      y: [0.4842, 0.4527],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.058,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7443, 0.7732],
      xaxis: 'x',
      y: [0.3945, 0.4444],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.0727,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6971, 0.6505],
      xaxis: 'x',
      y: [0.516, 0.6849],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.0738,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6825, 0.7626],
      xaxis: 'x',
      y: [0.4368, 0.367],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.0776,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.1094, 0.2114],
      xaxis: 'x',
      y: [0.8343, 0.8287],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.0893,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.0991, 0.235],
      xaxis: 'x',
      y: [0.8612, 0.9116],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.0901,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6662, 0.7728],
      xaxis: 'x',
      y: [0.4582, 0.5641],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.098,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.5652, 0.6559],
      xaxis: 'x',
      y: [0.5023, 0.4394],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.0995,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.5434, 0.6845],
      xaxis: 'x',
      y: [0.4761, 0.4527],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.1044,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6744, 0.6247],
      xaxis: 'x',
      y: [0, 0.0096],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.1086,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6063, 0.6825, 'NA', 0.552, 0.6662],
      xaxis: 'x',
      y: [0.5356, 0.4368, 'NA', 0.3713, 0.4582],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.1196,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6937, 0.7791],
      xaxis: 'x',
      y: [0.3612, 0.4055],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.1207,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7728, 0.9083],
      xaxis: 'x',
      y: [0.5641, 0.6557],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.1271,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6063, 0.6559],
      xaxis: 'x',
      y: [0.5356, 0.4394],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.1283,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.0865, 0.1766],
      xaxis: 'x',
      y: [0.793, 0.7485],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.1301,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6247, 0.6485],
      xaxis: 'x',
      y: [0.0096, 0.0807],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.1309,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6727, 0.5434],
      xaxis: 'x',
      y: [0.4699, 0.4761],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.1335,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.5652, 0.6845],
      xaxis: 'x',
      y: [0.5023, 0.4527],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.1366,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7606, 0.7732],
      xaxis: 'x',
      y: [0.4842, 0.4444],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.1385,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6386, 0.7791],
      xaxis: 'x',
      y: [0.4172, 0.4055],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.14,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7626, 0.6559],
      xaxis: 'x',
      y: [0.367, 0.4394],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.1494,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6386, 0.6792],
      xaxis: 'x',
      y: [0.4172, 0.3355],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.1509,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6247, 0.7121, 'NA', 0.6135, 0.6825],
      xaxis: 'x',
      y: [0.0096, 0.0757, 'NA', 0.3516, 0.4368],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.1528,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6971, 0.6386],
      xaxis: 'x',
      y: [0.516, 0.4172],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.1536,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6662, 0.5434],
      xaxis: 'x',
      y: [0.4582, 0.4761],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.1645,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.1094, 0.1766],
      xaxis: 'x',
      y: [0.8343, 0.7485],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.1698,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7626, 0.6845],
      xaxis: 'x',
      y: [0.367, 0.4527],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.1763,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6792, 0.6825],
      xaxis: 'x',
      y: [0.3355, 0.4368],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.1797,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6971, 0.6825],
      xaxis: 'x',
      y: [0.516, 0.4368],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.1804,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6727, 0.5652],
      xaxis: 'x',
      y: [0.4699, 0.5023],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.1925,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6135, 0.5222],
      xaxis: 'x',
      y: [0.3516, 0.4129],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.1986,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.5434, 0.6559],
      xaxis: 'x',
      y: [0.4761, 0.4394],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.1993,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6386, 0.7732],
      xaxis: 'x',
      y: [0.4172, 0.4444],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.2016,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.1292, 0.181],
      xaxis: 'x',
      y: [0.6481, 0.6176],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.2099,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7791, 0.6825],
      xaxis: 'x',
      y: [0.4055, 0.4368],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.211,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.0917, 0.1766],
      xaxis: 'x',
      y: [0.6276, 0.7485],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.2182,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6386, 0.5102],
      xaxis: 'x',
      y: [0.4172, 0.4693],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.2193,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.8133, 0.7299],
      xaxis: 'x',
      y: [0.9545, 0.9733],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.2243,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6727, 0.7626],
      xaxis: 'x',
      y: [0.4699, 0.367],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.2269,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7732, 0.6825],
      xaxis: 'x',
      y: [0.4444, 0.4368],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.2322,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6386, 0.5434],
      xaxis: 'x',
      y: [0.4172, 0.4761],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.2386,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6662, 0.5652],
      xaxis: 'x',
      y: [0.4582, 0.5023],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.242,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6792, 0.6845],
      xaxis: 'x',
      y: [0.3355, 0.4527],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.2458,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6792, 0.6559],
      xaxis: 'x',
      y: [0.3355, 0.4394],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.2473,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7791, 0.6845],
      xaxis: 'x',
      y: [0.4055, 0.4527],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.2492,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6971, 0.6559, 'NA', 0.552, 0.6386],
      xaxis: 'x',
      y: [0.516, 0.4394, 'NA', 0.3713, 0.4172],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.2579,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7728, 0.7965],
      xaxis: 'x',
      y: [0.5641, 0.7087],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.2602,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.2114, 0.1766],
      xaxis: 'x',
      y: [0.8287, 0.7485],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.2654,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7285, 0.7237],
      xaxis: 'x',
      y: [0.3752, 0.3477],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.2658,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6727, 0.6063],
      xaxis: 'x',
      y: [0.4699, 0.5356],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.276,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7443, 0.7237],
      xaxis: 'x',
      y: [0.3945, 0.3477],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.2772,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.3036, 0.3257],
      xaxis: 'x',
      y: [0.8399, 0.902],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.2791,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6971, 0.6845],
      xaxis: 'x',
      y: [0.516, 0.4527],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.2836,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6662, 0.7626],
      xaxis: 'x',
      y: [0.4582, 0.367],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.2866,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6135, 0.6559],
      xaxis: 'x',
      y: [0.3516, 0.4394],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.29,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.552, 0.481],
      xaxis: 'x',
      y: [0.3713, 0.2641],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.2934,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6135, 0.6845],
      xaxis: 'x',
      y: [0.3516, 0.4527],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.2942,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7732, 0.6845],
      xaxis: 'x',
      y: [0.4444, 0.4527],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.298,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7732, 0.6559],
      xaxis: 'x',
      y: [0.4444, 0.4394],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.2987,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6662, 0.6063],
      xaxis: 'x',
      y: [0.4582, 0.5356],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.2995,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.5222, 0.5102],
      xaxis: 'x',
      y: [0.4129, 0.4693],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.3002,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7791, 0.6559],
      xaxis: 'x',
      y: [0.4055, 0.4394],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.3025,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6135, 0.6662],
      xaxis: 'x',
      y: [0.3516, 0.4582],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.3029,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6386, 0.6063],
      xaxis: 'x',
      y: [0.4172, 0.5356],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.304,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6662, 0.7606],
      xaxis: 'x',
      y: [0.4582, 0.4842],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.3123,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6744, 0.6485],
      xaxis: 'x',
      y: [0, 0.0807],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.318,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6662, 0.7791],
      xaxis: 'x',
      y: [0.4582, 0.4055],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.3267,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6727, 0.7791],
      xaxis: 'x',
      y: [0.4699, 0.4055],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.3342,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6727, 0.6792],
      xaxis: 'x',
      y: [0.4699, 0.3355],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.338,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.3036, 0.2979],
      xaxis: 'x',
      y: [0.8399, 0.8169],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.3399,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6135, 0.6727],
      xaxis: 'x',
      y: [0.3516, 0.4699],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.3569,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6727, 0.7606],
      xaxis: 'x',
      y: [0.4699, 0.4842],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.3683,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7285, 0.6937],
      xaxis: 'x',
      y: [0.3752, 0.3612],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.3705,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.552, 0.6135],
      xaxis: 'x',
      y: [0.3713, 0.3516],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.3773,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6386, 0.5222],
      xaxis: 'x',
      y: [0.4172, 0.4129],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.3792,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7443, 0.6937],
      xaxis: 'x',
      y: [0.3945, 0.3612],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.3887,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6727, 0.7732],
      xaxis: 'x',
      y: [0.4699, 0.4444],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.3966,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6662, 0.6792],
      xaxis: 'x',
      y: [0.4582, 0.3355],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.4,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6971, 0.6662],
      xaxis: 'x',
      y: [0.516, 0.4582],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.4004,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.2979, 0.3257],
      xaxis: 'x',
      y: [0.8169, 0.902],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.4166,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.2556, 0.235],
      xaxis: 'x',
      y: [0.8671, 0.9116],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.4272,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.235, 0.2114],
      xaxis: 'x',
      y: [0.9116, 0.8287],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.4306,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.8576, 0.7728],
      xaxis: 'x',
      y: [0.6705, 0.5641],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.4314,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7443, 0.7285],
      xaxis: 'x',
      y: [0.3945, 0.3752],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.434,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7728, 0.8398],
      xaxis: 'x',
      y: [0.5641, 0.6954],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.4438,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.1766, 0.181],
      xaxis: 'x',
      y: [0.7485, 0.6176],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.4446,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6135, 0.6386],
      xaxis: 'x',
      y: [0.3516, 0.4172],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.4522,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6662, 0.7732],
      xaxis: 'x',
      y: [0.4582, 0.4444],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.5134,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6971, 0.7443],
      xaxis: 'x',
      y: [0.516, 0.3945],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.5478,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6744, 0.7181],
      xaxis: 'x',
      y: [0, 0.0287],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.5648,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6937, 0.7237],
      xaxis: 'x',
      y: [0.3612, 0.3477],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.5829,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7121, 0.6485],
      xaxis: 'x',
      y: [0.0757, 0.0807],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.5984,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6386, 0.7285],
      xaxis: 'x',
      y: [0.4172, 0.3752],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.6014,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.753, 0.7965],
      xaxis: 'x',
      y: [0.6109, 0.7087],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.6052,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.2556, 0.3257],
      xaxis: 'x',
      y: [0.8671, 0.902],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.6064,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7181, 0.6247],
      xaxis: 'x',
      y: [0.0287, 0.0096],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.6079,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6971, 0.6727],
      xaxis: 'x',
      y: [0.516, 0.4699],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.6219,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.3036, 0.235],
      xaxis: 'x',
      y: [0.8399, 0.9116],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.6234,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7181, 0.6485],
      xaxis: 'x',
      y: [0.0287, 0.0807],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.6306,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.2556, 0.2979],
      xaxis: 'x',
      y: [0.8671, 0.8169],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.6309,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7285, 0.6825],
      xaxis: 'x',
      y: [0.3752, 0.4368],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.6404,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6386, 0.7237],
      xaxis: 'x',
      y: [0.4172, 0.3477],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.6827,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.8576, 0.7965],
      xaxis: 'x',
      y: [0.6705, 0.7087],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.6956,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6386, 0.6937],
      xaxis: 'x',
      y: [0.4172, 0.3612],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.7107,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7285, 0.6845, 'NA', 0.7443, 0.6825],
      xaxis: 'x',
      y: [0.3752, 0.4527, 'NA', 0.3945, 0.4368],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.7152,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7285, 0.6559],
      xaxis: 'x',
      y: [0.3752, 0.4394],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.7209,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7181, 0.7121],
      xaxis: 'x',
      y: [0.0287, 0.0757],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.7224,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7237, 0.6559],
      xaxis: 'x',
      y: [0.3477, 0.4394],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.7273,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7443, 0.6559],
      xaxis: 'x',
      y: [0.3945, 0.4394],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.7371,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.0387, 0.0991],
      xaxis: 'x',
      y: [0.7881, 0.8612],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.7394,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.0991, 0.1094],
      xaxis: 'x',
      y: [0.8612, 0.8343],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.7572,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.8576, 0.753],
      xaxis: 'x',
      y: [0.6705, 0.6109],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.7643,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7443, 0.6845, 'NA', 0.6744, 0.7121],
      xaxis: 'x',
      y: [0.3945, 0.4527, 'NA', 0, 0.0757],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.7696,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6386, 0.7443],
      xaxis: 'x',
      y: [0.4172, 0.3945],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.7742,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7237, 0.6825],
      xaxis: 'x',
      y: [0.3477, 0.4368],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.8116,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.3036, 0.2114],
      xaxis: 'x',
      y: [0.8399, 0.8287],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.8135,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7237, 0.6845],
      xaxis: 'x',
      y: [0.3477, 0.4527],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.8222,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7285, 0.6727],
      xaxis: 'x',
      y: [0.3752, 0.4699],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.8328,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6069, 0.6247],
      xaxis: 'x',
      y: [0.0542, 0.0096],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.8411,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6069, 0.6485],
      xaxis: 'x',
      y: [0.0542, 0.0807],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.8464,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.0387, 0.1094],
      xaxis: 'x',
      y: [0.7881, 0.8343],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.8637,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.1292, 0.1766],
      xaxis: 'x',
      y: [0.6481, 0.7485],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.8671,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.2979, 0.2114],
      xaxis: 'x',
      y: [0.8169, 0.8287],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.8796,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7791, 0.8491],
      xaxis: 'x',
      y: [0.4055, 0.4717],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.8959,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6662, 0.6937],
      xaxis: 'x',
      y: [0.4582, 0.3612],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.897,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6662, 0.7285],
      xaxis: 'x',
      y: [0.4582, 0.3752],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.9378,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.3257, 0.2114],
      xaxis: 'x',
      y: [0.902, 0.8287],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.9435,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.753, 0.8398],
      xaxis: 'x',
      y: [0.6109, 0.6954],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.9526,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6727, 0.7237],
      xaxis: 'x',
      y: [0.4699, 0.3477],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.9548,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6386, 0.6845],
      xaxis: 'x',
      y: [0.4172, 0.4527],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.9805,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.0491, 0.1192],
      xaxis: 'x',
      y: [0.7461, 0.7486],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.9839,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.3036, 0.2556],
      xaxis: 'x',
      y: [0.8399, 0.8671],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 2.9885,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.0491, 0.0865],
      xaxis: 'x',
      y: [0.7461, 0.793],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.0043,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6662, 0.7443],
      xaxis: 'x',
      y: [0.4582, 0.3945],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.0115,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6727, 0.6937],
      xaxis: 'x',
      y: [0.4699, 0.3612],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.0164,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6662, 0.7237],
      xaxis: 'x',
      y: [0.4582, 0.3477],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.0285,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.1192, 0.0865],
      xaxis: 'x',
      y: [0.7486, 0.793],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.035,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7965, 0.8398],
      xaxis: 'x',
      y: [0.7087, 0.6954],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.0414,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7443, 0.6727],
      xaxis: 'x',
      y: [0.3945, 0.4699],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.0675,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6386, 0.6559],
      xaxis: 'x',
      y: [0.4172, 0.4394],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.1011,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6069, 0.7121],
      xaxis: 'x',
      y: [0.0542, 0.0757],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.1037,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6386, 0.6825],
      xaxis: 'x',
      y: [0.4172, 0.4368],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.1041,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6937, 0.6845],
      xaxis: 'x',
      y: [0.3612, 0.4527],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.1056,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.7728, 0.753],
      xaxis: 'x',
      y: [0.5641, 0.6109],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.1438,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6937, 0.6559],
      xaxis: 'x',
      y: [0.3612, 0.4394],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.1468,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6937, 0.6825],
      xaxis: 'x',
      y: [0.3612, 0.4368],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.1586,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.8576, 0.8398],
      xaxis: 'x',
      y: [0.6705, 0.6954],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.1642,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.2556, 0.2114],
      xaxis: 'x',
      y: [0.8671, 0.8287],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.2251,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6825, 0.6845],
      xaxis: 'x',
      y: [0.4368, 0.4527],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.298,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6069, 0.7181],
      xaxis: 'x',
      y: [0.0542, 0.0287],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.3003,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6825, 0.6559],
      xaxis: 'x',
      y: [0.4368, 0.4394],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.3112,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6662, 0.6845],
      xaxis: 'x',
      y: [0.4582, 0.4527],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.3165,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6727, 0.6825],
      xaxis: 'x',
      y: [0.4699, 0.4368],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.318,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6727, 0.6845],
      xaxis: 'x',
      y: [0.4699, 0.4527],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.3294,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6727, 0.6559],
      xaxis: 'x',
      y: [0.4699, 0.4394],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.3369,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6386, 0.6727],
      xaxis: 'x',
      y: [0.4172, 0.4699],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.3555,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6662, 0.6559],
      xaxis: 'x',
      y: [0.4582, 0.4394],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.3581,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6559, 0.6845],
      xaxis: 'x',
      y: [0.4394, 0.4527],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.3759,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6662, 0.6825],
      xaxis: 'x',
      y: [0.4582, 0.4368],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.3967,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.1017, 0.0643],
      xaxis: 'x',
      y: [0.2804, 0.2205],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.4057,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6386, 0.6662],
      xaxis: 'x',
      y: [0.4172, 0.4582],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.6627,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6069, 0.6744],
      xaxis: 'x',
      y: [0.0542, 0],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.6903,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.6662, 0.6727],
      xaxis: 'x',
      y: [0.4582, 0.4699],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      line: {
        color: 'rgba(127,127,127,0.25)',
        dash: 'solid',
        width: 3.7043,
      },
      marker: {
        line: {},
      },
      mode: 'lines',
      showlegend: false,
      text: [''],
      textfont: {},
      type: 'scatter',
      x: [0.1837, 0.2278],
      xaxis: 'x',
      y: [0.1704, 0.1123],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M100.95T574.33,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M100.95T574.33,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M100.95T574.33<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.6247],
      xaxis: 'x',
      y: [0.0096],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M100.95T719.24,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M100.95T719.24,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M100.95T719.24<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.6744],
      xaxis: 'x',
      y: [0],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M150.06T343.91,15,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(128,177,211,1)',
        line: {
          color: 'rgba(128,177,211,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'square',
      },
      mode: 'markers',
      name: '(0.8,M150.06T343.91,15,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M150.06T343.91<br /><b>Database spectrum ID: </b>CCMSLIB00000213784<br /><b>Database compound name: </b>Guanine 2-Amino-6-hydroxypurine 2-Amino-6-oxypurine 2-Aminohypoxanthine Guanine enol 6-Hydroxy-2-aminopurine<br /><b>Database SMILES: </b>C1=NC2=C(N1)C(=O)N=C(N2)N<br /><b>Database reference: </b>RESPECT.mgf<br /><b>dot product (database - sample): </b>0.68',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.102],
      xaxis: 'x',
      y: [0.4428],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M150.06T77.98,15,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(128,177,211,1)',
        line: {
          color: 'rgba(128,177,211,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'square',
      },
      mode: 'markers',
      name: '(0.8,M150.06T77.98,15,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M150.06T77.98<br /><b>Database spectrum ID: </b>CCMSLIB00000220821<br /><b>Database compound name: </b>3-Methyladenine 6-Amino-3-methylpurine 3-methylpurin-6-amine<br /><b>Database SMILES: </b>CN1C=NC(=C2C1=NC=N2)N<br /><b>Database reference: </b>RESPECT.mgf<br /><b>dot product (database - sample): </b>0.65',
      ],
      textfont: {},
      type: 'scatter',
      x: [0],
      xaxis: 'x',
      y: [0.4009],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M150.07T221.89,15,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(128,177,211,1)',
        line: {
          color: 'rgba(128,177,211,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'square',
      },
      mode: 'markers',
      name: '(0.8,M150.07T221.89,15,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M150.07T221.89<br /><b>Database spectrum ID: </b>CCMSLIB00000213784<br /><b>Database compound name: </b>Guanine 2-Amino-6-hydroxypurine 2-Amino-6-oxypurine 2-Aminohypoxanthine Guanine enol 6-Hydroxy-2-aminopurine<br /><b>Database SMILES: </b>C1=NC2=C(N1)C(=O)N=C(N2)N<br /><b>Database reference: </b>RESPECT.mgf<br /><b>dot product (database - sample): </b>0.52',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.0722],
      xaxis: 'x',
      y: [0.3871],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M165.05T871.34,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M165.05T871.34,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M165.05T871.34<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.5988],
      xaxis: 'x',
      y: [1],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M175T229.42,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M175T229.42,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M175T229.42<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.7626],
      xaxis: 'x',
      y: [0.367],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M175T309.76,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M175T309.76,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M175T309.76<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.5434],
      xaxis: 'x',
      y: [0.4761],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M179.08T381.57,15,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(128,177,211,1)',
        line: {
          color: 'rgba(128,177,211,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'square',
      },
      mode: 'markers',
      name: '(0.8,M179.08T381.57,15,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M179.08T381.57<br /><b>Database spectrum ID: </b>CCMSLIB00000426947<br /><b>Database compound name: </b>Allose<br /><b>Database SMILES: </b>[H][C@@]1(CO)OC(O)[C@@]([H])(O)[C@@]([H])(O)[C@@]1([H])O<br /><b>Database reference: </b>HMDB.mgf<br /><b>dot product (database - sample): </b>0.51',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.6505],
      xaxis: 'x',
      y: [0.6849],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M201.03T248,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M201.03T248,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M201.03T248<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.6559],
      xaxis: 'x',
      y: [0.4394],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M202.99T285.16,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M202.99T285.16,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M202.99T285.16<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.6825],
      xaxis: 'x',
      y: [0.4368],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M202.99T487.57,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M202.99T487.57,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M202.99T487.57<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.6937],
      xaxis: 'x',
      y: [0.3612],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M217.01T315.29,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M217.01T315.29,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M217.01T315.29<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.6845],
      xaxis: 'x',
      y: [0.4527],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M223.03T542.39,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M223.03T542.39,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M223.03T542.39<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.3918],
      xaxis: 'x',
      y: [0.3033],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M239.07T870.83,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M239.07T870.83,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M239.07T870.83<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.5251],
      xaxis: 'x',
      y: [0.9978],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M253.23T783.49,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M253.23T783.49,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M253.23T783.49<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.9083],
      xaxis: 'x',
      y: [0.6557],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M255.24T824.15,15,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(128,177,211,1)',
        line: {
          color: 'rgba(128,177,211,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'square',
      },
      mode: 'markers',
      name: '(0.8,M255.24T824.15,15,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M255.24T824.15<br /><b>Database spectrum ID: </b>CCMSLIB00004683387<br /><b>Database compound name: </b>Palmitic acid (NMR) - 10eV<br /><b>Database SMILES: </b>OC(=O)CCCCCCCCCCCCCCC<br /><b>Database reference: </b>SUMNER.mgf<br /><b>dot product (database - sample): </b>1',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.8398],
      xaxis: 'x',
      y: [0.6954],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M255.24T913.5,15,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(128,177,211,1)',
        line: {
          color: 'rgba(128,177,211,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'square',
      },
      mode: 'markers',
      name: '(0.8,M255.24T913.5,15,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M255.24T913.5<br /><b>Database spectrum ID: </b>CCMSLIB00004683389<br /><b>Database compound name: </b>Palmitic acid (NMR) - 20eV<br /><b>Database SMILES: </b>OC(=O)CCCCCCCCCCCCCCC<br /><b>Database reference: </b>SUMNER.mgf<br /><b>dot product (database - sample): </b>0.98',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.8576],
      xaxis: 'x',
      y: [0.6705],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M265.16T669.06,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M265.16T669.06,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M265.16T669.06<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.8936],
      xaxis: 'x',
      y: [0.9157],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M281.26T834.69,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M281.26T834.69,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M281.26T834.69<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.2278],
      xaxis: 'x',
      y: [0.1123],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M285.12T372.03,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M285.12T372.03,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M285.12T372.03<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.5553],
      xaxis: 'x',
      y: [0.549],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M293.19T740.33,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M293.19T740.33,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M293.19T740.33<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.8133],
      xaxis: 'x',
      y: [0.9545],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M295.24T666.55,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M295.24T666.55,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M295.24T666.55<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.181],
      xaxis: 'x',
      y: [0.6176],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M297.16T679.6,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M297.16T679.6,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M297.16T679.6<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.1766],
      xaxis: 'x',
      y: [0.7485],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M297.25T704.69,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M297.25T704.69,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M297.25T704.69<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.1292],
      xaxis: 'x',
      y: [0.6481],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M299.21T766.42,15,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(128,177,211,1)',
        line: {
          color: 'rgba(128,177,211,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'square',
      },
      mode: 'markers',
      name: '(0.8,M299.21T766.42,15,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M299.21T766.42<br /><b>Database spectrum ID: </b>CCMSLIB00000078634<br /><b>Database compound name: </b>Norethindrone (Norethisterone)<br /><b>Database SMILES: </b>[C@@]12([C@@]([C@@](C#C)(O)CC1)(CC[C@@]3([C@]2(CCC4[C@@]3(CCC(C=4)=O)[H])[H])[H])C)[H]<br /><b>Database reference: </b>GNPS-SELLECKCHEM-FDA-PART2.mgf<br /><b>dot product (database - sample): </b>0.58',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.0917],
      xaxis: 'x',
      y: [0.6276],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M301.23T823.14,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M301.23T823.14,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M301.23T823.14<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.7965],
      xaxis: 'x',
      y: [0.7087],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M303.13T378.06,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M303.13T378.06,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M303.13T378.06<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.7791],
      xaxis: 'x',
      y: [0.4055],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M305.26T829.67,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M305.26T829.67,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M305.26T829.67<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.5652],
      xaxis: 'x',
      y: [0.5023],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M309.18T699.17,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M309.18T699.17,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M309.18T699.17<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.3257],
      xaxis: 'x',
      y: [0.902],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M309.29T876.1,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M309.29T876.1,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M309.29T876.1<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.2979],
      xaxis: 'x',
      y: [0.8169],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M311.18T706.7,15,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(128,177,211,1)',
        line: {
          color: 'rgba(128,177,211,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'square',
      },
      mode: 'markers',
      name: '(0.8,M311.18T706.7,15,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M311.18T706.7<br /><b>Database spectrum ID: </b>CCMSLIB00000078120<br /><b>Database compound name: </b>Gestodene<br /><b>Database SMILES: </b>C1C(C=C2[C@](C1)([C@]3([C@@](CC2)([C@]4([C@](CC3)([C@@](C=C4)(O)C#C)CC)[H])[H])[H])[H])=O<br /><b>Database reference: </b>GNPS-SELLECKCHEM-FDA-PART2.mgf<br /><b>dot product (database - sample): </b>0.62',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.2114],
      xaxis: 'x',
      y: [0.8287],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M311.18T908.23,15,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(128,177,211,1)',
        line: {
          color: 'rgba(128,177,211,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'square',
      },
      mode: 'markers',
      name: '(0.8,M311.18T908.23,15,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M311.18T908.23<br /><b>Database spectrum ID: </b>CCMSLIB00000078120<br /><b>Database compound name: </b>Gestodene<br /><b>Database SMILES: </b>C1C(C=C2[C@](C1)([C@]3([C@@](CC2)([C@]4([C@](CC3)([C@@](C=C4)(O)C#C)CC)[H])[H])[H])[H])=O<br /><b>Database reference: </b>GNPS-SELLECKCHEM-FDA-PART2.mgf<br /><b>dot product (database - sample): </b>0.68',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.2556],
      xaxis: 'x',
      y: [0.8671],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M311.3T906.98,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M311.3T906.98,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M311.3T906.98<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.3036],
      xaxis: 'x',
      y: [0.8399],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M313.09T843.72,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M313.09T843.72,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M313.09T843.72<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.235],
      xaxis: 'x',
      y: [0.9116],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M319.13T334.87,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M319.13T334.87,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M319.13T334.87<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.8491],
      xaxis: 'x',
      y: [0.4717],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M325.19T736.82,15,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(128,177,211,1)',
        line: {
          color: 'rgba(128,177,211,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'square',
      },
      mode: 'markers',
      name: '(0.8,M325.19T736.82,15,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M325.19T736.82<br /><b>Database spectrum ID: </b>CCMSLIB00000004257<br /><b>Database compound name: </b>QuinineHCl<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>GNPS-SELLECKCHEM-FDA-PART1.mgf<br /><b>dot product (database - sample): </b>0.74',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.0865],
      xaxis: 'x',
      y: [0.793],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M325.19T930.06,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M325.19T930.06,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M325.19T930.06<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.0491],
      xaxis: 'x',
      y: [0.7461],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M325.32T921.53,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M325.32T921.53,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M325.32T921.53<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.1192],
      xaxis: 'x',
      y: [0.7486],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M332.16T396.62,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M332.16T396.62,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M332.16T396.62<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.6792],
      xaxis: 'x',
      y: [0.3355],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M337.25T825.9,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M337.25T825.9,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M337.25T825.9<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.0991],
      xaxis: 'x',
      y: [0.8612],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M339.21T761.15,15,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(128,177,211,1)',
        line: {
          color: 'rgba(128,177,211,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'square',
      },
      mode: 'markers',
      name: '(0.8,M339.21T761.15,15,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M339.21T761.15<br /><b>Database spectrum ID: </b>CCMSLIB00000006215<br /><b>Database compound name: </b>OlopatadineHCl<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>GNPS-SELLECKCHEM-FDA-PART1.mgf<br /><b>dot product (database - sample): </b>0.67',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.1094],
      xaxis: 'x',
      y: [0.8343],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M339.21T921.78,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M339.21T921.78,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M339.21T921.78<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.0387],
      xaxis: 'x',
      y: [0.7881],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M353.22T823.64,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M353.22T823.64,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M353.22T823.64<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.753],
      xaxis: 'x',
      y: [0.6109],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M353.22T827.15,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M353.22T827.15,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M353.22T827.15<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.7728],
      xaxis: 'x',
      y: [0.5641],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M361.14T394.37,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M361.14T394.37,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M361.14T394.37<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.6075],
      xaxis: 'x',
      y: [0.3043],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M365.22T839.7,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M365.22T839.7,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M365.22T839.7<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.7606],
      xaxis: 'x',
      y: [0.4842],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M367.24T875.85,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M367.24T875.85,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M367.24T875.85<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.5222],
      xaxis: 'x',
      y: [0.4129],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M379.24T837.69,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M379.24T837.69,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M379.24T837.69<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.7732],
      xaxis: 'x',
      y: [0.4444],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M381.25T878.86,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M381.25T878.86,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M381.25T878.86<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.481],
      xaxis: 'x',
      y: [0.2641],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M383.36T873.59,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M383.36T873.59,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M383.36T873.59<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.5102],
      xaxis: 'x',
      y: [0.4693],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M387.11T869.82,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M387.11T869.82,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M387.11T869.82<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.7285],
      xaxis: 'x',
      y: [0.3752],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M390.17T395.62,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M390.17T395.62,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M390.17T395.62<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.7237],
      xaxis: 'x',
      y: [0.3477],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M395.4T880.11,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M395.4T880.11,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M395.4T880.11<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.7443],
      xaxis: 'x',
      y: [0.3945],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M397.34T906.97,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M397.34T906.97,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M397.34T906.97<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.6135],
      xaxis: 'x',
      y: [0.3516],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M411.36T917.01,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M411.36T917.01,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M411.36T917.01<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [1],
      xaxis: 'x',
      y: [0.4862],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M411.4T900.95,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M411.4T900.95,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M411.4T900.95<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.6971],
      xaxis: 'x',
      y: [0.516],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M415.32T862.28,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M415.32T862.28,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M415.32T862.28<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.6727],
      xaxis: 'x',
      y: [0.4699],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M417.33T893.92,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M417.33T893.92,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M417.33T893.92<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.6662],
      xaxis: 'x',
      y: [0.4582],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M425.38T928.56,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M425.38T928.56,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M425.38T928.56<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.552],
      xaxis: 'x',
      y: [0.3713],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M426.15T399.63,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M426.15T399.63,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M426.15T399.63<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.6063],
      xaxis: 'x',
      y: [0.5356],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M465.32T896.93,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M465.32T896.93,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M465.32T896.93<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.6386],
      xaxis: 'x',
      y: [0.4172],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M563.52T836.69,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M563.52T836.69,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M563.52T836.69<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.1837],
      xaxis: 'x',
      y: [0.1704],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M744.44T880.37,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M744.44T880.37,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M744.44T880.37<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.0643],
      xaxis: 'x',
      y: [0.2205],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M758.46T882.88,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M758.46T882.88,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M758.46T882.88<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.1017],
      xaxis: 'x',
      y: [0.2804],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M96.96T62.43,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M96.96T62.43,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M96.96T62.43<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.7299],
      xaxis: 'x',
      y: [0.9733],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M98.95T577.6,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M98.95T577.6,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M98.95T577.6<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.7121],
      xaxis: 'x',
      y: [0.0757],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M98.95T695.15,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M98.95T695.15,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M98.95T695.15<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.7181],
      xaxis: 'x',
      y: [0.0287],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M98.95T98.37,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M98.95T98.37,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M98.95T98.37<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.6485],
      xaxis: 'x',
      y: [0.0807],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: {},
      legendgroup: '(0.8,M98.96T924.03,19,8)',
      line: {},
      marker: {
        autocolorscale: false,
        color: 'rgba(253,180,98,1)',
        line: {
          color: 'rgba(253,180,98,1)',
          width: 1.8898,
        },
        opacity: 0.8,
        size: 30.2362,
        symbol: 'circle',
      },
      mode: 'markers',
      name: '(0.8,M98.96T924.03,19,8)',
      showlegend: true,
      text: [
        '<b>sample ID: </b>M98.96T924.03<br /><b>Database spectrum ID: </b>-<br /><b>Database compound name: </b>-<br /><b>Database SMILES: </b>-<br /><b>Database reference: </b>-<br /><b>dot product (database - sample): </b>0',
      ],
      textfont: {},
      type: 'scatter',
      x: [0.6069],
      xaxis: 'x',
      y: [0.0542],
      yaxis: 'y',
    },
    {
      hoverinfo: 'text',
      hoveron: 'points',
      hovertext: [
        'x: 0.00000000<br />y: 0.400945903',
        'x: 0.68453980<br />y: 0.452734803',
        'x: 0.72991777<br />y: 0.973271281',
        'x: 0.64853496<br />y: 0.080678372',
        'x: 0.65588120<br />y: 0.439433461',
        'x: 0.71214802<br />y: 0.075720108',
        'x: 0.07215765<br />y: 0.387052464',
        'x: 0.76256358<br />y: 0.366950580',
        'x: 0.68254503<br />y: 0.436766087',
        'x: 0.10202648<br />y: 0.442827090',
        'x: 0.54344596<br />y: 0.476146341',
        'x: 0.84913217<br />y: 0.471683665',
        'x: 0.77905600<br />y: 0.405515022',
        'x: 0.55532396<br />y: 0.548997388',
        'x: 0.65051103<br />y: 0.684872236',
        'x: 0.72366918<br />y: 0.347715717',
        'x: 0.60747855<br />y: 0.304261124',
        'x: 0.67921076<br />y: 0.335457953',
        'x: 0.60625662<br />y: 0.535602939',
        'x: 0.69373915<br />y: 0.361185544',
        'x: 0.62468474<br />y: 0.009631284',
        'x: 0.39181305<br />y: 0.303267327',
        'x: 0.89359651<br />y: 0.915745332',
        'x: 0.18096845<br />y: 0.617632175',
        'x: 0.17655893<br />y: 0.748462882',
        'x: 0.21139412<br />y: 0.828657181',
        'x: 0.71808852<br />y: 0.028683881',
        'x: 0.32572607<br />y: 0.901988890',
        'x: 0.12918206<br />y: 0.648143856',
        'x: 0.67443631<br />y: 0.000000000',
        'x: 0.08652174<br />y: 0.793039338',
        'x: 0.81327872<br />y: 0.954484844',
        'x: 0.10938711<br />y: 0.834260207',
        'x: 0.09170744<br />y: 0.627610560',
        'x: 0.52508164<br />y: 0.997797325',
        'x: 0.90832961<br />y: 0.655689900',
        'x: 0.83980762<br />y: 0.695387142',
        'x: 0.23504591<br />y: 0.911573726',
        'x: 0.79654877<br />y: 0.708727255',
        'x: 0.75304203<br />y: 0.610908319',
        'x: 0.09913979<br />y: 0.861163877',
        'x: 0.22782281<br />y: 0.112285249',
        'x: 0.77276359<br />y: 0.564056822',
        'x: 0.56521623<br />y: 0.502339815',
        'x: 0.77318555<br />y: 0.444402547',
        'x: 0.18374846<br />y: 0.170391853',
        'x: 0.76058482<br />y: 0.484223289',
        'x: 0.59875649<br />y: 1.000000000',
        'x: 0.67274527<br />y: 0.469947292',
        'x: 0.72854006<br />y: 0.375162356',
        'x: 0.51018214<br />y: 0.469282208',
        'x: 0.29787407<br />y: 0.816887676',
        'x: 0.52218676<br />y: 0.412882126',
        'x: 0.06427771<br />y: 0.220486113',
        'x: 0.74426756<br />y: 0.394472002',
        'x: 0.48100971<br />y: 0.264075683',
        'x: 0.10173873<br />y: 0.280375838',
        'x: 0.66618600<br />y: 0.458247039',
        'x: 0.85758737<br />y: 0.670504881',
        'x: 0.63860711<br />y: 0.417192627',
        'x: 0.25564254<br />y: 0.867079243',
        'x: 0.69708711<br />y: 0.516038944',
        'x: 0.61348696<br />y: 0.351588958',
        'x: 0.30363053<br />y: 0.839867109',
        'x: 0.03873731<br />y: 0.788144854',
        'x: 1.00000000<br />y: 0.486172998',
        'x: 0.11918322<br />y: 0.748623329',
        'x: 0.60689422<br />y: 0.054236902',
        'x: 0.55201353<br />y: 0.371346466',
        'x: 0.04913783<br />y: 0.746106237',
      ],
      line: {},
      marker: {
        line: {},
      },
      mode: 'text',
      showlegend: false,
      text: [
        'M150.06T77.98',
        'M217.01T315.29',
        'M96.96T62.43',
        'M98.95T98.37',
        'M201.03T248',
        'M98.95T577.6',
        'M150.07T221.89',
        'M175T229.42',
        'M202.99T285.16',
        'M150.06T343.91',
        'M175T309.76',
        'M319.13T334.87',
        'M303.13T378.06',
        'M285.12T372.03',
        'M179.08T381.57',
        'M390.17T395.62',
        'M361.14T394.37',
        'M332.16T396.62',
        'M426.15T399.63',
        'M202.99T487.57',
        'M100.95T574.33',
        'M223.03T542.39',
        'M265.16T669.06',
        'M295.24T666.55',
        'M297.16T679.6',
        'M311.18T706.7',
        'M98.95T695.15',
        'M309.18T699.17',
        'M297.25T704.69',
        'M100.95T719.24',
        'M325.19T736.82',
        'M293.19T740.33',
        'M339.21T761.15',
        'M299.21T766.42',
        'M239.07T870.83',
        'M253.23T783.49',
        'M255.24T824.15',
        'M313.09T843.72',
        'M301.23T823.14',
        'M353.22T823.64',
        'M337.25T825.9',
        'M281.26T834.69',
        'M353.22T827.15',
        'M305.26T829.67',
        'M379.24T837.69',
        'M563.52T836.69',
        'M365.22T839.7',
        'M165.05T871.34',
        'M415.32T862.28',
        'M387.11T869.82',
        'M383.36T873.59',
        'M309.29T876.1',
        'M367.24T875.85',
        'M744.44T880.37',
        'M395.4T880.11',
        'M381.25T878.86',
        'M758.46T882.88',
        'M417.33T893.92',
        'M255.24T913.5',
        'M465.32T896.93',
        'M311.18T908.23',
        'M411.4T900.95',
        'M397.34T906.97',
        'M311.3T906.98',
        'M339.21T921.78',
        'M411.36T917.01',
        'M325.32T921.53',
        'M98.96T924.03',
        'M425.38T928.56',
        'M325.19T930.06',
      ],
      textfont: {
        color: 'rgba(0,0,0,1)',
        size: 9.4488,
      },
      type: 'scatter',
      x: [
        0,
        0.6845,
        0.7299,
        0.6485,
        0.6559,
        0.7121,
        0.0722,
        0.7626,
        0.6825,
        0.102,
        0.5434,
        0.8491,
        0.7791,
        0.5553,
        0.6505,
        0.7237,
        0.6075,
        0.6792,
        0.6063,
        0.6937,
        0.6247,
        0.3918,
        0.8936,
        0.181,
        0.1766,
        0.2114,
        0.7181,
        0.3257,
        0.1292,
        0.6744,
        0.0865,
        0.8133,
        0.1094,
        0.0917,
        0.5251,
        0.9083,
        0.8398,
        0.235,
        0.7965,
        0.753,
        0.0991,
        0.2278,
        0.7728,
        0.5652,
        0.7732,
        0.1837,
        0.7606,
        0.5988,
        0.6727,
        0.7285,
        0.5102,
        0.2979,
        0.5222,
        0.0643,
        0.7443,
        0.481,
        0.1017,
        0.6662,
        0.8576,
        0.6386,
        0.2556,
        0.6971,
        0.6135,
        0.3036,
        0.0387,
        1,
        0.1192,
        0.6069,
        0.552,
        0.0491,
      ],
      xaxis: 'x',
      y: [
        0.4009,
        0.4527,
        0.9733,
        0.0807,
        0.4394,
        0.0757,
        0.3871,
        0.367,
        0.4368,
        0.4428,
        0.4761,
        0.4717,
        0.4055,
        0.549,
        0.6849,
        0.3477,
        0.3043,
        0.3355,
        0.5356,
        0.3612,
        0.0096,
        0.3033,
        0.9157,
        0.6176,
        0.7485,
        0.8287,
        0.0287,
        0.902,
        0.6481,
        0,
        0.793,
        0.9545,
        0.8343,
        0.6276,
        0.9978,
        0.6557,
        0.6954,
        0.9116,
        0.7087,
        0.6109,
        0.8612,
        0.1123,
        0.5641,
        0.5023,
        0.4444,
        0.1704,
        0.4842,
        1,
        0.4699,
        0.3752,
        0.4693,
        0.8169,
        0.4129,
        0.2205,
        0.3945,
        0.2641,
        0.2804,
        0.4582,
        0.6705,
        0.4172,
        0.8671,
        0.516,
        0.3516,
        0.8399,
        0.7881,
        0.4862,
        0.7486,
        0.0542,
        0.3713,
        0.7461,
      ],
      yaxis: 'y',
    },
  ],
  layout: {
    barmode: 'relative',
    font: {
      color: 'rgba(0,0,0,1)',
      family: '',
      size: 14.6119,
    },
    hovermode: 'closest',
    legend: {
      bgcolor: 'rgba(255,255,255,1)',
      bordercolor: 'transparent',
      borderwidth: 1.8898,
      font: {
        color: 'rgba(0,0,0,1)',
        family: '',
        size: 11.9552,
      },
    },
    paper_bgcolor: 'rgba(255,255,255,1)',
    shapes: [
      {
        line: {
          linetype: [],
          width: 0,
        },
        type: 'rect',
        x0: 0,
        x1: 1,
        xref: 'paper',
        y0: 0,
        y1: 1,
        yref: 'paper',
      },
    ],
    showlegend: false,
    title: 'A network based on MSMS signatures',
    xaxis: {
      anchor: 'y',
      automargin: true,
      autorange: false,
      categoryarray: [null],
      categoryorder: 'array',
      domain: [0, 1],
      gridwidth: 0,
      hoverformat: '.2f',
      linewidth: 0,
      range: [-0.05, 1.05],
      showgrid: false,
      showline: false,
      showticklabels: false,
      tickangle: 0,
      tickfont: {
        size: 0,
      },
      ticklen: 3.653,
      tickmode: 'array',
      ticks: '',
      ticktext: [null],
      tickwidth: 0,
      title: {
        font: {
          size: 0,
        },
        text: '',
      },
      type: 'linear',
      zeroline: false,
    },
    yaxis: {
      anchor: 'x',
      automargin: true,
      autorange: false,
      categoryarray: [null],
      categoryorder: 'array',
      domain: [0, 1],
      gridwidth: 0,
      hoverformat: '.2f',
      linewidth: 0,
      range: [-0.05, 1.05],
      showgrid: false,
      showline: false,
      showticklabels: false,
      tickangle: 0,
      tickfont: {
        size: 0,
      },
      ticklen: 3.653,
      tickmode: 'array',
      ticks: '',
      ticktext: [null],
      tickwidth: 0,
      title: {
        font: {
          size: 0,
        },
        text: '',
      },
      type: 'linear',
      zeroline: false,
    },
  },
};
export const network2 = {
  data: [
    {
      hoverinfo: 'none',
      line: {
        color: 'rgb(127,127,127)',
      },
      mode: 'lines',
      showlegend: false,
      type: 'scatter',
      x: [0.6247, 0.102],
      y: [0.0096, 0.4428],
    },
    {
      marker: {
        line: {
          width: 0.5,
          opacity: 0.1,
        },
        opacity: 0.8,
        size: 25,
        symbol: 'circle',
      },
      mode: 'markers+text',
      hovertemplate:
        '<b>sample ID: </b>%{text}' +
        '<br><b>Database spectrum ID: </b>-' +
        '<br><b>Database compound name: </b>- ' +
        '<br><b>Database SMILES: </b>-' +
        '<br><b>Database reference: </b>-' +
        '<br><b>dot product (database - sample): </b>0' +
        '<br>x : %{x} y : %{y}' +
        '<extra></extra>',
      text: ['M100.95T574.33', 'M150.06T343.91'],
      cliponaxis: false,
      type: 'scatter',
      x: [0.6247, 0.102],
      y: [0.0096, 0.4428],
    },
    {
      marker: {
        line: {
          width: 0.5,
          opacity: 0.1,
        },
        opacity: 0.8,
        size: 25,
        symbol: 'square',
      },
      mode: 'markers+text',
      hovertemplate:
        '<b>sample ID: </b>%{text}' +
        '<br><b>Database spectrum ID: </b>-' +
        '<br><b>Database compound name: </b>- ' +
        '<br><b>Database SMILES: </b>-' +
        '<br><b>Database reference: </b>-' +
        '<br><b>dot product (database - sample): </b>0' +
        '<br>x : %{x} y : %{y}' +
        '<extra></extra>',
      text: ['M100.95T574.33'],
      cliponaxis: false,
      type: 'scatter',
      x: [0.8247],
      y: [0.0764],
    },
  ],
  layout: {
    barmode: 'relative',
    showlegend: false,
    title: 'A network based on MSMS signatures',
    xaxis: {
      showgrid: false,
      showline: false,
      showticklabels: false,
      zeroline: false,
    },
    yaxis: {
      showgrid: false,
      showline: false,
      showticklabels: false,
      zeroline: false,
    },
  },
};
